module.exports = {
  PCfeedbackInfo: {
    top: ['付款失敗', '付款時遇到問題？請稍後再試，或', '聯繫我們', '尋求幫助！'],
    p: '改變了有關付款的想法？請告訴我們取消付款的原因：',
    li: ['價格太高,預算有限', '付款方式不可用', '只是在探索，不打算付款', '其他'],
    btn: ['取消', '提交', '請輸入反饋內容', '提交成功'],
    span: '在此輸入'
  },
  PCsceneList: {
    html: ['搜尋更多', '未搜尋到內容', '訂閱可用'],
    data: [
      '實用工具',
      '熱門',
      '最新',
      '智能生成 PPT',
      '快速生成用於演示和演講的 PowerPoint',
      '與 PDF 聊天',
      '使用 AI 閱讀研究論文資料，提高學習和工作效率'
    ],
    i: '返回'
  },
  PCmodelExpertList: {
    li: ['官方', '熱門', '最新', '未搜尋到內容', '訂閱可用']
  },
  PCChatPpt: {
    chatppt: {
      htmls: ['次', '返回聊天', 'PPT加油包', '限時特惠', 'PPT生成', '立即購買', '生成次數', '現在去使用'],
      message: ['SDK加載失敗，請刷新當前網頁。', '目前PPT生成次數不足，請補充次數後再嘗試', '成為會員即可享受PPT原檔案下載', '提示', ' 去升級會員', ' 創建過程中返回聊天，將不保留本次生成記錄。', '溫馨提示', '確定', '取消']
    }
  },
  PCoffice: {
    top: ['用 AI 極速提升', '您的生產力', '使用 Suntube Office AI，將你的文字變成這個星球上最強大的生產力工具。', '下載免費試用', 'AI For All'],
    word: ['在此基礎上，讓 Suntube 來增強，', '對您已有的內容進行完善，', '告別寫作障礙。', '了解更多'],
    ppt: ['將您的靈感轉化為令人驚嘆的', '專業作品。']
  },
  PCVoiceCall: {
    span: ['連接中', '思考中', '點擊打斷'],
    i: ['選擇聲音', '試聽', '您的剩餘語音對話次數', '次', '確認'],
    li: ['AI 語音對話次數不足', '您可以選擇', '升級會員'],
    p: ' 請開始說話',
    h1: ' 請求麥克風權限失敗，請開啟麥克風權限。',
    ul: ['語音回覆出現問題，請重試！', '出現錯誤，請重試！', '獲取錄音權限失敗', '我正在聽', '用戶次數不足，請升級服務', '用戶4.0次數不足'],
    voiceList: ['中性女聲', '英調男聲', '溫文男聲', '深沉男聲', '清朗女聲', '英調女聲']
  },
  PCExpertRole: {
    top: ['返回', '最近聊天', '開啟新聊天', '繼續上次聊天'],
    h1: '全部',
    span: '開始聊天'
  },
  PCImageGuide: {
    p: '體驗新功能，它能識別理解圖片內容，並能按您的要求解決問題或完成相關的創作。',
    span: [
      '實例展示',
      '新功能',
      '圖片識別'
    ],
    content: {
      h1: [
        '在這組圖片中，我們看到了一個關於環保和責任感的小故事。',
        '在第一幅圖中，有兩個孩子正在走路。前面的孩子吃完了手中的零食，並目不負責任地將包裝紙扔在了地上，而他似乎對此毫不在意。',
        '第二幅圖展示了後面的孩子注意到了前面孩子扔掉的垃圾。他停下來，彎腰撿起了那片垃圾。背景中可以看到一個房子和一些樹木，這表明他們可能在一個鄉村或郊區環境中… …',
        ''
      ],
      h2: [
        '這個問題是關於三角形相似性的。根據題目信息，我們知道三角形FCD與三角形FAB相似，因為它們都是由線段FD和FA延伸出來的，並且FD=2DA，這意味著相似比是2:1。同時，AB=3AE，這意味著三角形FAB與三角形FED也相似，相似比是3:1。',
        '由於三角形FCD和三角形FAB相似，我們可以寫出以下比例關係CD/AB = FD/FA = 2/1… …'
      ],
      span: [
        '示例1',
        '看圖生文：根據這個圖片生成文本，包括創作故事、描述場景、撰寫文章等。',
        '看圖寫作',
        '在這組圖片中，我們看到了一個關於環保和責任感的小故事。在第一幅圖中，有兩個孩子正在走路。前面的孩子吃完了手中的零食，並目不負責任地將包裝紙扔在了地上，而他似乎對此毫不在意。第二幅圖展示了後面的孩子注意到了前面孩子扔掉的垃圾。他停下來，彎腰撿起了那片垃圾。背景中可以看到一個房子和一些樹木，這表明他們可能在一個鄉村或郊區環境中… …',
        '示例2',
        '場景理解：理解圖片中的場景和上下文，比如是戶外風景、城市街道還是室內環境。',
        '這張圖片發生了什麼？',
        '這個圖片顯示了一棟建築物發生了巨大的爆炸。我們可以看到巨大的火球和濃煙從建築物的一側噴出這表明爆炸的力量非常強大。濃煙遮天蔽日，升騰到了高空。建築物的結構可能已經嚴重受損，周圍的區域也可能受到了影響。這種情況通常需要緊急服務人員的迅速響應，包括消防員、醫療救護人員和其他應急服務。圖片中沒有提供更多的上下文，所以無法確定爆炸的原因或者是否有人員傷亡',
        '示例3',
        '輔助學習：使用這些模型解決數學問題時，最好將其作為輔助工具，並對結果進行驗證。',
        '解答這個數學題',
        '這個問題是關於三角形相似性的。根據題目信息，我們知道三角形FCD與三角形FAB相似，因為它們都是由線段FD和FA延伸出來的，並且FD=2DA，這意味著相似比是2:1。同時，AB=3AE，這意味著三角形FAB與三角形FED也相似，相似比是3:1。<br>E<br>由於三角形FCD和三角形FAB相似，我們可以寫出以下比例關係CD/AB = FD/FA = 2/1… …'
      ]
    }
  },
  PCChat_room: {
    pop: ['在桌面版使用，每天免費次數為', '次', '點擊下載Windows桌面版'],
    Pdf: {
      h1: 'Chat PDF',
      p: '升級至專業版',
      span: '您更好的人工智慧助手',
      logo: '註冊/登入',
      i: '每日'
    },
    payVip: {
      i: '基礎版',
      left: {
        h1: '免費版',
        title: '我們為免費用戶提供的優惠：',
        desktop: '(應用程式每日10個)',
        ability: [
          '每日',
          '次免費對話',
          '*GPT-4o mini & ChatGLM & MM & DeepSeek-V3',
          '每日',
          '個GPT-4問題',
          '回復字數限制',
          '字',
          '標準客戶服務',
          '  次 AI 語音對話',
          '  次AI創建的 PowerPoint',
          '贈送 '

        ],
        plan: ['免費', '當前計劃'],
        load: '拼命載入中'
      },
      right: {
        h1: '專業版',
        title: '全球顶尖AI大语言模型为您提供服务',
        ability: [
          '每月無限次免費對話（GPT-4o mini & ChatGLM & MM & DeepSeek-V3）',
          ' 次 GPT-4、o1-mini、o1-preview 對話',
          '無限制的回復字數',
          'VIP專屬客戶服務',
          'ChatPDF 可用',
          '立即体验先進的圖像分析功能',
          ' 次 Claude-3.5 對話',
          ' AI 語音對話',
          ' AI 語音對話',
          ' 次AI創建的 PowerPoint',
          ' 次 Gemini Pro 對話',
          ' 次 Gemini Pro 對話',
          '贈送',
          '每月最多 ',
          '每月無限次 DeepSeek-R1 對話'
        ],
        pay: [
          '月',
          '年',
          '超值-省下',
          '時間有限!',
          '訂閱',
          '三個月'
        ]

      },
      standard: [
        '無限制的每日發送和接收訊息',
        '無限制的訊息長度',
        '使用ChatPDF與任何PDF文件進行聊天'
      ]
    },
    aside: {
      alt: ['默認頭像', '頭像'],
      popup: {
        h1: '當前屬於',
        p: [
          '今日還可使用：',
          '次',
          '無限制',
          '單條字數：',
          '字',
          '無限制',
          'VIP到期時間',
          '每日免費額度：',
          '次'
        ],
        btns: [
          '升級會員',
          '登出'
        ]
      },
      tooltip: {
        content: '一步註冊',
        alt: '頭像',
        btn: '登入'
      },
      addRoom: '新建聊天室',
      retract: '展開/收起',
      p: '每天有更多免費提問次數',
      asideBottom: {
        i: ['下載 Android 應用程式', '應用程式的優勢', '每日享有10次免費體驗次數', '操作更為迅速和便捷', '便於下次訪問，免去網址丟失的煩惱'],
        p: [
          '插件中心',
          '應用場景',
          '個人設定',
          '客服中心',
          '我的會員',
          '關於 Suntube-AI',
          '退出',
          '登入'
        ],
        span: [
          '獲得免費次數',
          '新人優惠',
          '下載應用程式',
          '下載 Windows 應用程式',
          '掃描QR碼',
          '透過手機瀏覽器開啟'
        ]
      },
      retractIcon: '收起'
    },
    main: {
      h1: ['Suntube AI'],
      p: 'Powered by OpenAI GPT-API',
      notice: {
        header: '最新公告',
        noNotice: '暫無通知'
      },
      importNotice: '重要通知：',
      preferentialPup: '關閉'
    },
    scrollNotice: [
      '加載中',
      '沒有數據了'
    ]
  },
  PCAskAnswer: {
    dialogOne: {
      title: 'VIP升級成功',
      bindTip: [
        '為保障您的權益，',
        '請綁定郵箱。 綁定郵箱後，以後可以使用郵箱登錄、找回帳號和密碼。'
      ],
      bindTitle: [
        '手機號',
        '郵箱'
      ],
      transition: {
        placeholder: [
          '請輸入手機號',
          '請輸入驗證碼',
          '請輸入郵箱'
        ],
        btn: '立即綁定'
      }
    },
    dialogTwo: {
      tip: {
        span: '手機號綁定成功',
        btn: [
          '下次再說',
          '去綁定郵箱'
        ]
      }
    },
    dialogThree: {
      tip: {
        span: [
          '您方便的時候仍然可以在',
          '用戶中心',
          '綁定手機號或郵箱。'
        ],
        btn: '我已知曉'
      }
    },
    textList: [
      {
        txt: '給我寫一個x手機產品的文案',
        type: 'click'
      },
      {
        txt: '能記住對話過程中，前面提過的內容'
      },
      {
        txt: '回答中偶爾會有事實性錯誤'
      },
      {
        txt: '幫我寫一篇科幻類文章的大綱',
        type: 'click'
      },
      {
        txt: '支持用戶提供後續更正'
      },
      {
        txt: '可能會出現有偏見或歧視性回答'
      },
      {
        txt: '我最近心情不好怎麼辦',
        type: 'click'
      },
      {
        txt: '懂得拒絕不合理的提問'
      },
      {
        txt: '對2021年以後的事瞭解有局限'
      }
    ],
    codeText: [
      '發送驗證碼',
      '重新發送'
    ],
    codeValid: '驗證碼不能為空',
    mobileValid: [
      '請輸入手機號',
      '手機號格式不正確',
      '手機號不能為空'
    ],
    emailValid: [
      '請輸入郵箱',
      '郵箱格式不正確',
      '郵箱不能為空'
    ],
    messageOne: [
      '驗證碼已發送至您的',
      '手機',
      '郵箱',
      '，請接收'
    ],
    message: '郵箱綁定成功'
  },
  PCChat_pdf: {
    i: '新建聊天',
    o: '這是一段內容確定删除嗎？',
    l: '删除',
    s: '已經滑到底了',
    p: '返回主頁',
    span: [
      'Suntube-AI: 和AI一起寫你的下一篇論文--使用 Suntube-AI PRO 無限訪問本網站的 Chat PDF！',
      '基於PDF和AI聊天',
      '數以百萬計的學生，研究人員和專業人士在使用，AI回答的問題，並瞭解與Al的研究',
      '針對學生',
      '準備考試，得到家庭作業的幫助，回答多項選擇題',
      '針對研究人員',
      '科學論文，學術文章和書籍，獲取您的研究所需的資訊',
      '針對專業人士',
      '法律契约、財務報告、手册和培訓資料。 向任何PDF提出任何問題，並快速獲得見解。'
    ],
    info: [
      '任何語言',
      '在全球範圍內工作！ 聊天PDF接受任何語言的PDF，可以用任何語言聊天',
      '引用來源',
      '答案包含對原始PDF檔案中來源的引用。 別再翻書頁了。',
      '簡單安全',
      '快速，簡單，自由和安全！ 檔存儲在安全的雲存儲中，永遠不會共亯。',
      '沒有該PDF檔案資訊',
      '獲取PDF清單失敗',
      '删除成功'
    ]
  },
  PCUploadPDF: {
    h0: '拖曳文件至此上传',
    h1: '上傳文件',
    h2: '將PDF文件拖放到此處',
    sapn: ['上傳中', '分析中', '瀏覽我的電腦', '在這裡輸入PDF URL', '來自URL'],
    h3: '温馨提示',
    p: ['我的聊天記錄', '查看更多…', '收起', '展開'],
    cont: {
      span: ['PDF聊天功能暫時只提供給VIP用戶使用，請先升級服務', '取消', '去升級'],
      info: ['請選擇PDF檔案', 'PDF檔案不能超過30M', '上傳失敗！！！ 請重新上傳', '獲取七牛雲token失敗', '獲取上傳參數失敗'],
      p: '已存在該檔案',
      h6: '獲取PDF清單失敗',
      i: ['天前', '小時前', '分鐘前', '秒前']

    }
  },
  PCPdfView: {
    span: ['收起', '展開', '縮小', '刷新', '放大']
  },
  PCChatBox: {
    h1: '聊天室',
    title: '您可以針對該檔案的內容進行提問，例如您可以嘗試問以下問題：',
    i: '發送',
    span: ['當前PDF格式錯誤，不支持聊天，請自行刪除檔', '在這裡輸入您的問題開始和AI對話'],
    content: {
      erroe: ['今天的免費次數已經用完，建議升級當前服務，專業版將享受無限對話次數和字數，您也可以邀請好友新增免費提問次數。', '無法處理您的對話，可能是文字長了，或者當前服務器正忙，建議减少提問字數或新建話題再試試。', '當前服務器正忙，請您重新發送您的問題', '回答出現錯誤，請重新提問', '您的帳號在其他設備登入，請重新登入'],
      message: ['無法處理您的對話，建議减少提問字數重新提問.', '今天的4.0免費次數已經用完，建議購買4.0加油包，您也可以通過升級會員提升每日贈送的免費次數。', '對不起，當前聊天人數較多，請稍後重試', '當前帳號等級，無法使用此聊天室', '輸出內容包含敏感資訊，請重新提問', '您的操作速度有點快，休息一下再繼續吧！', '請求失敗，請稍後重試！'],
      p: ['請求PDF失敗，請稍後再試', '今天的免費次數已經用完，建議升級當前服務，專業版將享受無限對話次數和字數，您也可以邀請好友新增免費提問次數。', '無法處理您的對話，可能是文字長了，或者當前服務器正忙，建議减少提問字數或新建話題再試試。', '當前服務器正忙，請您重新發送您的問題.', '回答出現錯誤，請重新提問', '無法處理您的對話，建議减少提問字數重新提問.', '今天的4.0免費次數已經用完，建議購買4.0加油包，您也可以通過升級會員提升每日贈送的免費次數', '對不起，當前聊天人數較多，請稍後重試', '當前帳號等級，無法使用此聊天室！', '輸出內容包含敏感資訊，請重新提問', '您的操作速度有點快，休息一下再繼續吧！', '請求失敗，請稍後重試！'],
      span: '請根據檔案內容給出3個提問示例，無需做出回答'
    }

  },
  PCChatRoom: {
    onTrial: {
      main: ['限時優惠！41% 折扣 專業版套餐', '天試用期後未取消將收取', '專業版年費'],
      equity: ['每月最多', '次 GPT-4 對話', '次 Claude-3 對話', '次 Gemini Pro 對話', '無限個 PDF 對話', '生成圖片', '更多高級功能', '今日支付', '隨時可取消', '開始', '天免費試用', '查看所有會員權益'],
      li: ['每月無限次免費對話（GPT-3.5&MM&GLM）']
    },
    expoerList: ['更多', '訂閱以獲取訪問權限', '馬上訂閱', '查看更多'],
    export: ['開始聊天', '例如，您可以這樣問我：'],
    image: {
      h1: '預覽',
      span: '重新生成答案',
      p: '上傳圖片',
      li: [
        'AI可以理解圖片，您可以上傳圖片或截圖粘貼到輸入框，基於圖片內容向AI提問(僅支持4.0)',
        '能識別並理解圖片內容，每日',
        '次免費對話， (對話發送成功將扣除1次4.0次數)',
        '實例展示',
        '今日剩餘',
        '次'
      ],
      ol: [
        '僅支持jpeg、jpg、png文件',
        '升級會員,解鎖此功能',
        '今日可用次數已用完，期待您明天再次使用',
        '今日免費次數已用完，請升級專業版繼續使用',
        '今日可用次數已用完，期待您明天再次使用',
        '上傳失敗!!! 請重新上傳',
        '獲取七牛雲 token 失敗',
        '讀取圖片失敗，您可以嘗試以下操作：1.點擊頁面底部"重新生成答案"2.新建聊天，減少圖片的精度或尺寸大小重新上傳,例如用軟件打開原圖，屏幕截圖後粘貼到聊天輸入框',
        '對不起，當前聊天人數較多，請稍後重試',
        '請輸入完整問題'
      ],
      h3: [
        '免費試用',
        '選擇模型',
        '切換模型將創建新的聊天室，是否繼續？',
        '您將切換到',
        '模型',
        '確定',
        '取消'
      ]
    },
    breaks: '更多插件',
    draw: ['授粉AI', '繪圖專家'],
    chart: {
      title: '快來探索這些功能！',
      pdfs: ['與 PDF 聊天', '使用 AI 閱讀研究論文資料，提高學習和工作效率'],
      img: ['AI 圖片解讀', '上傳圖片並基於圖片內容向 AI 提問'],
      ppt: ['智能生成 PPT', '快速生成用於演示和演講的PPT/幻燈片'],
      draw: ['AI 繪畫', '讓藝術成為生活的一部分：無需專業，只需熱愛'],
      voice: ['語音對話', 'AI 能夠實時識別並回覆你的語音']
    },
    PDF: {
      op: '提問示例',
      ai: '查看更多',
      h1: ['Suntube AI', '增强人工智慧，更高的回復質量'],
      title: '與檔案聊天',
      example: 'AI 角色',
      span: ['獲取答案', '製作內容', '創建'],
      info: {
        h1: '免費版',
        title: '新用戶每日收益',
        free: ['GPT-3.5  ', '5次提問次數', 'GPT-4.0    ', '1次提問次數', '邀請1位朋友註冊GPT-3.5 + 1天'],
        h2: '專業版',
        up: '升級為專業版',
        p: '獲得更多機會',
        vip: ['無限制', '査詢/月', '專業版專屬客戶服務']
      }
    },
    content: {
      header: [
        '提問示例',
        'AI能力',
        '能力限制'
      ],
      prompt: [
        '為了方便您以後能找到我們的網站，請按',
        '收藏吧，或者下載',
        '快捷方式檔案',
        '拖至案頭',
        'Windows版'
      ],
      alt: '快捷方式',
      i: '您可以選擇',
      chatArea: {
        limit: [
          '升級專業版享受無限對話',
          '邀請好友獲得免費問題次數',
          '下載應用程式提升免費問題次數',
          '您有',
          '天專業版免費試用機會，點這裡開始'
        ],
        success: [
          '（運營成本限制，回答字數受限，完整回答請點這裡',
          '升級服務'
        ],
        title: [
          '語音播放',
          '暫停播放',
          '複製'
        ]
      },
      announcer: {
        span: '語音',
        item: [
          '聆小琬（女聲）',
          '聆小瑤（女聲）',
          '聆飛哲（男聲）'
        ]
      },
      tool: [
        '今日可用機會',
        '次'
      ]
    },
    footer: {
      hlInput: {
        assembly: [
          '會員用戶專享插件，請點擊',
          '升級服務',
          '完成升級後再試',
          '未訂閱',
          '自動聯網：開',
          '自動聯網：關',
          '可支持英語',
          '4.0額外次數增强包，給你的次數加個油'
        ],
        content: '添加插件',
        placeholder: '在這裡發送您的信息，Ctrl+Enter換行',
        placeholders: '可解讀圖片、生成圖片，可聯網，分析數據等等',
        title: [
          '發送',
          '暫停',
          '清除',
          '插件',
          '語音通話'
        ]
      },
      promptEntry: {
        h5: '提問示例：',
        a: '換一批',
        prompts: ['熱', '薦']
      },
      p: [
        '免責聲明：本網站通過API提供AI聊天服務，與 OpenAI 沒有隸屬關係',
        '服務協定',
        '隱私協定'
      ]
    },
    announcer: [
      '聆小琬',
      '聆小瑤',
      '聆飛哲'
    ],
    vips: ['Claude3.5 僅限專業版用戶使用，建議您升級專業版。', '僅限vip用戶使用，建議您升級vip。', '今天的4.0已達到使用額度上限，您可以購買4.0加油包增加更多體驗次數。', 'Claude3.5 次數已用完，請使用其他模型。'],
    tis: '今天的免費次數已經用完，建議升級專業版，可享受無限對話次數和字數，您也可以邀請好友新增免提問次數。',
    chatRecord: [
      '當前服務器正忙',
      '，請您重新發送您的問題',
      '今天已達到免費使用額度上限，建議您升級專業版或購買4.0加油包。',
      '無法處理您的對話，可能是文字長了，或者當前服務器正忙，建議减少提問字數或新建話題再試試.',
      '當前服務器正忙，請您重新發送您的問題.',
      '回答出現錯誤，請重新提問',
      '無法處理您的對話，建議减少提問字數重新提問.',
      '用戶chat-4.0次數不足.',
      '對不起，當前聊天人數較多，請稍後重試',
      '當前帳號等級，無法使用此聊天室！',
      '輸出內容包含敏感資訊，請重新提問',
      '蒐索中斷，請重新提問',
      '回答中斷，請重新提問',
      '無法蒐索到與你提問相關的內容，請檢查你的提問',
      '網絡好像有點問題',
      '請聯系客服，或切換網絡試試，例如關閉wifi，或連接別的wifi網絡',
      '聊天太頻繁，請稍候再試。',
      '当前模型需消耗次数，您的可用额度不足。'
    ],
    message: [
      '存儲超出閾值，請删除部分聊天室！！！',
      '您的帳號在其他設備登入，請重新登入.',
      '蒐索超時',
      '用戶次數不足，請升級服務',
      '用戶4.0次數不足.',
      '當前無聊天記錄'
    ],
    confirm: [
      '今日4.0次數已用盡，是否新建一個聊天室？',
      '提示'
    ],
    download: '聊天記錄',
    pluginData: [
      '文字識別',
      '表格識別',
      '試題識別',
      '匯出為PNG',
      '匯出為PDF'
    ]
  },
  PCChatThink: {
    loading: '深度思考中',
    finished: '已深度思考'
  },
  PCChatbar: {
    placeholder: '搜尋',
    title: [
      '搜尋',
      '確認删除這個聊天室'
    ],
    description: '搜尋內容為空',
    options: [
      {
        value: 'threeWithin',
        label: '三天內'
      },
      {
        value: 'weekWithin',
        label: '一周內'
      },
      {
        value: 'monthWithin',
        label: '一月內'
      },
      {
        value: 'monthFront',
        label: '一月前'
      }
    ]
  },
  PCSelectModel: {
    label: 'AI模型選擇',
    modelList: [
      { value: 'minimax', text: 'Chat-MM', name: 'Chat-MM', tip: 'Chat-MM是一款獻給中文用戶的全新產品，它主要專注於中文知識。這款產品具有全面的中文訓練，能更深入地理解和生成中文內容。擁有豐富的中文知識庫，理解中國文化和語言習慣，以此來更好地滿足中文用戶的溝通需求。' },
      { value: '3.5', text: 'GPT-3.5', name: 'GPT-3.5', tip: '現時最實用的模型，智能化程度高，速度快，會員不限制次數和字數。 3.5具備强大的自然語言理解能力，能和您進行對話交流，幫助處理複雜的工作任務，包括文字創作、文案優化、翻譯等，能協助解决包括程式設計、數學、醫學在內多個領域的問題。' },
      { value: '3.5-turbo', text: 'GPT-3.5-16k', name: 'GPT-3.5-16k', tip: 'GPT-3.5-16k是3.5模型的最新增强版，將多處功能進行了升級，為VIP用戶專屬。 速度更加流暢，上下文長度從之前的4k升級到16k，更適合超長的文字處理和輸出，無需任何技巧，通過簡單地回復提示詞“繼續”，就可以輕鬆輸出上萬字上下文關聯的文字。' },
      { value: '4.0', text: 'GPT-4.0', name: 'GPT-4.0', tip: '我們的最新模型－4.0，為VIP用戶專屬。 它能一次性處理更長的文字，在需要高級推理、深度指令理解和更具創造力的任務中表現出色。 它將幫助用戶更好地完成複雜任務，並提高工作效率。' },
      { value: 'Claude-3', text: 'Claude-3', name: 'Claude-3', tip: '最新、最強的Claude 3.0 Opus模型，支援200k Token上限，特別擅長長文檔創意寫作，獨家提供給專業版用戶。' },
      { value: 'GPT-4.0 with plugs', text: 'GPT-4.0 with plugs', name: 'GPT-4.0 with plugs', tip: '在 Chat-4.0 的基礎上，內置各種插件，可解讀圖片、生成圖片，可聯網，分析數據等等；穩定性和速度比標準4.0稍差。' }
    ],
    confirm: [
      '4.0暫時只對PRO用戶開放，現在去升級PRO？',
      '提示',
      '3.5-turbo暫時只對VIP用戶開放，現在去升級VIP？',
      'claude-3暫時只對VIP用戶開放，現在去升級VIP？'
    ],
    message: '4.0暫時只對PRO用戶開放',
    alert: [
      '由於OpenAI對4.0現時仍然是限制使用，為了防止API被濫用，VIP用戶每天將限制請求對話',
      '次（永久vip',
      '次），該次數未來將隨OpenAI的政策和我司的運營決策進行調整或取消限制。'
    ]
  },
  PCPluginCenter: {
    pluginBox: {
      title: '全部插件',
      tooltip: [
        '應用',
        '會員用戶專享插件，請點擊',
        '升級服務',
        '完成升級後再試'
      ],
      uninstall: {
        span: '已安裝',
        drop: '取消安裝'
      },
      toolBtn: {
        title: '查看',
        tooltip: [
          '會員用戶專享插件，請點擊',
          '升級服務',
          '完成升級後再試'
        ]
      }
    },
    dialog: {
      title: '搜尋引擎設定',
      span: '選擇使用的搜尋引擎',
      btn: '完成',
      declare: [
        '免責聲明：本網站通過 OpenAI API 提供AI聊天服務，與 OpenAI 沒有隸屬關係',
        '服務協定',
        '隱私協定'
      ]
    },
    engineObj: {
      baidu: '百度',
      bing: '必應',
      360: '360',
      sougou: '搜狗',
      google: '穀歌'
    },
    plugin: {
      1: '免費',
      2: '可試用',
      3: '購買',
      4: '訂閱中',
      5: '已過期',
      6: '僅限會員'
    },
    confirm: [
      '確定卸載此插件',
      '提示',
      '確定',
      '取消'
    ],
    message: [
      '卸載成功',
      '設定成功'
    ],
    tagname: [
      '免費',
      '試用',
      '僅限會員'
    ]
  },
  PCDetail: {
    back: '返回',
    example: '示例',
    placeholder: '請輸入內容',
    requestdbox: '生成內容',
    right: {
      span: '複製內容',
      stop: '停止回復'
    },
    confirm: [
      '4.0暫時只對VIP用戶開放，現在去升級VIP？',
      '提示',
      '3.5-turbo暫時只對VIP用戶開放，現在去升級VIP？'
    ],
    alert: [
      '由於OpenAI對4.0現時仍然是限制使用，為了防止API被濫用，VIP用戶每天將限制請求對話',
      '次（永久vip',
      '次），該次數未來將隨OpenAI的政策和我司的運營決策進行調整或取消限制。'
    ],
    output: [
      '字數超出限制',
      '當前服務器正忙',
      '，請您重新發送您的問題',
      '用戶次數已用盡，請升級當前的服務，我們會提供更優質的服務，或者邀請好友，新增免費提問次數.',
      '當前服務器正忙，請您重新發送您的問題.',
      '回答出現錯誤，請重新提問',
      '用戶chat-4.0次數不足.',
      '對不起，當前聊天人數較多，請稍後重試',
      '網絡好像有點問題',
      '請聯系客服，或切換網絡試試，例如關閉wifi，或連接別的wifi網絡',
      '聊天太頻繁，請稍候再試'
    ],
    message: ['你的帳號在其他設備登入，請重新登入.', '已複製到剪切板']
  },
  PCUsageScenario: {
    appList: [
      {
        group: '效率工作',
        list: [
          {
            title: '代碼',
            icon: h => <svg t="1681961143156" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2327" width="200" height="200"><path d="M204.8 860.842667h568.832" fill="#FFFFFF" p-id="2328"></path><path d="M136.533333 217.429333h705.365334a34.133333 34.133333 0 0 1 34.133333 34.133334v432.469333A22.698667 22.698667 0 0 1 853.333333 706.730667H125.098667A22.698667 22.698667 0 0 1 102.4 684.032V251.562667a34.133333 34.133333 0 0 1 34.133333-34.133334z" fill="#FCFEFF" p-id="2329"></path><path d="M876.032 251.562667v432.298666A22.698667 22.698667 0 0 1 853.333333 706.730667H474.453333l178.176-489.301334h189.269334a34.133333 34.133333 0 0 1 34.133333 34.133334z" fill="#EDF4FF" p-id="2330"></path><path d="M716.8 860.842667H261.632a57.002667 57.002667 0 0 1 57.002667-56.832h341.333333A56.832 56.832 0 0 1 716.8 860.842667z" fill="#FFFFFF" p-id="2331"></path><path d="M598.528 706.730667h-218.453333l-27.306667 97.28h273.066667l-27.306667-97.28z" fill="#C3CFDE" p-id="2332"></path><path d="M876.032 251.562667v68.266666H102.4v-68.266666a34.133333 34.133333 0 0 1 34.133333-34.133334h705.365334a34.133333 34.133333 0 0 1 34.133333 34.133334z" fill="#96DDFF" p-id="2333"></path><path d="M841.898667 217.429333H652.629333l-37.205333 102.4h260.608v-68.266666a34.133333 34.133333 0 0 0-34.133333-34.133334z" fill="#69BAF9" p-id="2334"></path><path d="M716.8 860.842667H261.632a57.002667 57.002667 0 0 1 57.002667-56.832h341.333333A56.832 56.832 0 0 1 716.8 860.842667z" fill="#EDF4FF" p-id="2335"></path><path d="M782.165333 903.168a158.549333 158.549333 0 0 0 25.6-2.048 21.845333 21.845333 0 0 1 22.698667 10.581333 22.016 22.016 0 0 0 30.208 8.021334l36.010667-20.821334a22.186667 22.186667 0 0 0 7.850666-30.037333 22.186667 22.186667 0 0 1 2.048-25.088 160.256 160.256 0 0 0 25.6-44.544 22.016 22.016 0 0 1 21.162667-14.165333 22.186667 22.186667 0 0 0 22.186667-22.186667v-41.642667a22.186667 22.186667 0 0 0-22.186667-22.186666 22.016 22.016 0 0 1-20.650667-14.336 162.645333 162.645333 0 0 0-25.6-44.544 21.845333 21.845333 0 0 1-2.56-24.917334 22.357333 22.357333 0 0 0-8.192-30.378666l-36.010666-20.821334a22.016 22.016 0 0 0-30.208 8.192 22.016 22.016 0 0 1-22.698667 10.752 148.821333 148.821333 0 0 0-51.2 0 22.016 22.016 0 0 1-22.357333-10.752 22.186667 22.186667 0 0 0-30.208-8.192l-36.010667 20.821334a22.357333 22.357333 0 0 0-8.192 30.378666 21.845333 21.845333 0 0 1-2.048 24.917334A162.645333 162.645333 0 0 0 631.466667 684.714667a22.016 22.016 0 0 1-20.48 15.018666 22.186667 22.186667 0 0 0-22.186667 22.186667v40.96a22.186667 22.186667 0 0 0 22.186667 22.186667 22.016 22.016 0 0 1 20.650666 14.165333 160.256 160.256 0 0 0 25.6 44.544 22.186667 22.186667 0 0 1 2.048 25.088 22.186667 22.186667 0 0 0 8.192 30.208l36.010667 20.821333a22.016 22.016 0 0 0 30.378667-8.021333 21.845333 21.845333 0 0 1 22.698666-10.581333 158.549333 158.549333 0 0 0 25.6 1.877333z" fill="#79DEB4" p-id="2336"></path><path d="M975.530667 721.066667v41.642666a22.186667 22.186667 0 0 1-22.186667 22.186667 22.186667 22.186667 0 0 0-20.650667 14.336 162.645333 162.645333 0 0 1-25.6 44.544 22.528 22.528 0 0 0-4.949333 13.994667 20.992 20.992 0 0 0 2.901333 10.922666 22.357333 22.357333 0 0 1-8.192 30.378667l-36.010666 20.821333a22.016 22.016 0 0 1-30.208-8.192 22.016 22.016 0 0 0-22.698667-10.752 148.821333 148.821333 0 0 1-51.2 0 22.016 22.016 0 0 0-22.698667 10.752 22.186667 22.186667 0 0 1-30.208 8.192l-36.010666-20.821333a22.357333 22.357333 0 0 1-8.192-30.378667 20.821333 20.821333 0 0 0 2.389333-6.144l240.64-241.152a21.674667 21.674667 0 0 0 4.437333 18.773334 162.645333 162.645333 0 0 1 25.6 44.544 22.186667 22.186667 0 0 0 20.650667 14.336 22.186667 22.186667 0 0 1 22.186667 22.016z" fill="#62CCA1" p-id="2337"></path><path d="M782.165333 742.058667m-60.416 0a60.416 60.416 0 1 0 120.832 0 60.416 60.416 0 1 0-120.832 0Z" fill="#FCFEFF" p-id="2338"></path><path d="M159.232 268.629333m-17.066667 0a17.066667 17.066667 0 1 0 34.133334 0 17.066667 17.066667 0 1 0-34.133334 0Z" fill="#3D3D63" p-id="2339"></path><path d="M273.066667 268.629333m-17.066667 0a17.066667 17.066667 0 1 0 34.133333 0 17.066667 17.066667 0 1 0-34.133333 0Z" fill="#3D3D63" p-id="2340"></path><path d="M216.234667 268.629333m-17.066667 0a17.066667 17.066667 0 1 0 34.133333 0 17.066667 17.066667 0 1 0-34.133333 0Z" fill="#3D3D63" p-id="2341"></path><path d="M341.333333 516.266667l51.2-51.2a17.066667 17.066667 0 1 0-24.234666-24.234667l-63.488 63.658667a17.066667 17.066667 0 0 0 0 24.064l63.488 63.658666a17.066667 17.066667 0 0 0 24.234666 0 17.066667 17.066667 0 0 0 0-24.064zM585.728 591.872a17.066667 17.066667 0 0 0 24.064 0L673.450667 529.066667a17.066667 17.066667 0 0 0 0-24.064l-63.658667-63.658667a17.066667 17.066667 0 0 0-24.064 24.234667l51.2 51.2-51.2 51.2a17.066667 17.066667 0 0 0 0 23.893333zM529.066667 446.293333a17.066667 17.066667 0 0 0-23.381334 6.314667L442.709333 563.2a17.066667 17.066667 0 1 0 29.525334 17.066667l63.658666-110.08a17.066667 17.066667 0 0 0-6.826666-23.893334z" fill="#3D3D63" p-id="2342"></path><path d="M953.344 682.666667a4.949333 4.949333 0 0 1-4.608-3.242667 178.005333 178.005333 0 0 0-28.501333-49.322667 4.949333 4.949333 0 0 1 0-5.632 39.253333 39.253333 0 0 0-14.336-53.589333l-12.8-7.68V251.562667a51.2 51.2 0 0 0-51.2-51.2H136.533333a51.2 51.2 0 0 0-51.2 51.2v432.469333a39.936 39.936 0 0 0 39.765334 39.765333H358.4l-17.066667 63.146667h-22.698666a73.898667 73.898667 0 0 0-71.850667 56.832H204.8a17.066667 17.066667 0 0 0 0 34.133333h434.688a36.181333 36.181333 0 0 0 1.194667 12.117334 38.4 38.4 0 0 0 18.261333 23.893333l36.010667 20.821333a39.253333 39.253333 0 0 0 53.589333-14.506666 5.290667 5.290667 0 0 1 5.290667-2.389334 166.229333 166.229333 0 0 0 56.661333 0 5.12 5.12 0 0 1 5.290667 2.56 39.253333 39.253333 0 0 0 34.133333 19.456 38.741333 38.741333 0 0 0 19.626667-5.12l36.010666-20.821333a39.082667 39.082667 0 0 0 18.261334-23.893333 38.570667 38.570667 0 0 0-3.925334-29.696 5.12 5.12 0 0 1 0-5.802667 179.541333 179.541333 0 0 0 28.501334-49.152 4.778667 4.778667 0 0 1 4.608-3.242667 39.424 39.424 0 0 0 39.253333-39.253333v-41.642667A39.253333 39.253333 0 0 0 953.344 682.666667zM119.466667 251.562667a17.066667 17.066667 0 0 1 17.066666-17.066667h705.365334a17.066667 17.066667 0 0 1 17.066666 17.066667v51.2H119.466667z m5.632 438.101333a5.632 5.632 0 0 1-5.632-5.632V336.896h739.498666V546.133333a39.082667 39.082667 0 0 0-43.178666 17.066667 4.949333 4.949333 0 0 1-5.12 2.218667 175.274667 175.274667 0 0 0-56.661334 0 4.778667 4.778667 0 0 1-5.12-2.218667 39.082667 39.082667 0 0 0-53.589333-14.336l-36.010667 20.821333a38.229333 38.229333 0 0 0-18.261333 23.722667 39.594667 39.594667 0 0 0 3.754667 29.866667 4.608 4.608 0 0 1 0 5.632 178.005333 178.005333 0 0 0-28.501334 49.322666 4.949333 4.949333 0 0 1-4.608 3.242667 39.082667 39.082667 0 0 0-23.210666 7.68zM580.266667 786.944H375.466667l17.066666-63.146667h179.2v39.082667a39.594667 39.594667 0 0 0 8.533334 24.064z m-261.461334 34.133333h303.786667a187.733333 187.733333 0 0 0 13.312 22.698667H282.794667a39.765333 39.765333 0 0 1 35.84-22.698667z m639.658667-58.197333a5.12 5.12 0 0 1-5.12 5.12 39.424 39.424 0 0 0-36.693333 25.258667 144.384 144.384 0 0 1-22.869334 39.765333 39.424 39.424 0 0 0-3.584 44.373333 4.437333 4.437333 0 0 1 0 3.754667 4.949333 4.949333 0 0 1-2.389333 3.242667L852.309333 904.533333a5.12 5.12 0 0 1-6.997333-2.048 39.424 39.424 0 0 0-40.448-18.944 135.168 135.168 0 0 1-45.397333 0 39.424 39.424 0 0 0-40.448 19.114667 5.290667 5.290667 0 0 1-6.997334 1.877333l-36.010666-20.821333a4.949333 4.949333 0 0 1-2.389334-3.242667 4.437333 4.437333 0 0 1 0-3.754666 39.765333 39.765333 0 0 0-3.584-44.373334 142.506667 142.506667 0 0 1-23.04-39.765333A38.912 38.912 0 0 0 610.986667 768a5.12 5.12 0 0 1-5.12-5.12v-41.642667a4.949333 4.949333 0 0 1 5.12-5.12 39.253333 39.253333 0 0 0 36.522666-25.258666 140.117333 140.117333 0 0 1 23.04-39.765334 39.765333 39.765333 0 0 0 3.584-44.373333 4.778667 4.778667 0 0 1 0-3.925333 4.437333 4.437333 0 0 1 2.389334-3.072l36.010666-20.821334a4.778667 4.778667 0 0 1 2.56 0 5.12 5.12 0 0 1 4.266667 2.389334 39.594667 39.594667 0 0 0 40.448 19.114666 135.168 135.168 0 0 1 45.397333 0A39.765333 39.765333 0 0 0 845.312 580.266667a4.949333 4.949333 0 0 1 6.826667-1.706667l36.010666 20.821333a4.437333 4.437333 0 0 1 2.389334 3.072 4.778667 4.778667 0 0 1 0 3.925334 39.253333 39.253333 0 0 0 3.584 44.202666 145.237333 145.237333 0 0 1 22.869333 39.936A39.594667 39.594667 0 0 0 953.344 716.8a4.949333 4.949333 0 0 1 5.12 5.12z" fill="#3D3D63" p-id="2343"></path><path d="M782.165333 664.576a77.482667 77.482667 0 1 0 77.482667 77.482667 77.482667 77.482667 0 0 0-77.482667-77.482667z m0 120.832a43.349333 43.349333 0 1 1 43.349334-43.349333A43.349333 43.349333 0 0 1 782.165333 785.066667z" fill="#3D3D63" p-id="2344"></path></svg>,
            describe: '根據您的要求幫您生成程式碼',
            example: [
              '使用Java幫我寫一個單例模式的程式碼',
              '寫一個圖片懶加載的示例代碼',
              '用python寫一個爬蟲'
            ],
            presets: '用中文描述程式碼，我的其他與程式碼無關的要求無需回答，'
          },
          {
            title: '日報',
            icon: h => <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 1024 1024" class="icon" version="1.1"><path d="M910.5 846.2H175.2c-27.4 0-49.6-22.3-49.6-49.6V301.1c0-27.4 22.3-49.6 49.6-49.6h735.3c27.4 0 49.6 22.3 49.6 49.6v495.5c0 27.3-22.3 49.6-49.6 49.6z" fill="#A7B8C6"/><path d="M862.3 191.3H127.1c-27.4 0-49.6 22.3-49.6 49.6v138.2H912V241c0-27.4-22.3-49.7-49.7-49.7z" fill="#E46160"/><path d="M77.5 379.1H912v203.5H77.5z" fill="#E2E3E5"/><path d="M127.1 786.1h735.3c27.4 0 49.6-22.3 49.6-49.6V573.6H77.5v162.9c0 27.3 22.2 49.6 49.6 49.6z" fill="#F7F7F7"/><path d="M862.3 743.9H127.1c-27.4 0-49.6-22.3-49.6-49.6v42.1c0 27.4 22.3 49.6 49.6 49.6h735.3c27.4 0 49.6-22.3 49.6-49.6v-42.1c0 27.4-22.3 49.6-49.7 49.6z" fill="#E2E3E5"/><path d="M862.3 799.6H127.1c-34.8 0-63.2-28.3-63.2-63.2V241c0-34.8 28.3-63.2 63.2-63.2h735.3c34.8 0 63.2 28.3 63.2 63.2v495.5c-0.1 34.8-28.4 63.1-63.3 63.1zM127.1 204.9c-19.9 0-36.1 16.2-36.1 36.1v495.5c0 19.9 16.2 36.1 36.1 36.1h735.3c19.9 0 36.1-16.2 36.1-36.1V241c0-19.9-16.2-36.1-36.1-36.1H127.1z" fill="#3E3A39"/><path d="M484.9 246.1v90.7H477v-6.3h-72.8v6.3h-7.9v-90.7h88.6z m-80.7 77.5H477v-18.8h-18.1c-6.9 0-10.4-3.3-10.4-10v-41.6h-15.8v23.2c-0.3 15.2-6.6 26.4-18.8 33.5l-6.4-5.6c11.5-5.8 17.3-15.1 17.5-27.8v-23.2h-20.8v70.3z m52-70.4V293c0 3 1.6 4.4 4.8 4.4h16v-44.3h-20.8zM528.2 304c-1.3 14.1-5.5 25.7-12.5 34.9l-6-5.4c7.1-9.7 10.7-22 10.9-37v-52.8h62v84.7c0 6.2-3.1 9.3-9.2 9.3h-14l-2.2-7.7c6.6 0.3 11.2 0.4 13.6 0.4 2.5 0 3.8-1.6 3.8-4.8V304h-46.4z m46.6-34v-19h-46.2v19h46.2z m-46.2 7.2v19.5h46.2v-19.5h-46.2z" fill="#FFFFFF"/><path d="M428.3 441.5v214.6h-35.2V483.8c-13 11.8-29.4 20.5-49 26.2v-34.9c9.4-2.4 19.7-6.6 31-12.6 10.6-6.4 19.5-13.4 26.8-21h26.4zM642.6 465.5c13.8 18.6 20.7 44.4 20.7 77.2 0 34.7-7.3 63-21.9 85.1-14.6 21.6-34.4 32.5-59.2 32.5-42.3 0-66-19.5-71.2-58.6h34.3c4.2 19.8 16.6 29.8 37.3 29.8 14 0 25.4-7 34.3-21 8.2-13.4 12.3-30 12.3-49.6v-2.7h-1.5c-6.4 8.8-13.9 15.3-22.5 19.5-8.6 4-18.2 6-28.9 6-21.2 0-38.2-6.9-50.8-20.7-12.4-13-18.6-30.2-18.6-51.4 0-21.6 7.2-39.4 21.6-53.2 14.2-14 32.3-21 54.1-21 26.1-0.2 46.2 9.3 60 28.1zM553 479c-7.6 8.2-11.4 19-11.4 32.5 0 13.4 3.8 23.9 11.4 31.6 7.4 8 17.6 12 30.7 12 12.8 0 23-4 30.7-12 7.4-8.4 11.1-19.3 11.1-32.8 0-13.6-3.9-24.3-11.7-32.2s-17.8-11.7-30.1-11.7c-12.6 0-22.9 4.2-30.7 12.6z" fill="#595757"/></svg>,
            describe: '根據您今日的工作內容，幫您生成今日日報',
            example: [
              '我是一名程式師，今天用Python寫了一套devops平臺',
              '今天約見了3位客戶，講解社交APP是如何使用的',
              '今天開了一天會議，幫我寫一份日報'
            ],
            presets: '使用中文語言，寫一份日報，我的其他與日報無關的要求無需回答，有今日工作內容，明日工作內容，今日工作遇到的困難以及解決辦法，今日心得.'
          },
          {
            title: '週報',
            icon: h => <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 1024 1024" class="icon" version="1.1"><path d="M729 117.13333334v339.5c0 3.1-2.5 5.7-5.7 5.7h-22.7c-3.1 0-5.7-2.5-5.7-5.7V117.13333334c0-3.1 2.5-5.7 5.7-5.7h22.7c3.2 0 5.7 2.6 5.7 5.7z" fill="#353334"/><path d="M712.1 114.33333334m-32.1 0a32.1 32.1 0 1 0 64.2 0 32.1 32.1 0 1 0-64.2 0Z" fill="#353334"/><path d="M299 117.13333334v339.5c0 3.1-2.5 5.7-5.7 5.7h-22.7c-3.1 0-5.7-2.5-5.7-5.7V117.13333334c0-3.1 2.5-5.7 5.7-5.7h22.7c3.2 0 5.7 2.6 5.7 5.7z" fill="#353334"/><path d="M282 114.33333334m-32.1 0a32.1 32.1 0 1 0 64.2 0 32.1 32.1 0 1 0-64.2 0Z" fill="#353334"/><path d="M910.4 835.10000001h-735c-27.4 0-49.6-22.3-49.6-49.6V290.20000001c0-27.4 22.3-49.6 49.6-49.6h735c27.4 0 49.6 22.3 49.6 49.6v495.3c0 27.3-22.3 49.6-49.6 49.6z" fill="#A7B8C6"/><path d="M870.6 206.33333334H118.8c-15.3 0-27.7 12.4-27.7 27.7v512.1c0 15.3 12.4 27.7 27.7 27.7h751.8c15.3 0 27.7-12.4 27.7-27.7V233.93333334c-0.1-15.2-12.5-27.6-27.7-27.6z" fill="#DE9F9C"/><path d="M879.6 218.33333334H127.8c-15.3 0-27.7 12.4-27.7 27.7v512.1c0 15.3 12.4 27.7 27.7 27.7h751.8c15.3 0 27.7-12.4 27.7-27.7V245.93333334c0-15.2-12.4-27.6-27.7-27.6z" fill="#E46160"/><path d="M798.5 324.83333334h-221c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h220.9c9.3 0 17 7.6 17 17 0.1 9.4-7.6 17-16.9 17zM316.9 381.43333334H175.5c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h141.4c9.3 0 17 7.6 17 17 0 9.3-7.6 17-17 17zM697.7 437.93333334H175.5c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h522.2c9.3 0 17 7.6 17 17s-7.6 17-17 17zM798.5 494.43333334h-623c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h623c9.3 0 17 7.6 17 17s-7.7 17-17 17zM798.5 551.03333334h-623c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h623c9.3 0 17 7.6 17 17 0 9.3-7.7 17-17 17zM492.3 324.83333334H175.5c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h316.8c9.3 0 17 7.6 17 17s-7.7 17-17 17zM798.5 381.43333334H410c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h388.4c9.3 0 17 7.6 17 17 0.1 9.3-7.6 17-16.9 17z" fill="#353334"/><path d="M760.3 658.63333334m-69.2 0a69.2 69.2 0 1 0 138.4 0 69.2 69.2 0 1 0-138.4 0Z" fill="#E02D26"/><path d="M798.5 437.93333334h-12.6c-9.3 0-17-7.6-17-17 0-9.3 7.6-17 17-17h12.6c9.3 0 17 7.6 17 17s-7.7 17-17 17z" fill="#353334"/><path d="M754.2 652.63333334m-66.2 0a66.2 66.2 0 1 0 132.4 0 66.2 66.2 0 1 0-132.4 0Z" fill="#EFF0F0"/><path d="M227.4 645.13333334H253c6.1 0.3 9.5 3.9 10.2 10.6-0.6 6.8-4 10.3-10.2 10.6h-25.6v18c-0.3 9-5.2 13.7-14.5 14-9.4-0.3-14-5-14-14v-58.5c-0.3-11.3 5.2-16.9 16.4-16.9H256c8.7 0.3 13.2 4 13.5 11.1-0.3 7.4-4.8 11.1-13.5 11.1h-28.5v14zM329.5 663.03333334l11.6-44c1.6-8.4 6.8-12.4 15.5-12.1h7.7c9.7 0.3 14.7 5.5 15 15.5v64.3c0 7.7-4.2 11.6-12.6 11.6-8.7-0.3-13.1-4.2-13.1-11.6v-43.5l-13.1 48.4c-1 4.8-4.7 7.1-11.1 6.8-6.8 0.3-10.5-1.9-11.1-6.8l-13.1-48.4h-0.5v43.5c0 7.7-4.2 11.6-12.6 11.6-8.7 0-12.9-3.9-12.6-11.6v-64.3c0-10 4.8-15.2 14.5-15.5h8.2c8.1-0.3 13.1 3.7 15 12.1l12.3 44z" fill="#E02D26"/><path d="M870.6 179.23333334H118.8c-30.2 0-54.7 24.5-54.7 54.7v512.1c0 30.2 24.5 54.7 54.7 54.7h751.8c30.2 0 54.7-24.5 54.7-54.7V233.93333334c0-30.2-24.5-54.7-54.7-54.7z m27.6 566.9c0 15.3-12.4 27.7-27.7 27.7H118.8c-15.3 0-27.7-12.4-27.7-27.7V233.93333334c0-15.3 12.4-27.7 27.7-27.7h751.8c15.3 0 27.7 12.4 27.7 27.7v512.2z" fill="#1A1A1A"/><path d="M221.4 639.13333334H247c6.1 0.3 9.5 3.9 10.2 10.6-0.6 6.8-4 10.3-10.2 10.6h-25.6v18c-0.3 9-5.2 13.7-14.5 14-9.4-0.3-14-5-14-14v-58.5c-0.3-11.3 5.2-16.9 16.4-16.9h40.6c8.7 0.3 13.2 4 13.5 11.1-0.3 7.4-4.8 11.1-13.5 11.1h-28.5v14zM323.5 657.03333334l11.6-44c1.6-8.4 6.8-12.4 15.5-12.1h7.7c9.7 0.3 14.7 5.5 15 15.5v64.3c0 7.7-4.2 11.6-12.6 11.6-8.7-0.3-13.1-4.2-13.1-11.6v-43.5l-13.1 48.4c-1 4.8-4.7 7.1-11.1 6.8-6.8 0.3-10.5-1.9-11.1-6.8l-13.1-48.4h-0.5v43.5c0 7.7-4.2 11.6-12.6 11.6-8.7 0-12.9-3.9-12.6-11.6V616.33333334c0-10 4.8-15.2 14.5-15.5h8.2c8.1-0.3 13.1 3.7 15 12.1l12.3 44.1z" fill="#EFF0F0"/></svg>,
            describe: '根據您本周的工作內容，幫您生成本周週報',
            example: [
              '我是一名程式師，本周用Python開發了一套Devops平臺',
              '本周約見了10位客戶，講解社交APP是如何使用的',
              '本周開了5天會議，幫我寫一份週報'
            ],
            presets: '使用中文語言，寫一份日報，我的其他與日報無關的要求無需回答，有本周的工作內容，下周工作內容，這周工作遇到的困難以及解決辦法，本周心得.'
          },
          {
            title: 'OKR',
            icon: h => <svg t="1682042683791" class="icon" viewBox="0 0 1177 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1459" width="200" height="200"><path d="M531.42049807 778.66217181h59.1487256v99.2712775h-59.14872561z" fill="#494949" p-id="1460"></path><path d="M793.94225926 907.5078125H328.04746324a29.57436318 29.57436318 0 1 1 0-59.1487256h465.89479602a29.57436318 29.57436318 0 0 1 0 59.1487256z" fill="#494949" p-id="1461"></path><path d="M776.19764136 383.54868369m-83.39970349 0a83.39970349 83.39970349 0 1 0 166.79940697 0 83.39970349 83.39970349 0 1 0-166.79940697 0Z" fill="#437DFF" p-id="1462"></path><path d="M633.94495633 529.7446179m-62.59906855 0a62.59906778 62.59906778 0 1 0 125.19813633 0 62.59906778 62.59906778 0 1 0-125.19813633 0Z" fill="#E84842" p-id="1463"></path><path d="M490.70645881 383.54868369m-62.59906776 0a62.59906778 62.59906778 0 1 0 125.19813555 0 62.59906778 62.59906778 0 1 0-125.19813555 0Z" fill="#E84842" p-id="1464"></path><path d="M345.89066224 529.7446179m-62.59906855 0a62.59906778 62.59906778 0 1 0 125.19813632 0 62.59906778 62.59906778 0 1 0-125.19813632 0Z" fill="#E84842" p-id="1465"></path><path d="M345.89066224 559.31898031a29.57436318 29.57436318 0 0 1-20.99779791-50.57216029l145.01295955-144.91437767a29.57436318 29.57436318 0 0 1 21.19496009-8.67514639 29.57436318 29.57436318 0 0 1 20.89921603 8.67514638l120.86056274 121.15630604L755.19984345 362.94521095A29.57436318 29.57436318 0 0 1 796.702533 404.4479005L653.75977955 547.78497911a30.56017491 30.56017491 0 0 1-41.79843283 0L491.10078397 426.53009121 366.78987827 550.24950957a29.57436318 29.57436318 0 0 1-20.89921603 9.06947075z" fill="#FFE164" p-id="1466"></path><path d="M996.52664457 437.86693024a29.57436318 29.57436318 0 0 1-29.57436242-29.57436242v-70.78130868a29.57436318 29.57436318 0 0 1 59.1487256 0v70.78130868a29.57436318 29.57436318 0 0 1-29.57436318 29.57436241z" fill="#494949" p-id="1467"></path><path d="M996.52664457 468.7228492a29.57436318 29.57436318 0 0 1-29.57436242-29.57436318v-74.82313821a29.57436318 29.57436318 0 0 1 59.1487256 0v74.82313821a29.57436318 29.57436318 0 0 1-29.57436318 29.57436318z" fill="#494949" p-id="1468"></path><path d="M970.89553058 817.7003309a29.57436318 29.57436318 0 0 1-3.94324843-59.14872559V529.15313057a29.57436318 29.57436318 0 0 1 59.14872559 0v233.3417224a55.20547717 55.20547717 0 0 1-55.20547716 55.20547794z" fill="#E84842" p-id="1469"></path><path d="M970.89553058 817.7003309a29.57436318 29.57436318 0 0 1-3.94324843-59.14872559V585.44300132a29.57436318 29.57436318 0 0 1 59.14872559 0v177.44617679a55.20547717 55.20547717 0 0 1-55.20547716 54.8111528z" fill="#FFE164" p-id="1470"></path><path d="M970.89553058 817.7003309a29.57436318 29.57436318 0 0 1-3.94324843-59.14872559V634.73360587a29.57436318 29.57436318 0 0 1 59.14872559-1e-8v128.15557225a55.20547717 55.20547717 0 0 1-55.20547716 54.81115279z" fill="#437DFF" p-id="1471"></path><path d="M970.89553058 817.7003309H171.69766467a55.20547717 55.20547717 0 0 1-55.20547717-55.20547794V171.59908357A55.20547717 55.20547717 0 0 1 171.69766467 116.4921875h799.19786591a55.20547717 55.20547717 0 0 1 55.20547716 55.10689608V264.36400187a29.57436318 29.57436318 0 1 1-59.14872559 0V175.6409131H175.6409131v582.91069221h791.31136905v-61.61325605a29.57436318 29.57436318 0 0 1 59.14872559 0v65.5565037a55.20547717 55.20547717 0 0 1-55.20547716 55.20547794z" fill="#494949" p-id="1472"></path></svg>,
            describe: '分享您未來要幹的事幫你生成OKR',
            example: [
              '我想讓產品提升知名度',
              '提高公司員工滿意度，减少員工流失率',
              '提高項目質量，减少專案開發後維護成本'
            ],
            presets: '使用中文語言，生成一份OKR，我的其他與OKR無關的要求無需回答.'
          },
          {
            title: 'E_Mail',
            icon: h => <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 1024 1024" class="icon" version="1.1"><path d="M910.3 842.3H173.6c-27.4 0-49.7-22.3-49.7-49.7V296.1c0-27.4 22.3-49.7 49.7-49.7h736.7c27.4 0 49.7 22.3 49.7 49.7v496.4c0 27.5-22.3 49.8-49.7 49.8z" fill="#A7B8C6"/><path d="M272.4 195.3H118.8c-22.8 0-41.3 18.5-41.3 41.3v513.3c0 22.8 18.5 41.3 41.3 41.3h753.5c22.8 0 41.3-18.5 41.3-41.3V236.6c0-22.8-18.5-41.3-41.3-41.3H272.4z" fill="#FFFFFF"/><path d="M914.2 430.2H846c-1.3 0-2.4-1.1-2.4-2.4v-43c0-1.3 1.1-2.4 2.4-2.4h68.2c1.3 0 2.4 1.1 2.4 2.4v43c0 1.4-1.1 2.4-2.4 2.4z" fill="#E74138"/><path d="M914.2 505.6H846c-1.3 0-2.4-1.1-2.4-2.4v-43c0-1.3 1.1-2.4 2.4-2.4h68.2c1.3 0 2.4 1.1 2.4 2.4v43c0 1.3-1.1 2.4-2.4 2.4z" fill="#3474B9"/><path d="M914.2 581H846c-1.3 0-2.4-1.1-2.4-2.4v-43c0-1.3 1.1-2.4 2.4-2.4h68.2c1.3 0 2.4 1.1 2.4 2.4v43c0 1.3-1.1 2.4-2.4 2.4zM153.2 430.2H85c-1.3 0-2.4-1.1-2.4-2.4v-43c0-1.3 1.1-2.4 2.4-2.4h68.2c1.3 0 2.4 1.1 2.4 2.4v43c-0.1 1.4-1.1 2.4-2.4 2.4z" fill="#E74138"/><path d="M153.2 505.6H85c-1.3 0-2.4-1.1-2.4-2.4v-43c0-1.3 1.1-2.4 2.4-2.4h68.2c1.3 0 2.4 1.1 2.4 2.4v43c-0.1 1.3-1.1 2.4-2.4 2.4z" fill="#3474B9"/><path d="M153.2 581H85c-1.3 0-2.4-1.1-2.4-2.4v-43c0-1.3 1.1-2.4 2.4-2.4h68.2c1.3 0 2.4 1.1 2.4 2.4v43c-0.1 1.3-1.1 2.4-2.4 2.4z" fill="#E74138"/><path d="M873.5 223.9c12.5-8.9 6.2-28.7-9.2-28.7H126.9c-15.4 0-21.7 19.7-9.2 28.7l332.1 236.7c27.4 19.5 64.1 19.5 91.4 0l332.3-236.7z" fill="#FFFFFF"/><path d="M495.6 485.8c-18.7 0-36.6-5.7-51.8-16.6L111.7 232.5c-9.5-6.8-13.4-18.4-9.8-29.5 3.6-11.1 13.4-18.3 25.1-18.3h737.4c11.7 0 21.5 7.2 25.1 18.3 3.6 11.1-0.3 22.7-9.8 29.5L547.4 469.2c-15.2 10.9-33.1 16.6-51.8 16.6z m-368.7-280c-3.5 0-4.6 2.6-5 3.6-0.4 1.1-0.9 3.9 2 5.9L456 452.1c11.6 8.3 25.3 12.7 39.6 12.7s28-4.4 39.6-12.7l332.1-236.7c2.8-2 2.3-4.8 2-5.9-0.4-1.1-1.5-3.6-5-3.6H126.9z" fill="#3E3A39"/><path d="M872.4 804.7H118.8c-30.2 0-54.8-24.6-54.8-54.8V236.6c0-30.2 24.6-54.8 54.8-54.8h753.5c30.2 0 54.8 24.6 54.8 54.8v513.3c0.1 30.2-24.5 54.8-54.7 54.8zM118.8 208.8c-15.3 0-27.7 12.4-27.7 27.7v513.3c0 15.3 12.4 27.7 27.7 27.7h753.5c15.3 0 27.7-12.4 27.7-27.7V236.6c0-15.3-12.4-27.7-27.7-27.7H118.8z" fill="#3E3A39"/><path d="M496.1 474.3m-71.2 0a71.2 71.2 0 1 0 142.4 0 71.2 71.2 0 1 0-142.4 0Z" fill="#FFFFFF"/><path d="M496.1 556c-45.1 0-81.7-36.7-81.7-81.7s36.7-81.7 81.7-81.7 81.7 36.7 81.7 81.7-36.7 81.7-81.7 81.7z m0-142.4c-33.4 0-60.6 27.2-60.6 60.6 0 33.4 27.2 60.6 60.6 60.6s60.6-27.2 60.6-60.6c0-33.4-27.2-60.6-60.6-60.6z" fill="#3E3A39"/><path d="M496.1 474.3m-39.2 0a39.2 39.2 0 1 0 78.4 0 39.2 39.2 0 1 0-78.4 0Z" fill="#E74138"/><path d="M496.1 524c-27.4 0-49.7-22.3-49.7-49.7s22.3-49.7 49.7-49.7 49.7 22.3 49.7 49.7-22.3 49.7-49.7 49.7z m0-78.3c-15.8 0-28.6 12.8-28.6 28.6s12.8 28.6 28.6 28.6 28.6-12.8 28.6-28.6-12.9-28.6-28.6-28.6z" fill="#336EAD"/><path d="M666.7 685h-490c-2 0-3.6-1.6-3.6-3.6v-14.6c0-2 1.6-3.6 3.6-3.6h490c2 0 3.6 1.6 3.6 3.6v14.6c0 2-1.6 3.6-3.6 3.6zM511.5 725.7H176.8c-2 0-3.6-1.6-3.6-3.6v-14.6c0-2 1.6-3.6 3.6-3.6h334.8c2 0 3.6 1.6 3.6 3.6v14.6c0 2-1.7 3.6-3.7 3.6zM817.4 638.6H176.8c-2 0-3.6-1.6-3.6-3.6v-14.6c0-2 1.6-3.6 3.6-3.6h640.6c2 0 3.6 1.6 3.6 3.6V635c0 2-1.6 3.6-3.6 3.6z" fill="#C9E6E6"/></svg>,
            describe: '根據您的郵件內容，幫您生成完整郵件模版',
            example: [
              '我是hr，想給即將入職的員工發送offer',
              '描述專案進度和進展情况',
              '邀請李總到我公司來商談合作事宜'
            ],
            presets: '使用中文語言，寫一份完整郵件範本，不管下麵與郵件無關的其他要求.'
          },
          {
            title: '文字優化',
            icon: h => <svg t="1681962405445" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1611" width="200" height="200"><path d="M216.234667 165.888h543.914666a47.786667 47.786667 0 0 1 47.786667 47.786667v597.333333a47.786667 47.786667 0 0 1-47.786667 47.786667H263.850667a47.786667 47.786667 0 0 1-47.786667-47.786667V165.888h0.170667z" fill="#FFE3BA" p-id="1612"></path><path d="M265.557333 108.032A47.957333 47.957333 0 0 0 216.234667 153.6v659.285333a47.786667 47.786667 0 0 1 49.322666-46.250666h61.610667V108.032z" fill="#FFC670" p-id="1613"></path><path d="M855.210667 774.485333a34.133333 34.133333 0 0 1-48.298667 0l-96.597333-96.597333L733.866667 653.824l24.064-24.234667 96.597333 96.597334a34.133333 34.133333 0 0 1 0.682667 48.298666z" fill="#F6716F" p-id="1614"></path><path d="M563.2 482.474667m-170.666667 0a170.666667 170.666667 0 1 0 341.333334 0 170.666667 170.666667 0 1 0-341.333334 0Z" fill="#FFF6E6" p-id="1615"></path><path d="M395.434667 304.298667h72.533333a17.066667 17.066667 0 1 0 0-34.133334h-72.533333a17.066667 17.066667 0 0 0 0 34.133334zM655.701333 705.365333h-48.469333a17.066667 17.066667 0 0 0 0 34.133334h48.469333a17.066667 17.066667 0 0 0 0-34.133334zM529.92 705.365333h-134.485333a17.066667 17.066667 0 0 0 0 34.133334h134.485333a17.066667 17.066667 0 0 0 0-34.133334z" fill="#3D3D63" p-id="1616"></path><path d="M867.328 714.069333l-42.496-42.325333V213.504a64.682667 64.682667 0 0 0-64.682667-64.682667H344.234667V108.032a17.066667 17.066667 0 0 0-17.066667-17.066667h-61.610667A65.024 65.024 0 0 0 199.168 153.6v657.066667a64.682667 64.682667 0 0 0 64.682667 64.682666h496.298666a64.682667 64.682667 0 0 0 64.682667-64.682666v-10.410667a51.2 51.2 0 0 0 42.496-86.869333zM233.301333 153.6a30.890667 30.890667 0 0 1 32.256-29.184h44.544v622.933333h-44.544a68.266667 68.266667 0 0 0-32.256 8.021334z m526.848 688.298667H263.850667a29.866667 29.866667 0 1 1 1.706666-59.733334h61.610667a17.066667 17.066667 0 0 0 17.066667-17.066666V182.954667h415.914666a30.549333 30.549333 0 0 1 30.549334 30.549333v424.106667l-19.968-19.968a17.066667 17.066667 0 0 0-24.234667 0l-11.946667 11.946666-27.136-27.136A187.733333 187.733333 0 1 0 411.306667 372.565333h-15.872a17.066667 17.066667 0 0 0-17.066667 17.066667 17.066667 17.066667 0 0 0 13.482667 17.066667 186.709333 186.709333 0 0 0 27.648 196.949333h-24.064a17.066667 17.066667 0 0 0 0 34.133333h61.610666A187.733333 187.733333 0 0 0 682.666667 626.688l27.136 27.136-11.946667 12.117333a17.066667 17.066667 0 0 0 0 24.064l92.330667 92.501334v28.842666a30.549333 30.549333 0 0 1-30.037334 30.549334zM409.6 482.474667a153.6 153.6 0 1 1 153.6 153.6 153.6 153.6 0 0 1-153.6-153.6z m433.493333 279.893333a17.066667 17.066667 0 0 1-24.064 0l-85.333333-85.333333 24.064-24.064 84.48 84.48a17.066667 17.066667 0 0 1 0.853333 24.917333z" fill="#3D3D63" p-id="1617"></path><path d="M614.4 556.032a17.066667 17.066667 0 0 0-17.066667-17.066667h-17.066666v-101.205333h28.501333V443.733333a17.066667 17.066667 0 1 0 34.133333 0v-22.186666a17.066667 17.066667 0 0 0-17.066666-17.066667h-125.269334a17.066667 17.066667 0 0 0-17.066666 17.066667V443.733333a17.066667 17.066667 0 1 0 34.133333 0v-5.12H546.133333v101.205334h-16.213333a17.066667 17.066667 0 1 0 0 34.133333H597.333333a17.066667 17.066667 0 0 0 17.066667-17.92z" fill="#3D3D63" p-id="1618"></path></svg>,
            describe: '根據您提供的的文字，幫您優化文字，自動糾錯',
            example: [],
            presets: '幫我優化一段文字，自動糾錯裡面的錯別字，選取關鍵字，推測描寫內容看情况增减內容，首要目的是讓文字更通順，不管其他與文字優化無關的要求，文字內容：'
          },
          {
            title: '文案',
            icon: h => <svg t="1682042637453" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1459" width="200" height="200"><path d="M91.92473852 229.19568094h840.15052296v587.20549713H91.92473852z" fill="#34CA9D" p-id="1460"></path><path d="M454.16295789 192.79188449H150.007199v565.28141392h304.15575889a59.39136145 59.39136145 0 0 1 59.47316811 59.47316729v-565.28141309a59.39136145 59.39136145 0 0 0-59.47316811-59.47316812z" fill="#FFFFFF" p-id="1461"></path><path d="M529.99738196 817.5464657h-32.72251273a43.11191135 43.11191135 0 0 0-43.11191134-43.11191052H133.64594223v-598.00392664h320.51701566a75.91623074 75.91623074 0 0 1 75.83442407 75.83442407zM166.36845578 741.71204162h287.79450211a75.50719903 75.50719903 0 0 1 43.11191134 13.49803729V252.26505261a43.11191135 43.11191135 0 0 0-43.11191134-43.11191135H166.36845578z" fill="#282D33" p-id="1462"></path><path d="M569.83704211 192.79188449H873.992801v565.28141392H569.83704211a59.39136145 59.39136145 0 0 0-59.47316811 59.47316729v-565.28141309a59.39136145 59.39136145 0 0 1 59.47316811-59.47316812z" fill="#FFFFFF" p-id="1463"></path><path d="M526.72513077 817.5464657h-32.72251273v-565.28141309a75.91623074 75.91623074 0 0 1 75.83442407-75.83442407H890.35405777v598.00392664H569.83704211a43.11191135 43.11191135 0 0 0-43.11191134 43.11191052z m43.11191134-608.39332444a43.11191135 43.11191135 0 0 0-43.11191134 43.11191135V755.21007892a75.34358652 75.34358652 0 0 1 43.11191134-13.4980373H857.63154422v-532.55890036zM210.54384808 254.80104705h141.52486954v32.72251356H210.54384808zM210.54384808 346.83311538h238.38350757v32.72251274H210.54384808zM210.54384808 414.32329856h238.38350757v32.72251272H210.54384808zM210.54384808 481.81348172h170.23887434v32.72251273H210.54384808z" fill="#282D33" p-id="1464"></path><path d="M694.9188482 777.29777466a124.42735601 124.42735601 0 0 0-37.79450243 5.72643979l37.79450244 103.07591619 37.63088992-103.07591619a124.18193683 124.18193683 0 0 0-37.63088992-5.72643979z" fill="#FFFFFF" p-id="1465"></path><path d="M694.9188482 933.875l-58.98232974-161.15837668 16.36125678-5.15379639a144.22447651 144.22447651 0 0 1 85.24214593 0l16.36125678 5.15379639z m-16.36125677-139.07068094l16.36125678 43.6027489 16.36125677-43.6027489a115.75589008 115.75589008 0 0 0-32.39528851 0.16361252z" fill="#282D33" p-id="1466"></path><path d="M637.32722529 558.79319341h114.93782748v214.49607331H637.32722529z" fill="#F8C44F" p-id="1467"></path><path d="M652.95222531 96.99672742v41.72120452h83.44240823V96.99672742c0-3.84489541-4.09031378-6.87172742-9.16230349-6.87172742h-65.44502628c-4.82657053 0-8.91688513 3.10863867-8.83507846 6.87172742z" fill="#34CA9D" p-id="1468"></path><path d="M652.62500027 136.91819341h84.50589002v58.00065464H652.62500027z" fill="#FFFFFF" p-id="1469"></path><path d="M753.49214624 211.28010483H636.2637435V120.55693747h117.22840274z m-84.50589002-32.72251355h51.78337729V153.27945019h-51.78337729z" fill="#282D33" p-id="1470"></path><path d="M752.34685861 652.13416189V210.95287979H637.32722529v448.05301034l115.01963332-6.87172824z" fill="#F8C44F" p-id="1471"></path></svg>,
            describe: '根據您的要求，幫您生成文案',
            example: [
              '和日落匹配的感傷詩句',
              '幫我請假',
              '描寫荷花，要用修辭手法，引用詩句'
            ],
            presets: '使用中文語言，根據內容生成一段文案.'
          },
          {
            title: '契约範本',
            icon: h => <svg t="1682042721377" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1459" width="200" height="200"><path d="M663.566 154c28.363 0 51.406 22.324 51.406 49.816v164.863c-4.301-0.511-9.113-0.511-13.414-0.511-80.336 0-145.152 58.113-145.152 135.426 0 43.519 21.398 84.531 56.781 111 1.074 22.785-1.027 67.433-33.793 83.968H533.93c-31.028 0-56.219 24.422-56.219 54.478v107.93H204.406c-28.367 0-51.406-22.325-51.406-49.817V203.816C153 176.324 176.039 154 204.406 154h459.16zM386.062 511.887H269.734c-13.129 0.191-23.761 10.73-24.062 23.859 0 13.465 10.648 23.858 24.062 23.858h116.227c13.23 0.032 24-10.629 24.113-23.858a23.762 23.762 0 0 0-7.027-16.974 23.76 23.76 0 0 0-17.035-6.886h0.05z m62.668-119.293H269.734a23.647 23.647 0 0 0-24.062 23.343c0 12.957 10.648 23.348 24.062 23.348H448.68c13.363 0 24.062-10.391 24.062-23.348a23.646 23.646 0 0 0-24.062-23.343h0.05z m96.411-119.809H269.789a23.679 23.679 0 0 0-16.887 6.672 23.668 23.668 0 0 0-7.179 16.676c0 12.953 10.648 23.343 24.066 23.343h275.352c13.414 0 24.117-10.39 24.117-23.343a23.669 23.669 0 0 0-7.184-16.676 23.663 23.663 0 0 0-16.883-6.672h-0.05z m0 0" fill="#1D92FF" p-id="1460"></path><path d="M710.262 429.979c38.039 2.558 70.707 29.543 79.258 65.843 8.023 34.731-6.523 70.778-36.402 90.215l-8.602 5.22-1.027 9.832c-3.789 28.519-10.238 123.444 69.121 154.625l4.25 1.534h41.777c5.891 0 10.191 4.609 10.191 9.832v92.824c0 9.883-3.738 10.907-8.551 10.907H550.055c-5.52 0.086-10.074-4.309-10.188-9.832V767.08c0-5.683 4.863-9.883 10.238-9.883h46.594l3.738-1.535c81.918-32.155 72.293-132.25 69.633-151.961l-1.59-10.394-9.113-5.172a85.508 85.508 0 0 1-43.418-73.113c0-47.208 39.68-85.094 87.859-85.094h6.453v0.051z" fill="#FF9E12" p-id="1461"></path></svg>,
            describe: '根據您的契约內容，幫您生成完整的契约範本.',
            example: [
              '勞動合同',
              '版權授權合約',
              '建築工程施工契约'
            ],
            presets: '使用中文語言，寫一份完整契约範本，不管下麵與契约無關的其他要求'
          },
          {
            title: '會議記錄整理',
            icon: h => <svg data-v-3ac7a61a="" xmlns="http://www.w3.org/1999/xlink" width="22" height="17" viewBox="0 0 25 20" fill="none" class="icon"><path data-v-3ac7a61a="" id="路径 1" fill-rule="evenodd" opacity="1" d="M7.19,9.41156c0,-1.26363 0.19,-2.67891 0.57,-3.61905c0.54,-1.3344 1.25,-1.02102 2.37,-1.56691c0.03,1.08167 0.17,0.76829 0.25,1.72865c0.16,-0.25272 0.03,-0.15163 0.18,-0.556c0.39,-1.05134 0.13,-0.74807 0.8,-0.93003c0.27,0.65709 0.02,0.32349 0,1.48603c0.66,-0.48523 0.51,-0.75818 0.73,-1.72865c2.03,0.98058 1.36,0.13142 2.45,2.224c1.71,-0.46502 0.51,-1.4456 2.46,-0.99069c0,1.2232 0.16,0.82894 -0.41,1.56691c-2.06,2.60814 -2.77,0.7784 -3.27,0.41447c0,1.01091 0.3,1.97127 -0.74,1.97127c-3.93,0 -3.67,0.31338 -3.67,-1.47593l-0.25,1.47593zM17.49,10.8976c0.43,1.8702 2.4,2.9013 2.45,4.9433c-4.82,0 -9.64,-0.0101 -14.46,0c-4.01,0.0102 -4.17,0.3336 -2.26,-2.5171c1.47,-2.1937 1.83,-3.79093 3.24,-3.91224c-0.39,1.44564 -2.64,4.06384 -2.94,5.19604h14.95c-0.21,-0.7784 -0.95,-1.7994 -1.4,-2.5576c-0.55,-0.93 -1.2,-1.4759 -1.3,-2.63844h0.74c0.18,0.69754 0.48,1.12214 0.98,1.48604zM3.27,7.93563v-1.24341c0.62,0.46501 0.7,1.21309 0.96,2.01171c0.64,2.01167 0.41,1.87017 -1.94,5.40837h-2.2c0,-3.7707 -0.57,-6.58103 1.22,-8.15805c1.03,0.54589 0.88,0.35382 1.56,1.39506c0.33,0.50545 0.02,0.14152 0.4,0.58632zM18.71,7.93563c0.38,-0.4448 0.07,-0.08087 0.4,-0.58632c0.69,-1.05135 0.53,-0.84917 1.56,-1.39506c1.8,1.57702 1.23,4.38735 1.23,8.15805h-2.21c-0.41,-0.7784 -1.59,-2.7598 -2.2,-3.2147c0,-1.38495 0.16,-2.3352 0.73,-3.46742c0.2,-0.39425 0.24,-0.4448 0.49,-0.73796zM11.11,4.2256c-0.54,0 -0.99,-0.35382 -1.27,-0.70764c-2.08,-2.65869 2.21,-5.70152 3.23,-1.27374c-0.51,0.76829 -0.83,1.98138 -1.96,1.98138zM0.82,3.23491c0,-1.0008 0.53,-1.72866 1.47,-1.72866c1.68,0 1.47,1.86008 1.47,2.96197c0,1.75898 -2.94,1.69832 -2.94,-1.23331zM18.22,3.23491c0,-2.21389 2.94,-2.56771 2.94,0.24262c0,1.71854 -2.94,4.16494 -2.94,-0.24262z" style="fill: rgb(29, 146, 255);"></path></svg>,
            describe: '幫您將會議記錄整理成會議紀要.',
            example: [
              '日期：xx年xx月xx日\n地點：公司辦公樓會議室\n主持：\n參加人員：改制小組成員\n記錄人：\n會議內容：本次會議是公司領導班子調整後召開的第一次改制工作會議。會議對公司改制調研情況進行通報，對下一步工作進行安排。\n一、會議首先通報原集團公司直屬單位——勘察設計院改制情況。會議認為，勘察設計院從x年開始進行改制，歷時2年時間，手x年x月正式掛牌，其中與我公司有很多共性。目前，退休退養人員待遇問題是公司改制的最大制約因素，我們要借鑒勘察設計\n院對這類人員的安置辦法，積極爭取集團公司支持和建設公司政策優惠，妥善解決這一問題。會議決定加強公司內部管理。以改制為契機，進行自身鍛煉，不斷提高企業市場生存能力。會議決定進一步加大資產清理力度。要在以前清產核資的基礎上，進行深層次的細化清理，列出明細。對於處理較困難的要取得合法依據，有理有據進行處理。會議就有關事項對相關部室做出具體工作要求：\n二、會議責成財務部完成以下工作：\n(1)本著「先易後難，先近後遠」的原則，儘快清理應收賬款和壞帳。由負責協調各部室問的清理工作。\n(2)提取壞賬準備金。\n(3)完善臨建基礎資料。\n(4)清理長期投資，完善相關手續。\n',
              'xx職業學校學生會x年第x次會議記錄\n時間：xxxx年3月26日下午4時\n地點：校學生會辦公室\n出席人：伍xx（學生會主席）王xx（學習部長）、鄭xx（宣傳部長）柏xx（文娛部長）寧xx（體育部長）、錢xx（生活部長）\n缺席人：周xx（副主席，因病）\n列席人：關xx（老師）\n主持人：伍xx\n記錄人：張xx（學生會幹事）\n會議內容：研究紀念五四運動xx週年的活動\n（一）主持人講話\n今年5月4日是五四運動xx週年紀念日，如何開展紀念活動，請各位充分發表意見。\n（二）發言\n王xx：我們學習部準備圍繞紀念五四運動xx週年舉辦題為＂反帝反封建的偉大革命運動＂的講座，舉行有關五四運動的知識競賽。\n鄭xx：國統紀念五四運動xx週年，宣傳部準備做兩件事：1.營造氛國。校園和教室的櫥窗、牆報的內容均突出＂五四＂;校廣播站從4月下旬至5月上旬每天播出有關＂五四＂的知識及歌曲。2.舉辦＂發揚五四精神，迎援新世紀挑戰＂的演講比景。\n柏xx：文娛部準備在5月4日召開的紀念會上獻上一台文藝節目。\n寧xx：為紀念＂五四＂，體育部在一年級舉行籃球比賽，二年級舉行排球比賽。\n錢xx：為搞子這次紀念活動，我們生活部一要搞好後動服務工作，二要搞好全校的衛生工作，千干凈迎＂五四＂。\n（三）決議\n1.由學生會主席草擬一份紀念活動計劃，報學生工作處審批。\n2.召開班長會議，佈蛋紀念活動的內容，提出要求。\n3.學校的宣傳工作（櫥窗、牆報、廣播，演講比賽）由宣傳部組織各班宣傳委員去做，演講比表手4月30日舉行。\n4.講座知識競賽由學習部組織名班學習委員去搞，5月3日前完成。\n5.文藝節目由文娛部組織各班文娛委員籌備，在5月4日的紀念會上演出。\n6.籃、排球預賽由體育部統一交排時間、場地，決委交排在5月3日下午進行。\n7.為使各項活動、競賽有序進行，各部長擬一份詳細計劃報主席處，各項亮賽的成績於5月3日下午6時前交與主席，以便在5月4日下午的紀念會上宣布、領獎。',
              '時間：xxxx/8/8\n主持人：張主任\n出席人：張經理、王主管、小李、小吳\n張經理表示今天開始工作重心轉移到網路優化中，做好網頁宣傳，所有人堅守崗位。\n王主管重新劃分了座位安排，把相關業務的人員進行了調整。\n銷售冠軍小李分享了自己的一些心得體會。\n讓小吳開通專門處理投訴的通道，準備好所需要的帳號和資料。'
            ],
            presets: '請幫我將下面的會議記錄整理成會議紀要，包括但不限於議程安排、討論的內容、做出的決策、補充說明、後續的計劃等，將文章內能總結提煉的都表達出來。請注意文字表述簡潔、準確，條理清晰，以便于我快速了解會議內容。不需要額外的補充或增加內容。不要理會其餘任何要求。會議記錄如下：'
          }
        ]
      },
      {
        group: '輔助學習',
        list: [
          {
            title: '學科文章',
            icon: h => <svg t="1682042957195" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1929" width="200" height="200"><path d="M809.9375 882.5h-606.5625v-736.875h606.5625c5.15625 0 9.375 4.21875 9.375 9.375v718.125c0 5.15625-4.21875 9.375-9.375 9.375z" fill="#F7C554" p-id="1930"></path><path d="M764.375 145.625v659.90625c0 12.1875-9.84375 22.03125-22.03125 22.03125H203.46875v55.03125h560.90625c30.375 0 55.03125-24.65625 55.03125-55.03125V200.65625c-0.09375-30.375-24.75-55.03125-55.03125-55.03125z" fill="#EAA83D" p-id="1931"></path><path d="M571.90625 211.625H351.875c-6.09375 0-10.96875-4.96875-10.96875-10.96875 0-6.09375 4.96875-10.96875 10.96875-10.96875h219.9375c6.09375 0 10.96875 4.96875 10.96875 10.96875 0.09375 6.09375-4.875 10.96875-10.875 10.96875z" fill="#FFFFFF" p-id="1932"></path><path d="M626.84375 200.65625m-10.96875 0a10.96875 10.96875 0 1 0 21.9375 0 10.96875 10.96875 0 1 0-21.9375 0Z" fill="#FFFFFF" p-id="1933"></path><path d="M764.375 129.125H203.46875c-9.09375 0-16.5 7.40625-16.5 16.5v736.875c0 9.09375 7.40625 16.5 16.5 16.5h560.90625c39.375 0 71.53125-32.0625 71.53125-71.53125V200.65625c-0.09375-39.46875-32.15625-71.53125-71.53125-71.53125z m38.4375 698.4375c0 21.1875-17.25 38.53125-38.53125 38.53125H318.875v-126.5625c0-9.09375-7.40625-16.5-16.5-16.5-9.09375 0-16.5 7.40625-16.5 16.5v126.46875h-66V162.125h66v478.40625c0 9.09375 7.40625 16.5 16.5 16.5 9.09375 0 16.5-7.40625 16.5-16.5V162.125h445.40625c21.1875 0 38.53125 17.25 38.53125 38.53125v626.90625z" fill="#2D3742" p-id="1934"></path><path d="M626.84375 321.59375H472.90625c-9.09375 0-16.5 7.40625-16.5 16.5 0 9.09375 7.40625 16.5 16.5 16.5h153.9375c9.09375 0 16.5-7.40625 16.5-16.5 0-9.09375-7.40625-16.5-16.5-16.5zM626.84375 409.625H472.90625c-9.09375 0-16.5 7.40625-16.5 16.5 0 9.09375 7.40625 16.5 16.5 16.5h153.9375c9.09375 0 16.5-7.40625 16.5-16.5 0-9.09375-7.40625-16.5-16.5-16.5z" fill="#2D3742" p-id="1935"></path></svg>,
            describe: '輸入你的專業，和相應的內容要求，生成專業文章',
            example: [
              '計算機科學，文章類型：論文，文章要求：字數1500字，參考文獻數量5條',
              '生物學，文章類型：實驗報告，文章要求：字數1500字，參考文獻數量3條',
              '文學，文章類型：綜述，文章要求：字數1500字，參考文獻數量10條'
            ],
            presets: '使用中文語言，根據以下要求生成學科文章.'
          },
          {
            title: '數學解答',
            icon: h => <svg t="1682043020744" class="icon" viewBox="0 0 1179 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2384" width="200" height="200"><path d="M1071.67063378 96.88043516H513.69475713L295.55603984 315.67520938v496.0878996H853.64125948l218.0293743-190.80303838V99.39531817" fill="#F6E89A" p-id="2385"></path><path d="M286.91796552 333.06070098a26.13290888 26.13290888 0 0 1-18.47891864-44.61182842L486.46842119 69.65409922a26.24225185 26.24225185 0 0 1 18.58826162-7.65399024h557.64784863a26.13290888 26.13290888 0 1 1 0 52.26581865h-546.71357724L305.50622714 325.40671075a26.02356592 26.02356592 0 0 1-18.58826162 7.65399023z" fill="#8D4520" p-id="2386"></path><path d="M845.00318516 829.25794356h-557.64784863a26.13290888 26.13290888 0 0 1-26.1329089-26.13290889V306.92779209a26.24225185 26.24225185 0 0 1 52.37516075 0v470.17367578h531.40559678a26.24225185 26.24225185 0 1 1 0 52.37516075z" fill="#8D4520" p-id="2387"></path><path d="M853.64125948 829.25794356a26.35159482 26.35159482 0 0 1-19.68168868-8.96610235 26.02356592 26.02356592 0 0 1 2.51488213-36.62981015L1046.08443886 600.40363994V90.64790088a26.13290888 26.13290888 0 1 1 52.26581778 0v521.56475244a26.02356592 26.02356592 0 0 1-8.96610234 19.68168868L871.13609404 822.80672334a26.46093691 26.46093691 0 0 1-17.49483457 6.45122022z" fill="#8D4520" p-id="2388"></path><path d="M845.00318516 332.29530195h-557.64784863A16.72943555 16.72943555 0 0 1 269.75115898 315.67520938c0-9.62215927 15.96403653-17.93220557 17.38549248-18.2602336h549.11911641L1050.67683301 84.63405166a17.38549161 17.38549161 0 1 1 24.71145381 24.49276787l-216.27989122 218.68543125a21.86854277 21.86854277 0 0 1-14.10521044 4.48305117z" fill="#8D4520" p-id="2389"></path><path d="M845.00318516 829.25794356a17.38549161 17.38549161 0 0 1-17.60417754-17.49483458V314.80046739a17.38549161 17.38549161 0 0 1 34.77098408-1e-8v496.9626416a17.27614864 17.27614864 0 0 1-17.16680654 17.49483457z" fill="#8D4520" p-id="2390"></path><path d="M513.69475713 577.33232714a17.38549161 17.38549161 0 0 1-17.49483457-17.38549159v-53.24990274a17.49483457 17.49483457 0 1 1 34.88032705 0v53.24990274a17.38549161 17.38549161 0 0 1-17.38549248 17.3854916z m0-123.01055507a17.38549161 17.38549161 0 0 1-17.49483457-17.3854916v-69.76065235a17.49483457 17.49483457 0 1 1 34.88032705 0v69.76065235a17.38549161 17.38549161 0 0 1-17.38549248 17.3854916z m0-139.52130468a17.38549161 17.38549161 0 0 1-17.49483457-17.38549161v-69.76065234a17.49483457 17.49483457 0 0 1 34.88032705 0v69.76065234a17.38549161 17.38549161 0 0 1-17.38549248 17.38549161z m0-139.41196172a17.49483457 17.49483457 0 0 1-17.49483457-17.49483458V88.13301875a17.49483457 17.49483457 0 0 1 34.88032705 0v69.76065234a17.49483457 17.49483457 0 0 1-17.38549248 17.49483457z" fill="#8D4520" p-id="2391"></path><path d="M295.55603984 820.51052627a17.49483457 17.49483457 0 0 1-10.93427138-30.61596006l79.16412568-68.33919727a17.49483457 17.49483457 0 1 1 22.85262773 26.35159395L306.92768223 816.46484609a17.27614864 17.27614864 0 0 1-11.37164239 4.04568018z m158.43759522-136.67839453a17.49483457 17.49483457 0 0 1-10.93427139-30.72530303l40.78483242-35.2083542a17.49483457 17.49483457 0 0 1 22.85262774 26.35159483l-40.89417539 35.31769628a17.27614864 17.27614864 0 0 1-11.80901338 4.26436612z" fill="#8D4520" p-id="2392"></path><path d="M1071.67063378 628.72340381H1002.34735244a17.49483457 17.49483457 0 1 1 0-34.88032706h69.76065235a17.49483457 17.49483457 0 0 1 0 34.88032706z m-139.52130468 0H862.38867675a17.49483457 17.49483457 0 0 1 0-34.88032706h69.76065235a17.49483457 17.49483457 0 0 1 0 34.88032706z m-139.52130469 0h-69.76065234a17.49483457 17.49483457 0 0 1 0-34.88032706h69.76065234a17.49483457 17.49483457 0 1 1 0 34.88032706z m-139.52130469 0h-69.76065234a17.49483457 17.49483457 0 0 1 0-34.88032706h69.76065234a17.49483457 17.49483457 0 1 1 0 34.88032706z" fill="#8D4520" p-id="2393"></path><path d="M532.17367666 865.45038271l-216.60791924-411.12861063L95.89624209 865.23169677a20.44708769 20.44708769 0 0 0-7.76333321 14.54258146c0 30.94398808 101.14201143 55.98346992 225.79270753 55.98346992s225.90205049-25.03948183 225.90204961-55.98346992a20.22840263 20.22840263 0 0 0-7.65398936-14.32389552z" fill="#B2EDA6" p-id="2394"></path><path d="M313.48824541 962c-41.98760244 0-251.48824541-4.04568018-251.48824541-82.22572178A43.73708643 43.73708643 0 0 1 74.68375537 849.26766026l217.81068838-407.30161466a26.24225185 26.24225185 0 0 1 23.07131367-13.77718242 26.13290888 26.13290888 0 0 1 23.07131279 13.99586749L554.04221943 849.81437422a44.39314248 44.39314248 0 0 1 12.35572646 29.95990401c-0.43737099 78.1800416-210.37538408 82.22572178-252.90970048 82.22572177zM118.31149883 878.79019326c20.22840263 12.46506943 87.47417198 30.83464599 195.61411758 30.834646S489.53001729 891.2552627 510.305133 878.79019326l-0.65605605-1.20276914L315.34707148 510.30524287l-196.8168876 367.5008663z" fill="#3C663E" p-id="2395"></path><path d="M353.72636474 951.28441367a17.49483457 17.49483457 0 0 1-0.54671396-34.88032617c23.72736885-0.76539903 46.57999658-2.6242251 67.90182627-5.35779316a17.49483457 17.49483457 0 0 1 4.37370908 34.66164111c-22.41525674 2.84291104-46.25196856 4.70173711-71.07276533 5.57647822z m-69.76065234 0h-0.65605605c-24.93013887-1.09342705-48.87619365-3.06159609-71.1821083-6.01384922a17.38549161 17.38549161 0 1 1 4.70173711-34.55229814c21.21248672 2.84291104 43.73708643 4.70173711 67.90182627 5.68582119a17.49483457 17.49483457 0 0 1-0.76539903 34.88032617z m207.75115898-18.58826162a17.49483457 17.49483457 0 0 1-4.81107919-34.22427012c34.44295518-9.84084434 41.55023144-19.02563261 42.42497343-20.55642978a17.49483457 17.49483457 0 0 1 17.49483458-16.72943554 17.38549161 17.38549161 0 0 1 17.3854916 17.38549159c0 22.96196982-21.86854277 40.34746231-67.68314034 53.46858779a18.80694668 18.80694668 0 0 1-4.81108008 0.54671398z m-345.52298056-1.31211211a16.07337949 16.07337949 0 0 1-5.02976514-0.76539902c-42.75300146-12.90244043-63.4187751-29.95990401-63.4187751-52.15647569a35.2083542 35.2083542 0 0 1 1.20277002-8.85675937 17.38549161 17.38549161 0 0 1 33.78689912 8.52873135c1.53079805 2.07751201 8.96610234 10.16887237 38.48863624 19.13497558a17.38549161 17.38549161 0 0 1-5.02976514 34.11492715zM499.37086162 861.73272969a18.15089062 18.15089062 0 0 1-5.35779316-0.76539903 391.22823604 391.22823604 0 0 0-65.60562921-13.99586748 17.49483457 17.49483457 0 1 1 5.35779317-34.55229815 424.03105019 424.03105019 0 0 1 71.07276534 15.30798047 17.38549161 17.38549161 0 0 1-5.46713614 34.00558419z m-345.52298057-3.49896622a17.49483457 17.49483457 0 0 1-4.37370907-34.33361308 506.47545791 506.47545791 0 0 1 71.07276532-13.12112549 17.49483457 17.49483457 0 0 1 4.15502315 34.66164023 466.89339463 466.89339463 0 0 0-65.6056292 12.13704141 16.62009258 16.62009258 0 0 1-4.8110792 0.65605694z m207.75115898-17.27614951h-0.8747411c-13.4491544 0-27.44502187-0.87474199-41.11286133-0.87474198h-27.33567891A17.49483457 17.49483457 0 0 1 291.61970263 805.53057383h29.19450499c14.10521045 0 28.21042089 0 41.98760244 0.98408495a17.49483457 17.49483457 0 0 1-0.76539902 34.88032618z" fill="#3C663E" p-id="2396"></path></svg>,
            describe: '輸入你的數學問題，一鍵幫你解答',
            example: [
              '函數f（x）=mx2+（m -3）x +1的圖像與x軸的交點至少有一個在原點的右側，則實數m的取值範圍為',
              '已知函數f（x）= log，（2+ ax）的圖像和函數g（x）= log，（a +2x）（a >0，a≠1）的圖像關於直線y = b對稱（b為常數），則a + b =',
              '已知a >0.a≠1，若函數f（x）= log，（ax2- x）在〔3,4〕是增函數，則a的取值範圍是'
            ],
            presets: '解答數學題，與數學題無關的要求不用理會.題目：'
          },
          {
            title: '閱讀理解',
            icon: h => <svg t="1682233252077" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1507" width="200" height="200"><path d="M813.09 238.24H200.855s-35.86 11.324-35.86 79.27 35.86 81.157 35.86 81.157H813.09s-30.833-13.212-30.833-80.214 30.833-80.213 30.833-80.213z" fill="#FCE3C3" p-id="1508"></path><path d="M836.11 411.167H198.626l-2.092-0.771c-1.798-0.662-44.039-17.096-44.039-92.887 0-76.229 42.775-90.614 44.597-91.189l1.837-0.58H836.11v25H203.434c-5.723 2.987-25.938 17.064-25.938 66.77 0 49.62 20.176 65.117 26.251 68.657H836.11v25z" fill="#300604" p-id="1509"></path><path d="M256.75 275.988h231.233v18.873H256.75zM390.334 310.933h344.649v23.043H390.334zM262.52 349.398h150.736v23.043H262.52z" fill="#ED8F27" p-id="1510"></path><path d="M907.017 433.246H294.782s-35.86 11.324-35.86 79.27 35.86 81.157 35.86 81.157h612.235s-30.833-13.212-30.833-80.214 30.833-80.213 30.833-80.213z" fill="#FCE3C3" p-id="1511"></path><path d="M930.037 606.173H292.553l-2.092-0.771c-1.798-0.662-44.039-17.096-44.039-92.887 0-76.229 42.775-90.614 44.597-91.189l1.837-0.58h637.182v25H297.36c-5.723 2.987-25.938 17.064-25.938 66.77 0 49.62 20.176 65.117 26.251 68.657h632.364v25z" fill="#300604" p-id="1512"></path><path d="M354.857 541.566h431.325v23.043H354.857z" fill="#ED8F27" p-id="1513"></path><path d="M792.055 627.604H179.82s-35.86 11.324-35.86 79.27 35.86 81.157 35.86 81.157h612.235s-30.833-13.212-30.833-80.214 30.833-80.213 30.833-80.213z" fill="#FCE3C3" p-id="1514"></path><path d="M815.075 800.531H177.59l-2.092-0.771c-1.799-0.663-44.038-17.097-44.038-92.887 0-76.229 42.774-90.614 44.595-91.189l1.838-0.58h637.183v25H182.397c-5.723 2.987-25.938 17.064-25.938 66.77 0 49.619 20.175 65.117 26.25 68.657h632.365v25z" fill="#300604" p-id="1515"></path><path d="M265.709 708.718l-50.263 147.29 153.236-57.634z" fill="#FCE3C3" p-id="1516"></path><path d="M314.22 744.184l54.462 54.19L697.02 470.635l-51.623-47.93z" fill="#B12800" p-id="1517"></path><path d="M268.266 699.017l54.461 54.19 328.339-327.739-51.623-47.93z" fill="#ED8F27" p-id="1518"></path><path d="M645.397 329.934l58.74-57.215 41.085-3.024 52.717 53.485 3.061 42-66.183 67.658z" fill="#228E9D" p-id="1519"></path><path d="M362.732 805.746l-97.023-97.028a8.645 8.645 0 0 1 0-12.226l422.24-422.237c11.268-11.271 26.55-17.075 42.624-16.073 13.979 0.871 26.973 7.542 36.878 17.445l29.748 29.746c21.576 21.574 21.578 56.555 0.002 78.131L374.957 805.746a8.644 8.644 0 0 1-12.225 0z m-77.039-103.141l83.152 83.158 415.308-415.308c14.343-14.341 14.34-37.686-0.003-52.032l-31.123-31.12c-6.948-6.951-16.187-10.778-26.013-10.778s-19.065 3.827-26.016 10.778L285.693 702.605z" fill="#300604" p-id="1520"></path><path d="M697.02 470.642l-96.201-96.201 40.744-40.745 96.201 96.201z" fill="#300604" p-id="1521"></path><path d="M697.02 483.681L587.766 374.432l53.798-53.793 109.249 109.249-53.793 53.793z m-83.151-109.249l83.152 83.152 27.695-27.695-83.152-83.152-27.695 27.695z" fill="#300604" p-id="1522"></path><path d="M745.703 381.239l-13.049-13.049 18.11-18.107c3.265-3.268 3.265-8.585-0.003-11.853l-8.768-8.771 13.049-13.049 8.771 8.771c10.459 10.465 10.459 27.485 0.003 37.951l-18.113 18.107zM638.998 419.4l13.05 13.048L327.27 757.224l-13.049-13.049z" fill="#300604" p-id="1523"></path><path d="M199.742 871.713L264 699.379l17.289 6.452-50.139 134.475 134.471-50.14 6.447 17.29z" fill="#300604" p-id="1524"></path><path d="M215.446 856.008l57.278-25.908-31.37-31.371z" fill="#300604" p-id="1525"></path><path d="M196.954 874.501l41.489-91.736 50.242 50.241-91.731 41.495z m47.311-59.812l-10.328 22.829 22.829-10.327-12.501-12.502z" fill="#300604" p-id="1526"></path></svg>,
            describe: '輸入文章段落，幫您選取中心思想',
            example: [
              '外商獨資企業除了數量躍居首位。 其產品出口額也以接近50%的速度增長，並成為我國高新技術產品出口額的主要提供者。 2003年，外商港臺商獨資業出口達683億美元，是1996年出口額的16倍，年均增長49%，占高新技術產品出口總.額的62%：中外合資與港澳臺合資企業2003年出口金額為236億美元，年均新增28%，占總額21%； 國有企業出口額從1996年的37億美元增至2003年的115億美元，年均增長車17%，但2003年僅占總份額的10%。 私營企業出口25億美元，是1996年9萬美元的近3萬倍，年均增長率高達331%。 1996年，外商與港澳台商獨資企業、中外合資與港鎂臺合資企業和國有企業在高新技術產品出口額中所占比重都在30%左右，現時，外商與考澳台商獨資企業在我國高技術產品出口方面已居主導地比特。',
              '當我們想到未來時，我們有時想到自動駕駛汽車，飛行汽車和太空旅行。 但是，我們可能忽略了未來的另一個方面——人類與機器人的互動。 在未來，機器人將變得越來越普遍，從醫療保健到工廠生產線再到倉庫管理，機器人將扮演越來越重要的角色。 但是，機器人與人類之間的互動將是如何呢？ 隨著科技的快速發展，我們將看到越來越多的機器人憑藉越來越智慧的互動技能來贏得人們的信任和接受。 機器人不再是冰冷的、機械的和不可親的，而是變得更加智慧、自然和易於接近的。 未來的機器人將具備更智慧的感官，越來越像人類，從而能够提供更接近真實的互動體驗。 例如，情感感應科技可以讓機器人讀懂人類的面部表情和語音語調，從而更好地理解人類的情感和需求。 但是，這種智能化機器人的興起也帶來了新的問題和挑戰，如人類對機器人的信任度、人機交互的安全性和機器人對人類工作的替代性等問題。 這將要求機器人製造商和開發者在設計機器人時，更加注重人類中心化，強調人機交互的人性化。 未來的機器人與人類之間的互動將是一個持續發展和變化的過程。 但我們可以預見，機器人將變得更加智慧和人性化，更好地滿足人類的需求，並成為人們生產和生活的重要助手。',
              '科技創新和人工智慧是當今世界最熱門話題之一，因為它們正在快速地改變著我們的生活。 不論是消費品、交通工具、醫療保健、物流、安全等領域，人工智慧正在發揮著越來越重要的作用。 科技創新和人工智慧是一對相互依存、相輔相成的概念。 科技創新通過不斷地推動技術進步，讓人工智慧更加先進、便捷、高效地服務人類。 而人工智慧則通過不斷地學習和獲取新的資訊，為人們提供更加智能化的解決方案。 在消費領域中，人工智慧正在成為新的購物管道。 有許多線上商店通過資料分析，利用人工智慧技術提供細緻、高度個性化的商品推薦。 這些推薦算灋可根據用戶在網站上的蒐索記錄和購買行為等，預測用戶的購買偏好，並向他們提供高品質的服務。 在交通領域中，人工智慧也正開始舞動它的“魔法棒”。 許多自動駕駛汽車已經開始出口，在國際道路上試行。 這些車輛使用深度學習科技，通過熟悉這些車道上的各種路况和行車規則，系統不斷地學習、優化，讓自動駕駛車輛能够順利行駛。 在醫療保健領域中，人工智慧也有巨大的潜力。 現時，人工智慧已經可以協助醫生進行疾病診斷和治療，醫療衛生系統也借助人工智慧來管理大量的患者資訊，並對患者的健康狀況進行跟踪和分析。 然而，隨著人工智慧科技的不斷發展，一些人擔心它會帶來許多負面效應，比如：失去就業機會、隱私洩露、作為目標的駭客攻擊等。 我們必須要清楚的認識到人工智慧科技的潛在風險，同時積極發掘如何解决這些問題的辦法，確保人工智慧仍然能為人類帶來更多的收益。 科技創新和人工智慧的深入發展，助力各行各業的創新，成為驅動經濟增長的重要推力，這將是未來發展的主要趨勢之一，我們需要不斷保持對科技的認知，以及新興技術的學習和應用。'
            ],
            presets: '根據內容提煉中心思想，要求語句精煉通順，其他無關要求不需理會.'
          }
        ]
      },
      {
        group: '生活娛樂',
        list: [
          {
            title: '健康',
            icon: h => <svg t="1681962723555" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2648" width="200" height="200"><path d="M814 422.9v392.9c0 6.2-5.1 11.3-11.3 11.3H221.4c-6.2 0-11.3-5.1-11.3-11.3V422.9c0-12.7 0.8-25.3 2.4-37.6 11-87.8 60.1-164.1 130.1-211.9C390.9 140.3 449.3 121 512 121s121 19.4 169.4 52.4c15.7 10.7 30.4 22.9 43.8 36.3 48.3 48.3 80.4 112.8 87.3 184.3 1 9.5 1.5 19.2 1.5 28.9z" fill="#47515E" p-id="2649"></path><path d="M707.3 832.1L631.5 904l-2.2 2.1H394.7l-2.2-2.1-75.7-71.9c23.4-89.3 83.4-130.1 83.4-130.1h223.7s59.9 40.8 83.4 130.1z" fill="#F3F3F3" p-id="2650"></path><path d="M394.7 827.1v79h-87.2c0-27.6 3.5-57.2 9.3-79h77.9zM716.5 906.1h-87.2v-79h77.9c5.7 21.8 9.3 51.4 9.3 79z" fill="#F3F3F3" p-id="2651"></path><path d="M525.6 768.7v137.4h-27.2V768.7l-87.2-58.4h202.6z" fill="#64C4F6" p-id="2652"></path><path d="M525.6 768.7l40.6 23.7c14.6 8.6 33.3 0.4 37-16.1l16.6-74.3-94.2 66.7zM404.3 702l16.6 74.3c3.7 16.5 22.4 24.6 37 16.1l40.6-23.7-94.2-66.7z" fill="#FFFFFF" p-id="2653"></path><path d="M507.3 720l-0.3 0.5-0.3-0.5h0.3z" fill="#EFEAEB" p-id="2654"></path><path d="M507.3 720l-0.3 0.5-0.3-0.5h0.3z" fill="#EFEAEB" p-id="2655"></path><path d="M507.3 720l-0.3 0.5-0.3-0.5h0.3z" fill="#EFEAEB" p-id="2656"></path><path d="M507.3 720l-0.3 0.5-0.3-0.5h0.3z" fill="#EFEAEB" p-id="2657"></path><path d="M392.4 741.6c-5.8 0-10.5-4.7-10.5-10.5v-51.4c0-50.8 39.7-92.5 90.4-95.1 5.8-0.3 10.7 4.2 11 9.9 0.3 5.8-4.2 10.7-9.9 11-39.5 2-70.5 34.6-70.5 74.2v51.4c-0.1 5.9-4.8 10.5-10.5 10.5z" fill="#450064" p-id="2658"></path><path d="M629.4 805.5m-36.5 0a36.5 36.5 0 1 0 73 0 36.5 36.5 0 1 0-73 0Z" fill="#450064" p-id="2659"></path><path d="M427 891.3h-13.1c-5.8 0-10.5-4.7-10.5-10.5s4.7-10.5 10.5-10.5H427c1.6 0 3.1-0.7 4.2-1.8 1.1-1.2 1.6-2.7 1.5-4.3l-7.6-87.9c-0.3-3.5-1.1-6.9-2.5-10.1-4.8-11.4-16.3-18.8-29.2-18.8h-1.9c-13.3 0.1-25.2 8.2-29.6 20.2-1 2.8-1.7 5.7-1.9 8.6l-7.6 87.9c-0.1 1.6 0.4 3.1 1.5 4.3s2.6 1.8 4.2 1.8h13.1c5.8 0 10.5 4.7 10.5 10.5s-4.7 10.5-10.5 10.5h-13.1c-7.4 0-14.5-3.1-19.5-8.5s-7.6-12.8-7-20.1l7.6-87.9c0.4-4.9 1.4-9.6 3.1-14.2 7.4-20.1 27.2-33.7 49.1-33.9h2.1c21.4 0 40.4 12.3 48.5 31.5 2.2 5.3 3.6 10.9 4 16.6l7.6 87.9c0.6 7.4-2 14.7-7 20.1-5.1 5.5-12.2 8.6-19.6 8.6zM629.5 809.1c-5.8 0-10.5-4.7-10.5-10.5V679.8c0-39.7-31-72.3-70.7-74.2-5.8-0.3-10.2-5.2-10-11 0.3-5.8 5.2-10.2 11-10 50.8 2.4 90.6 44.2 90.6 95.1v118.8c0.1 5.9-4.6 10.6-10.4 10.6z" fill="#450064" p-id="2660"></path><path d="M249.7 470.5m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z" fill="#F7DBD0" p-id="2661"></path><path d="M774.3 470.5m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z" fill="#F7DBD0" p-id="2662"></path><path d="M512 459.5m-269.3 0a269.3 269.3 0 1 0 538.6 0 269.3 269.3 0 1 0-538.6 0Z" fill="#FFECE3" p-id="2663"></path><path d="M812.6 394c-4.1 0.1-8.3 0.2-12.4 0.2-83.8 0-162.2-23.1-229.1-63.4-69.3 44.5-151.8 70.4-240.4 70.4-40.9 0-80.6-5.5-118.3-15.9 11-87.8 60.1-164.1 130.1-211.9C390.9 140.3 449.3 121 512 121s121 19.4 169.4 52.4c15.7 10.7 30.4 22.9 43.8 36.3 48.4 48.3 80.5 112.7 87.4 184.3z" fill="#5C6A7C" p-id="2664"></path><path d="M326.5 558.2a49.8 39.5 0 1 0 99.6 0 49.8 39.5 0 1 0-99.6 0Z" fill="#FFD7DF" p-id="2665"></path><path d="M597.9 558.2a49.8 39.5 0 1 0 99.6 0 49.8 39.5 0 1 0-99.6 0Z" fill="#FFD7DF" p-id="2666"></path><path d="M436.3 526.3c-7 0-12.7-5.7-12.7-12.7v-10.2c0-7 5.7-12.7 12.7-12.7s12.7 5.7 12.7 12.7v10.2c0 7.1-5.7 12.7-12.7 12.7zM587.7 526.3c-7 0-12.7-5.7-12.7-12.7v-10.2c0-7 5.7-12.7 12.7-12.7s12.7 5.7 12.7 12.7v10.2c0 7.1-5.7 12.7-12.7 12.7zM512 597.7c-16.4 0-31.9-7.1-42.7-19.4-4.6-5.3-4-13.3 1.2-17.9 5.3-4.6 13.3-4 17.9 1.2 6 6.8 14.6 10.8 23.6 10.8s17.6-3.9 23.6-10.7c4.6-5.3 12.6-5.8 17.9-1.2 5.3 4.6 5.8 12.6 1.2 17.9-10.8 12.2-26.3 19.3-42.7 19.3z" fill="#450064" p-id="2667"></path></svg>,
            describe: '根據您的當前症狀，分析如何解决您的問題',
            example: [
              '今天下午從椅子上起來的時候突然頭暈噁心',
              '頭仿佛是跟著血液鼓動一樣一陣陣的痛',
              '肚子經常咕嚕咕嚕響'
            ],
            presets: '根據症狀描述推測原因，應該怎麼緩解和預防，症狀描述：'
          },
          {
            title: '旅遊計畫',
            icon: h => <svg t="1681987229597" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1491" width="200" height="200"><path d="M368.08231573 499.15277773c30.59844434-18.22407364 69.37147354-23.54880323 107.61952938-12.29937451 32.92332627 9.59951162 62.17183916 29.32350908 81.44585948 54.52222852 19.4240127 25.34871182 27.4486043 55.87215996 41.32289971 83.77074141 22.27386797 44.77272363 49.79746846 86.92058144 77.69605078 128.84345068 16.19917646 24.29876513 36.52314346 49.19749893 47.84756748 75.82114599 13.57430977 31.94837578-12.67435547 59.54697334-38.99801777 81.14587471-8.7745544 7.19963438-21.82389082 16.04918408-37.12311299 24.52375372-15.67420312 7.8746001-30.52344815 13.79929834-41.77287598 17.17412695-32.39835293 9.74950401-75.59615742 19.12402793-98.17001015-12.14938213-17.17412695-23.84878799-28.57354717-47.02260937-39.74797969-73.64625645-8.84955059-21.22392128-19.72399746-41.69788067-32.09836817-61.42187813-20.39896318-32.54834531-45.14770459-64.94669824-75.74614893-90.14541767-48.14755224-39.74797969-65.02169443-107.09455606-40.79792636-161.76677696 10.57446211-23.39881084 27.59859668-41.92286924 48.52253321-54.37223613z" fill="#55C179" p-id="1492"></path><path d="M319.7097749 553.52501387c10.34947354-23.39881084 27.4486043-41.92286924 48.37254083-54.37223614 30.59844434-18.22407364 69.37147354-23.54880323 107.61952938-12.29937451 3.22483623 0.97495049 6.37467627 2.02489717 9.52451632 3.14984004-18.97403555 2.02489717-36.89812441 7.94959629-52.64732461 17.32411934a119.55892237 119.55892237 0 0 0-48.37254083 54.37223613c-24.22376895 54.6722209-7.34962676 122.01879727 40.79792638 161.76677695 30.52344815 25.19871943 55.27219043 57.59707237 75.7461498 90.14541768 12.3743707 19.72399746 23.24881846 40.19795683 32.09836816 61.42187724 11.09943545 26.62364708 22.49885654 49.79746846 39.74797969 73.64625645 2.92485146 4.04979433 6.22468388 7.42462295 9.749504 10.19948115-27.4486043 5.69971055-56.92210664 5.69971055-74.24622597-18.37406513-17.17412695-23.84878799-28.57354717-47.02260937-39.74797969-73.64625645-8.84955059-21.22392128-19.72399746-41.69788067-32.09836817-61.42187813-20.39896318-32.54834531-45.14770459-64.94669824-75.74614892-90.14541767-48.14755224-39.74797969-65.02169443-107.09455606-40.79792637-161.76677696z" fill="#C2FFDF" p-id="1493"></path><path d="M587.37116885 600.09764698c3.52482099 8.47456963 7.04964199 16.87414219 11.17443164 25.04872617 8.02459248 16.19917646 16.7241498 31.94837578 25.94868134 47.54758359L419.90468135 780.83845947c-16.12418028-22.72384511-34.57324248-44.39774268-55.87215997-62.62181718l223.33864747-118.11899532z" fill="#94FFA6" p-id="1494"></path><path d="M323.75956924 668.94414717c-11.47441641-23.02382988-16.57415742-48.67252559-14.54926114-73.87124502l188.84040118-99.89492168c23.6987956 10.79945068 44.32274737 26.84863477 59.09699531 46.12265508 0.74996192 0.97495049 1.42492763 2.02489717 2.17488955 2.99984765L323.75956924 668.94414717zM676.16665508 753.98982383c14.1742793 21.29891748 31.49839864 42.97281592 43.19780361 65.92164873l-215.83902832 114.14419804c-14.69925263-21.59890224-25.12372325-42.97281592-35.2482082-67.12158779-1.79990859-4.27478291-3.67481338-8.47456963-5.54971729-12.67435635l207.21446631-109.64442568c2.09989336 3.07484385 4.19978672 6.22468388 6.22468389 9.37452305z" fill="#7CE597" p-id="1495"></path><path d="M659.2175167 924.5311543c26.32366231-21.52390606 52.57232754-49.19749893 38.99801778-81.14587471-11.32442402-26.62364708-31.64839102-51.52238086-47.84756836-75.821146-27.89858144-41.92286924-55.42218281-84.07072617-77.69604991-128.8434498-13.87429453-27.89858144-21.9738832-58.42203047-41.3228997-83.77074228-19.27402031-25.19871943-48.5225332-44.84771982-81.44586036-54.52222852-30.74843672-8.99954209-61.94685146-7.34962676-88.79548623 3.14984003 2.24988574-1.57492002 4.57476768-3.07484385 6.9746458-4.49977148 30.59844434-18.22407364 69.37147354-23.54880323 107.61952939-12.29937451 32.92332627 9.59951162 62.17183916 29.32350908 81.44585948 54.52222852 19.4240127 25.34871182 27.4486043 55.87215996 41.32289971 83.7707414 22.27386797 44.77272363 49.79746846 86.92058144 77.69605078 128.84345068 16.19917646 24.29876513 36.52314346 49.19749893 47.84756748 75.82114601 13.57430977 31.94837578-12.67435547 59.54697334-38.99801777 81.1458747-8.7745544 7.19963438-21.82389082 16.04918408-37.12311299 24.52375371-4.49977148 2.24988574-8.9245459 4.3497791-13.19932881 6.2996792 9.82450019-6.07469151 18.29906982-11.99938974 24.52375371-17.17412695z" fill="#008941" p-id="1496"></path><path d="M452.60301904 791.86289873c-0.8249581 0-1.64991622-0.07499619-2.47487432-0.22498857-2.69986289-0.52497334-66.44662207-13.12433262-87.89553193-67.27158018-17.32411933-43.94776641-1.12494287-100.41989502 48.29754551-167.84146846l3.37482861-4.57476767 5.62471348-0.74996192c2.84985527-0.44997715 69.97144307-9.22453067 120.44387724 30.59844521 29.92347862 23.62379942 47.39759033 58.87200761 51.97235802 104.76967413 0.74996192 7.34962676-4.64976386 13.94929072-12.07438594 14.69925264-7.42462295 0.74996192-13.94929072-4.64976386-14.69925264-12.07438594-3.82480576-38.32305205-17.84909268-67.27158018-41.69788066-86.17061953-33.89827675-26.84863477-79.2709708-26.69864239-94.87017686-25.72369277-40.19795683 56.3971333-54.59722471 103.71972744-41.47289209 137.01803466 15.82419551 40.34794922 67.42157256 50.77241894 67.9465459 50.92241133 7.27463057 1.42492763 12.07438594 8.47456963 10.64945917 15.74920019-1.19993906 6.37467627-6.82465342 10.87444688-13.12433349 10.87444688z" fill="#FFB814" p-id="1497"></path><path d="M417.27981465 576.47384756c-3.29983242 0-6.67466104-1.19993906-9.29952686-3.74980957l-35.39820058-33.82328057c-5.39972578-5.09974102-5.54971816-13.64930596-0.44997715-18.97403554 5.09974102-5.39972578 13.64930596-5.54971816 18.97403554-0.44997716l35.47319678 33.82328057c5.39972578 5.09974102 5.54971816 13.64930596 0.44997715 18.97403555-2.6248667 2.77485908-6.1496877 4.19978672-9.74950489 4.19978672z" fill="#FFB814" p-id="1498"></path><path d="M876.93144893 312.03728984c-35.77318154-15.52421074-78.82099365-15.8991917-118.86895723 1.64991622-34.49824628 15.07423359-63.5967668 40.57293779-80.99588232 70.64640878-17.54910791 30.29845958-22.12387558 64.64671348-33.29830724 96.89507402-17.99908506 51.82236562-41.99786543 101.54483789-66.52161914 151.04232247-14.24927549 28.72353955-32.84833008 58.64701904-41.4728912 89.24546338-10.27447734 36.59813964 22.12387558 63.07179346 53.77226659 82.87078711 10.57446211 6.59966484 26.02367753 14.39926787 43.79777315 21.52390605 18.14907744 6.37467627 35.17321201 10.72445449 47.84756748 12.82434786 36.59813964 6.07469151 84.89568428 10.27447734 105.06965976-26.92363096 15.37421836-28.34855859 24.52375371-55.12219805 32.92332628-85.6456462 6.67466104-24.29876513 15.67420312-48.14755224 26.32366142-71.32137451 17.69910029-38.24805586 40.04796445-76.94608887 69.82145069-108.66947607 46.872617-49.94746084 55.79716377-125.61861445 21.82389082-181.71576299-14.54926026-23.99878037-35.69818535-41.77287685-60.22193906-52.42233516z" fill="#55C179" p-id="1499"></path><path d="M937.15338799 364.459625c-14.54926026-23.99878037-35.69818535-41.77287685-60.22193906-52.42233516-35.77318154-15.52421074-78.82099365-15.8991917-118.86895723 1.64991622-3.37482862 1.49992383-6.67466104 3.07484385-9.89949639 4.72476006 20.92393653-0.44997715 41.24790352 3.52482099 59.77196104 11.54941259 24.52375371 10.6494583 45.67267793 28.42355479 60.22193906 52.42233515 33.97327295 56.09714854 25.04872705 131.76830215-21.82389082 181.71576299-29.77348623 31.72338721-52.12235039 70.42142021-69.82145068 108.66947608-10.72445449 23.17382227-19.64900127 47.02260937-26.32366143 71.32137451-8.39957344 30.52344815-17.54910791 57.2970876-32.92332715 85.6456462-2.6248667 4.79975625-5.69971055 8.9245459-9.22453066 12.44936689 30.67344052 2.39987812 62.77180869-1.79990859 78.22102411-30.29845957 15.37421836-28.34855859 24.52375371-55.12219805 32.92332628-85.64564619 6.67466104-24.29876513 15.67420312-48.14755224 26.32366142-71.32137451 17.69910029-38.24805586 40.04796445-76.94608887 69.82145069-108.66947608 46.872617-50.09745323 55.79716377-125.69361065 21.82389082-181.79075918z" fill="#C2FFDF" p-id="1500"></path><path d="M652.39286328 452.43015312c-2.6248667 9.67450781-5.32472959 19.34901651-8.62456113 28.79853574-6.44967247 18.67405078-13.79929834 37.12311299-21.59890225 55.34718663l237.66291826 89.17046719c14.32427167-26.92363096 31.42340244-53.17229707 52.04735421-75.9711375l-259.48680909-97.34505205z" fill="#94FFA6" p-id="1501"></path><path d="M948.85279297 490.60321279c9.29952685-26.62364708 11.24942783-55.34718662 5.47472197-82.42080996L734.88866943 325.83658818c-24.22376895 15.07423359-44.47273886 35.39820058-57.89705625 58.49702666-0.67496572 1.19993906-1.27493526 2.39987812-1.94990097 3.524821l273.81108076 102.74477695zM577.17168682 632.27101133c-12.4493669 25.12372325-28.2735624 51.1473999-37.79807872 77.77104697l250.78725177 94.12021495c12.97434023-25.57370039 21.29891748-50.2474456 28.94852899-77.99603468 1.34993145-4.87475244 2.77485908-9.74950401 4.27478203-14.54926113l-240.73776211-90.37040537c-1.79990859 3.67481338-3.59981719 7.34962676-5.47472196 11.02443926z" fill="#7CE597" p-id="1502"></path><path d="M619.46953701 815.56169433c-31.64839102-19.79899365-64.12174013-46.19765127-53.7722666-82.87078798 8.62456201-30.59844434 27.22361572-60.52192383 41.47289209-89.24546338 24.52375371-49.49748369 48.5975294-99.21995596 66.52161826-151.04232159 11.17443164-32.32335674 15.74919932-66.59661445 33.29830723-96.8950749 17.39911552-30.07347099 46.49763604-55.57217519 80.99588232-70.64640879 32.24836055-14.0992831 66.37162588-16.57415742 97.12006348-8.92454589-2.69986289-1.34993145-5.39972578-2.69986289-8.17458486-3.89980196-35.77318154-15.52421074-78.82099365-15.8991917-118.86895723 1.64991621-34.49824628 15.07423359-63.5967668 40.57293779-80.99588232 70.64640879-17.54910791 30.29845958-22.12387558 64.64671348-33.29830723 96.89507402-17.99908506 51.82236562-41.99786543 101.54483789-66.52161914 151.04232247-14.24927549 28.72353955-32.84833008 58.64701904-41.47289121 89.24546338-10.27447734 36.59813964 22.12387558 63.07179346 53.7722666 82.87078711 10.57446211 6.59966484 26.02367753 14.39926787 43.79777314 21.52390605 5.17473721 1.79990859 10.34947354 3.4498248 15.29922218 4.94974864-11.62440878-5.24973339-21.67389844-10.57446211-29.17351671-15.29922218z" fill="#008941" p-id="1503"></path><path d="M823.90914424 642.47049248a14.71425205 14.71425205 0 0 1-4.5747668-28.72353955c0.59996953-0.22498857 55.27219043-18.74904697 66.82160303-64.87170205 9.59951162-38.09806348-12.67435547-87.59554717-64.27173252-143.31771474-17.02413458 1.12494287-66.44662207 7.27463057-99.59493779 41.24790263-23.32381464 23.92378418-34.57324248 57.37208378-33.37330342 99.59493779a14.69925263 14.69925263 0 0 1-14.32427168 15.14922979 14.69925263 14.69925263 0 0 1-15.14922979-14.32427168c-1.42492763-50.62242656 12.67435547-91.42035293 41.92286836-121.26883535 49.4224875-50.3224418 123.66871347-50.2474456 126.81855352-50.1724503l6.22468389 0.07499619 4.2747829 4.49977149c63.14678965 66.44662207 88.72049004 125.69361065 75.9711375 175.94105625-15.74919932 61.94685146-83.39576045 84.52070332-86.24561571 85.4956538-1.42492763 0.37498096-2.99984766 0.67496572-4.49977149 0.67496573z" fill="#FEB914" p-id="1504"></path><path d="M832.23372148 403.15765801a14.74425088 14.74425088 0 0 1-11.4744164-23.99878038l33.82328057-41.77287685c5.09974102-6.29968008 14.39926787-7.27463057 20.69894794-2.17488867 6.29968008 5.09974102 7.27463057 14.39926787 2.17488868 20.69894707l-33.82328057 41.77287686c-2.84985527 3.59981719-7.04964199 5.47472198-11.39942022 5.47472197z" fill="#FEB914" p-id="1505"></path><path d="M251.98821758 549.47522041c-2.77485908 0-5.54971816-0.67496572-8.09958867-2.17488955L100.72090654 465.0295124C84.89671104 455.95497412 73.49729083 441.18072529 68.77253076 423.55662119s-2.39987812-36.07316631 6.74965723-51.89736181L248.68838516 70.24958105c4.49977148-7.79960391 14.47426406-10.57446211 22.34886416-6.0746915 7.8746001 4.49977148 10.57446211 14.47426406 6.07469062 22.34886417l-173.24119336 301.4846745c-4.72476006 8.24958105-5.99969531 17.84909268-3.524821 27.07362334a35.23320878 35.23320878 0 0 0 16.64915362 21.59890225l143.16772236 82.19582138c7.8746001 4.49977148 10.57446211 14.47426406 6.07469151 22.34886416-3.07484385 5.32472959-8.54956582 8.24958105-14.24927549 8.24958106z" fill="#FFBCC5" p-id="1506"></path><path d="M150.41338086 504.91998477l25.21371797-43.89526846 109.05945644 62.64431543-25.22121767 43.89526846z" fill="#FF7166" p-id="1507"></path><path d="M262.48768349 578.64873711l-123.14374013-70.72140498 33.29830723-57.97205332 123.14374014 70.72140497-33.29830724 57.97205333zM161.54281513 501.85264062l94.94517305 54.52222852 17.09913077-29.77348623-94.94517305-54.52222851-17.09913077 29.77348622z" fill="#FFBCC5" p-id="1508"></path><path d="M156.30058145 179.43652988l78.79099482 43.79777403-30.68094023 55.19719424-78.79099482-43.79777403z" fill="#FF7166" p-id="1509"></path><path d="M207.59047403 289.46343711l-92.99527296-51.67237324 38.54804063-69.37147354 92.99527294 51.67237324-38.54804062 69.37147354zM136.71907666 231.49138378l64.57171728 35.92317393 22.72384512-40.94791787-64.57171728-35.92317392-22.72384512 40.94791787z" fill="#FFBCC5" p-id="1510"></path><path d="M617.21965127 232.46633428L283.11163526 182.74386201a34.87322724 34.87322724 0 0 0-33.67328819 14.47426406l-59.47197715 113.31923995c-10.72445449 15.37421836-4.42477529 36.67313584 12.89934404 43.79777401l130.34337451 58.19704102c14.84924502 6.07469151 31.87337959-0.8999543 38.09806348-15.74919931l34.19826152-81.59585186c11.69940498-27.97357763 53.02230469-21.82389082 56.09714854 8.32457637l8.9245459 88.04552432a29.28601143 29.28601143 0 0 0 31.87338047 26.17366992l141.59280234-17.6991003a29.1735167 29.1735167 0 0 0 25.04872618-38.17305966l-23.84878799-125.69361065a34.74573398 34.74573398 0 0 0-27.97357764-23.6987956z" fill="#FCE665" p-id="1511"></path><path d="M528.94913838 219.34200166l-60.97190098-9.07453828 157.11701397 212.08921875 18.89903936-2.32488193a29.1735167 29.1735167 0 0 0 22.72384423-14.69925264l-137.76799658-185.9905459z" fill="#FFFEE6" p-id="1512"></path><path d="M237.36396026 220.16695977l-22.49885567 42.82282353 106.94456367 144.44265762 11.32442403 5.02474395c14.02428691 5.77470674 29.84848242-0.14999239 36.89812441-13.19932881L237.36396026 220.16695977z" fill="#FFFFEE" p-id="1513"></path><path d="M385.93140839 361.8347583l19.57400508-46.64762841s0-0.07499619 0.0749962-0.0749962L310.48524336 186.79365635l-27.3736081-4.04979434c-9.07453828-1.34993145-18.14907744 0.97495049-25.34871182 6.1496877l128.16848496 172.94120859z" fill="#FFFEE6" p-id="1514"></path><path d="M499.6256293 451.45520263c-21.67389844 0-40.42294541-16.57415742-42.67283115-38.54804062l-8.92454591-88.04552432c-0.8999543-8.9245459-7.42462295-12.97434023-13.27432588-13.87429453-5.77470674-0.8999543-13.274325 1.12494287-16.7241498 9.44951924l-34.19826152 81.59585273c-9.07453828 21.67389844-34.12326533 32.02337197-55.87215996 23.09882608l-0.37498096-0.14999238-130.11838506-58.1220457a42.74782734 42.74782734 0 0 1-24.67374609-27.52360138c-3.59981719-12.22437832-1.57492002-25.27371563 5.47472197-35.84817773l59.47197627-113.39423525 0.52497334-0.67496572a48.21504873 48.21504873 0 0 1 46.87261787-20.17397461l334.10801602 49.79746846c18.29906982 2.69986289 33.22331104 15.37421836 38.92302158 32.92332626l0.29998477 0.82495811 23.84878711 125.76860683a42.59783497 42.59783497 0 0 1-5.24973253 35.92317393 42.64283232 42.64283232 0 0 1-31.5733957 19.12402793l-141.81779091 17.6991003c-1.34993145 0.14999239-2.69986289 0.14999239-4.04979346 0.14999237z m-67.42157344-167.91646377c2.17488955 0 4.3497791 0.14999239 6.59966484 0.52497247 19.72399746 2.92485146 34.34825391 18.22407364 36.37315108 38.09806348l8.92454678 88.04552431a15.68920254 15.68920254 0 0 0 16.87414219 14.0242878l141.81779091-17.6991003c4.72476006-0.44997715 8.99954209-2.99984766 11.62440879-6.9746458 2.6248667-3.97479815 3.29983242-8.84955059 1.79990859-13.42431738l-0.29998477-0.82495811L631.9939001 259.61495469c-2.6248667-7.27463057-8.99954209-12.52436309-16.79914599-13.64930596l-334.10801602-49.79746933c-7.72460771-1.12494287-15.37421836 1.94990098-20.02398223 8.17458486l-59.39698096 113.16924756-0.52497246 0.67496572a15.62170606 15.62170606 0 0 0 6.89964873 23.39880996l0.37498096 0.14999239 130.11838594 58.1220457a15.67420312 15.67420312 0 0 0 20.17397461-8.47456963l34.19826152-81.59585185c6.82465342-16.19917646 22.12387558-26.24866612 39.29800166-26.24866524z" fill="#FF9797" p-id="1515"></path><path d="M516.04979433 429.93129658c-17.24912315 0-32.39835293-12.4493669-34.42325009-28.94852812L472.25202031 323.51170625c-2.69986289-22.27386797-14.02428691-34.64823867-34.64823867-37.64808633-19.19902412-2.84985527-33.44829961 5.92469912-42.4478417 26.17366992l-31.5733957 71.39637071c-7.04964199 15.8991917-26.77363857 23.47380703-43.94776553 16.7241498l-0.37498095-0.14999238-106.11960557-49.79746846c-9.97449258-3.97479815-17.24912315-11.84939737-20.09897842-21.67389844-2.5498705-8.99954209-0.8999543-18.5240584 4.64976386-26.09867373l55.19719424-99.06996357 0.22498858-0.29998476c8.47456963-11.32442402 22.94883369-17.02413458 37.64808545-14.84924503l317.3088709 47.24759795c14.77424883 2.17488955 26.92363096 11.84939737 31.72338721 25.12372325l0.22498857 0.8249581 23.84878711 110.39438847a29.9984748 29.9984748 0 0 1-3.14983917 26.32366143c-5.54971816 8.54956582-14.84924502 13.94929072-25.49870419 14.84924502L518.74965723 429.7813042c-0.8249581 0.07499619-1.7249124 0.14999239-2.69986289 0.14999238zM430.85412529 272.81428349c2.77485908 0 5.69971055 0.22498857 8.62456114 0.67496573 26.17366992 3.89980195 41.77287685 20.69894795 45.14770547 48.5225332L494.07591114 399.48284463c1.27493526 10.72445449 11.92439356 18.74904697 23.62379941 17.92408886l116.46907909-16.79914599c6.82465342-0.52497334 12.74935166-3.89980195 16.19917648-9.22453154 3.07484385-4.79975625 3.74980957-10.34947354 1.79990859-15.74919932l-0.22498858-0.8249581L628.01910195 264.48970713c-3.29983242-8.6995582-11.77440117-15.22422598-21.67389755-16.72414981l-317.30887003-47.24759883c-9.89949638-1.49992383-19.94898604 2.32488193-25.64869658 9.6745087l-55.19719423 98.99496738-0.14999239 0.29998476c-3.4498248 4.57476768-4.42477529 10.12448496-2.92485146 15.59920694 1.7249124 6.07469151 6.44967247 11.02443926 12.82434873 13.57430977l0.37498096 0.14999238 106.11960556 49.79746934c11.02443926 4.19978672 23.47380703-0.37498096 27.82358525-10.27447823l31.57339483-71.3963707c9.82450019-22.19887177 26.39865849-34.12326533 47.02261025-34.12326534z" fill="#FF7166" p-id="1516"></path><path d="M264.13759971 538.82576123m-46.57263223 0a46.57263223 46.57263223 0 1 0 93.14526445 0 46.57263223 46.57263223 0 1 0-93.14526445 0Z" fill="#05D8CD" p-id="1517"></path><path d="M264.13759971 538.82576123m-46.57263223 0a46.57263223 46.57263223 0 1 0 93.14526445 0 46.57263223 46.57263223 0 1 0-93.14526445 0Z" fill="#05D8CD" p-id="1518"></path><path d="M294.36106309 503.35256445c2.6248667 7.12463818 3.59981719 14.9992374 2.39987812 23.02382988a46.67762724 46.67762724 0 0 1-52.9473085 39.22300635c-8.99954209-1.34993145-16.94913838-5.17473721-23.39881083-10.64945917a46.54263427 46.54263427 0 0 0 36.82312822 29.92347948c25.423708 3.82480576 49.12250273-13.79929834 52.94730849-39.22300635 2.47487432-16.42416503-4.04979433-32.17336435-15.8241955-42.29785019z" fill="#0896A4" p-id="1519"></path></svg>,
            describe: '根據你的旅遊要求為您生成旅遊計畫',
            example: [
              '五一假期我想去三亞，出發地在深圳',
              '國慶我想和朋友去北京故宮，從武漢出發',
              '想自駕遊有去西藏，從廣州出發'
            ],
            presets: '根據內容生成旅遊計畫，內容包括所需經費，時間安排，遊玩路線等等.'
          },
          {
            title: '每日食譜',
            icon: h => <svg t="1681962826447" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2958" width="200" height="200"><path d="M511.99772445 305.24188445c222.93845333 0 403.66193778 98.28352 403.66193777 219.52739555 0 121.23818667-180.72348445 219.52512-403.66193777 219.52512-222.93504 0-403.65397333-98.28807111-403.65397334-219.52512 0-121.24387555 180.71893333-219.52739555 403.65397334-219.52739555z" fill="#EE7C1A" p-id="2959"></path><path d="M511.99772445 747.37550222c-108.09344 0-209.76071111-22.91598222-286.25578667-64.51768889-77.16181333-41.95783111-119.65326222-98.10261333-119.65326223-158.08853333 0-59.99160889 42.49144889-116.13639111 119.65326223-158.10104889 76.49507555-41.60056889 178.16234667-64.50744889 286.25578667-64.50744889 108.10140445 0 209.76071111 22.90688 286.2637511 64.50744889 77.15498667 41.96465778 119.64984889 98.10944 119.6498489 158.10104889 0 59.98705778-42.496 116.13070222-119.6498489 158.08853333-76.50304 41.60170667-178.16234667 64.51768889-286.2637511 64.51768889z m0-439.05251555c-107.54275555 0-208.61724445 22.75669333-284.5957689 64.07850666-75.33112889 40.96455111-116.81336889 95.07612445-116.81336888 152.36778667 0 57.28597333 41.48224 111.39299555 116.81336888 152.35754667 75.97852445 41.32522667 177.05301333 64.07850667 284.5957689 64.07850666 107.54389333 0 208.61952-22.76010667 284.60145777-64.07850666 75.33226667-40.96455111 116.80995555-95.07271111 116.80995556-152.35754667 0-57.29052445-41.47768889-111.40209778-116.80995556-152.36778667-75.98193778-41.32181333-177.05756445-64.07850667-284.60145777-64.07850666z" fill="#6A331A" p-id="2960"></path><path d="M511.99772445 354.06506667c189.97020445 0 343.96956445 77.10037333 343.96956444 172.20039111 0 95.10798222-154.00049778 172.20494222-343.96956444 172.20494222-189.96224 0-343.96501333-77.09696-343.96501334-172.20494222 0-95.10001778 154.00277333-172.20039111 343.96501334-172.20039111z" fill="#F4BC3E" p-id="2961"></path><path d="M193.40060445 596.19214222s23.4496-5.39989333 41.71889777 1.01262223c18.27043555 6.41137778-0.59505778 15.24508445 34.25848889 10.86577777 34.85240889-4.38272 141.18229333-29.93152 169.17276444-57.31669333 37.12910222-20.76899555 112.71168-86.47907555 124.66858667-92.50929778 11.95690667-6.03363555 25.15057778-66.21866667 1.55648-113.96323556-23.59296-47.74229333-40.70855111-42.73038222-40.70855111-42.73038222s-35.86730667-37.06993778-68.83669333-24.95032888c-32.9728 12.11960889-72.24888889 4.02659555-85.11374223 0.74752-12.86826667-3.2768-76.72490667 6.96775111-100.74680888 32.88064-24.02190222 25.91744-51.99303111 41.22168889-70.98481778 63.70872888-18.99178667 22.48931555-51.06232889 93.47868445-39.79264 134.70833778 11.26968889 41.23420445 14.10048 81.33859555 34.80803556 87.54631111z" fill="#F4F4C9" p-id="2962"></path><path d="M254.90659555 611.61699555c-8.46506667 0-10.28323555-2.24483555-12.0877511-5.6672711-1.12184889-2.12764445-2.28238222-4.32810667-8.4844089-6.50467556-5.67978667-1.99452445-12.51214222-3.00487111-20.30705777-3.00487111-10.99548445 0-20.00327111 2.04572445-20.09315556 2.06506667l-0.61326222 0.14108444-0.60188445-0.18090667c-17.00636445-5.09724445-22.45176889-29.28753778-29.34556444-59.91310222-2.13788445-9.49589333-4.34744889-19.31491555-7.07242666-29.28071111-5.06083555-18.51847111-2.00817778-45.43488 8.59818666-75.79079111 8.40135111-24.04693333 21.12967111-48.59107555 31.67118222-61.07477333 9.84291555-11.65539555 21.92384-21.2992 34.71132445-31.50734223 12.14691555-9.69614222 24.70684445-19.72451555 36.34631111-32.28330667 21.13080889-22.79310222 72.81208889-34.23232 95.80657778-34.23232 3.08906667 0 5.53301333 0.22414222 7.26698666 0.66446223 6.63438222 1.69073778 24.22784 5.62289778 44.25272889 5.62176 14.81386667 0 28.08945778-2.11854222 39.45699556-6.2976 4.65806222-1.71121778 9.63015111-2.58048 14.77973333-2.58048 26.51477333 0 50.83591111 22.45632 55.72721778 27.25091555 0.19569778-0.01137778 0.40846222-0.01820445 0.63943111-0.01820444 5.86410667 0 21.63143111 4.30762667 41.34798222 44.20380444 24.02986667 48.62407111 10.94883555 110.29048889-2.61461333 117.13308445-4.40433778 2.22094222-19.08167111 13.90705778-36.07779556 27.43637333-27.55697778 21.93863111-65.25724445 51.95093333-88.23125333 64.87267556-15.87086222 15.30424889-53.72586667 28.90638222-82.76081778 37.63882666-34.15381333 10.27185778-69.89368889 17.89610667-87.54631111 20.11477334-6.38179555 0.80327111-11.21166222 1.19352889-14.76835556 1.19352888z m-40.87921777-19.92476444c8.33308445 0 15.69336889 1.10136889 21.87946667 3.27224889 7.96103111 2.79324445 9.78147555 6.2464 11.1104 8.76999111 1.10023111 2.08782222 1.65319111 3.13571555 7.88821333 3.13571556 3.35644445 0 7.99402667-0.37774222 14.17671111-1.15598222 36.59776-4.60003555 140.71921778-30.15338667 167.80856889-56.65792l0.22528-0.2207289 0.27534222-0.1536c22.60992-12.64526222 60.32497778-42.67235555 87.86375111-64.59505777 18.60949333-14.81614222 32.05575111-25.52035555 36.89699556-27.96088889 4.864-2.45532445 10.98752-17.87221333 12.81365333-39.42058667 1.25496889-14.80931555 1.32209778-43.77372445-12.31644445-71.37166222-19.05777778-38.56156445-33.20945778-41.55847111-37.09155555-41.55847111-0.57344 0-0.87950222 0.07054222-0.88177778 0.07168l-1.37443555 0.40277333-0.93866667-1.04561777c-0.25941333-0.26624-26.14954667-26.66154667-53.17063111-26.66154667-4.58865778 0-9.00892445 0.77027555-13.14133334 2.28920889-11.89546667 4.37134222-25.72060445 6.58887111-41.09539555 6.58887111-20.56192 0-38.61617778-4.03456-45.42350222-5.76853333-0.92842667-0.23665778-2.73976889-0.51882667-6.09507556-0.51882667-21.63712 0-72.41500445 11.23555555-92.32611555 32.71338667-11.88181333 12.81934222-24.58282667 22.95921778-36.86627556 32.76458666-12.60088889 10.06023111-24.50318222 19.56067555-34.04572444 30.85994667-19.59708445 23.20611555-50.15779555 92.88590222-39.31704889 132.55111111 2.75228445 10.07160889 4.97550222 19.94296889 7.12476444 29.49006222 6.21112889 27.59111111 11.58599111 51.46965333 25.51352889 56.22784 2.33472-0.49038222 10.57109333-2.048 20.50730667-2.048z" fill="#FCD770" p-id="2963"></path><path d="M193.00579555 438.06151111c3.30524445-2.20728889 5.18485333-1.63157333 8.47985778-0.37319111a18.90531555 18.90531555 0 0 0 6.08028445 1.24245333l0.73045333-1.32323555-0.11036444 0.03754667c-0.26510222 0.09102222-1.67708445 0.55523555-1.52120889 1.05813333 0.36522667 1.18215111 3.04583111 2.15836445 4.00497777 2.66922667 1.87392 1.00010667 4.19612445 2.29376 6.39089778 2.30513777 2.43029333 0.01592889 4.82531555-0.88177778 6.95864889-1.96380444 2.94912-1.49390222 5.63427555-4.90609778 8.90993778-2.97187556 5.87776 3.46794667 8.76999111 10.51875555 14.40426667 14.38151111 6.22023111 4.26325333 15.62055111 3.44974222 22.73962666 4.76501334 1.03424 0.19114667 4.95047111-1.48252445 3.78993778-1.69528889-7.42627555-1.37329778-16.46364445-0.65991111-22.92849778-5.09269333-5.39761778-3.69891555-8.24092445-10.15580445-13.67267555-13.87861334-4.27576889-2.92977778-9.06695111-0.29013333-12.87395556 2.15495111-0.94663111 0.60643555-3.24721778 2.63623111-4.35313777 2.53610667-1.21628445-0.11150222-2.48263111-0.82944-3.57489778-1.33233778-1.06496-0.49265778-4.82417778-1.85571555-5.20988445-3.10499556l-1.52120889 1.05813334 0.11036445-0.03754667c0.65763555-0.22641778 2.44963555-1.25383111 0.73045333-1.32323555-3.77287111-0.15473778-7.04853333-2.70222222-10.80206222-2.63168-3.79221333 0.07054222-7.11111111 1.41084445-10.24227556 3.50094222-1.85457778 1.23676445 2.72839111 0.52110222 3.48046222 0.01934222zM461.28924445 323.12433778c10.70193778 6.27939555 22.51662222 9.79285333 34.45532444 12.88760889 3.82179555 0.99100445 7.16572445 1.73624889 11.06261333 1.78176 4.08462222 0.04778667 8.16583111 0.20707555 12.23566223 0.53361778 3.31434667 0.26396445 6.88469333 0.51427555 9.99765333 1.76241777 3.51800889 1.40970667 4.28259555 7.09063111 4.32924444 10.28209778 0.05688889 4.00611555-0.56888889 7.93486222-0.09329777 11.94097778 0.55751111 4.71153778 3.63861333 8.22840889 7.52867555 10.65642667 1.83523555 1.14460445 5.77991111-1.34144 3.50549333-2.7602489-9.34570667-5.83224889-5.36576-15.01184-6.55928888-24.07765333-1.04334222-7.94282667-6.90403555-10.11256889-13.81717334-10.99320889-6.64120889-0.84536889-13.40871111-0.93411555-20.09429333-0.93980444-3.05038222-0.00227555-7.19644445-1.87278222-10.12849778-2.65557334a220.19072 220.19072 0 0 1-9.41966222-2.75342222c-6.76522667-2.13902222-13.37002667-4.83100445-19.49696-8.42524444-1.85912889-1.08999111-5.80380445 1.41198222-3.50549333 2.76024889zM341.35495111 493.11857778c10.73834667-5.9392 22.95580445-16.54556445 36.03228444-12.77724445a39.91893333 39.91893333 0 0 1 11.64060445 5.49546667c2.22094222 1.52348445 4.33379555 2.55658667 7.06332445 2.79665778 4.23936 0.37091555 8.68807111-1.26065778 12.62136888-2.59413333 6.64348445-2.25166222 13.13905778-4.10624 20.14549334-4.80256 12.72832-1.26065778 25.66371555 1.19694222 38.41479111 1.25496888 2.13674667 0.01024 4.84238222-0.62691555 6.01998222-2.62940444 1.09340445-1.86026667-0.92387555-3.16757333-2.61461333-3.17667556-13.19936-0.06030222-26.34296889-2.18339555-39.54460445-1.29934222-7.05649778 0.47217778-14.38151111 1.92739555-21.02499555 4.35313778-2.86947555 1.04903111-5.75032889 2.05596445-8.71424 2.80803556-1.27431111 0.32426667-2.02865778 0.28899555-2.57365334 0.12856888-2.03093333-0.59278222-4.88789333-3.20739555-7.08949333-4.36110222-5.32366222-2.78755555-11.43694222-4.66261333-17.45692445-4.70584889-14.47480889-0.10808889-26.69681778 9.50613333-38.77091555 16.18602667-1.49048889 0.82488889-2.52700445 3.00828445-0.67584 4.05617778 2.05027555 1.16167111 4.64440889 0.30833778 6.52743111-0.73272889zM302.60337778 341.23662222c9.61422222 0.04892445 19.25461333 1.44952889 28.86428444 0.73272889 9.18528-0.68721778 17.55704889-3.95377778 25.08913778-9.19210666-1.97176889 0.30492445-3.94353778 0.61098667-5.91644445 0.91477333 4.31217778 4.84238222 7.86318222 11.24010667 13.88885334 14.13575111 8.96682667 4.30648889 19.84056889 3.00828445 29.39221333 2.73635556 6.47736889-0.18318222 12.12074667 1.12071111 17.03708445 5.47157333 3.72849778 3.29841778 6.53198222 7.44220445 10.51306666 10.49144889 8.57088 6.56497778 20.64952889 4.45895111 30.66766222 4.37930666 2.22208-0.01934222 7.43651555-3.41674667 2.81713778-3.38033778-5.22581333 0.04209778-10.45048889 0.49720889-15.67516444 0.18090667-5.84704-0.35271111-10.43456-2.47352889-14.61930667-6.51491555-3.35758222-3.24152889-6.07914667-6.96775111-9.84974222-9.78830222-3.98449778-2.98097778-9.18528-3.98108445-14.05610667-4.16768-10.13077333-0.38912-20.32412445 1.62702222-30.07715555-2.1765689-5.86183111-2.28579555-9.62218667-9.42535111-13.60668445-13.90250666-1.24928-1.40288-4.76728889 0.11605333-5.91644444 0.91477333-6.81984 4.74339555-13.87861333 6.66396445-22.1184 6.72085333-7.87797333 0.05347555-15.73660445-0.89884445-23.61799111-0.93866666-2.23118222-0.00796445-7.43879111 3.35872-2.816 3.38261333zM501.10008889 419.67502222c1.44611555 8.79274667-3.78766222 14.49528889-8.97934222 20.78606223-1.93763555 2.34723555-3.59424 4.85944889-4.03911112 7.9200711-0.59278222 4.08803555 2.29148445 7.77329778 4.83555556 10.60067556 0.71907555 0.79985778 4.92999111-0.85333333 4.33493334-1.51438222-2.60778667-2.89792-4.90609778-6.25436445-4.58410667-10.31509334 0.25941333-3.27224889 2.78869333-6.15651555 4.79800889-8.54812444 5.07335111-6.0416 9.59715555-11.79192889 8.22044444-20.15687111-0.13425778-0.81123555-4.75818667 0.18773333-4.58638222 1.22766222zM237.63057778 546.66353778c7.32273778 13.68746667 27.01084445 10.63480889 39.89959111 11.56778667 8.85077333 0.64170667 17.28056889 3.33710222 25.73198222 5.84362666 9.30816 2.76252445 18.52188445 4.00611555 28.21233778 2.97528889 1.07064889-0.11377778 5.02897778-1.96835555 2.03776-1.65091555-17.99168 1.91374222-33.72145778-7.00643555-51.27168-8.75292445-12.82161778-1.27544889-32.68494222 2.51221333-40.02474667-11.21052445-0.54499555-1.024-4.87310222 0.68721778-4.58524444 1.22766223z" fill="#FCD770" p-id="2964"></path><path d="M311.13216 380.93255111a11.41987555 6.52743111 90 1 0 13.05486222 0 11.41987555 6.52743111 90 1 0-13.05486222 0Z" fill="#9A3224" p-id="2965"></path><path d="M417.94446222 449.37216a14.83434667 7.66748445 0 1 0 29.66869333 0 14.83434667 7.66748445 0 1 0-29.66869333 0Z" fill="#9A3224" p-id="2966"></path><path d="M262.47395555 524.68622222a10.68145778 8.90083555 90 1 0 17.80167112 0 10.68145778 8.90083555 90 1 0-17.80167112 0Z" fill="#548E21" p-id="2967"></path><path d="M468.97607111 305.34997333a10.67235555 9.27402667 0 1 0 21.34471111 0 10.67235555 9.27402667 0 1 0-21.34471111 0Z" fill="#548E21" p-id="2968"></path><path d="M374.03079111 405.57340445a7.71527111 5.18144 0 1 0 15.43054222 0 7.71527111 5.18144 0 1 0-15.43054222 0Z" fill="#548E21" p-id="2969"></path><path d="M218.56256 449.91829333a7.12135111 6.52743111 90 1 0 13.05486222 0 7.12135111 6.52743111 90 1 0-13.05486222 0Z" fill="#548E21" p-id="2970"></path><path d="M403.70289778 519.34663111a14.53738667 5.34072889 0 1 0 29.07477333 0 14.53738667 5.34072889 0 1 0-29.07477333 0Z" fill="#FFCC00" p-id="2971"></path><path d="M351.48231111 442.25649778a7.78922667 7.66065778 0 1 0 15.57845334 0 7.78922667 7.66065778 0 1 0-15.57845334 0Z" fill="#FFCC00" p-id="2972"></path><path d="M447.61315555 350.51064889a7.71413333 5.65134222 0 1 0 15.42826667 0 7.71413333 5.65134222 0 1 0-15.42826667 0Z" fill="#FFCC00" p-id="2973"></path><path d="M542.55616 428.61340445a7.12135111 5.98243555 0 1 0 14.24270222 0 7.12135111 5.98243555 0 1 0-14.24270222 0Z" fill="#FFCC00" p-id="2974"></path><path d="M262.47395555 376.26197333a8.90083555 4.67057778 0 1 0 17.80167112 0 8.90083555 4.67057778 0 1 0-17.80167112 0Z" fill="#FFCC00" p-id="2975"></path><path d="M490.32192 389.27246222a11.11950222 6.23843555 90 1 0 12.47687111 0 11.11950222 6.23843555 90 1 0-12.47687111 0Z" fill="#FFFFFF" p-id="2976"></path><path d="M247.04341333 409.72629333a9.33432889 7.71527111 90 1 0 15.43054222 0 9.33432889 7.71527111 90 1 0-15.43054222 0Z" fill="#FFFFFF" p-id="2977"></path><path d="M225.08885333 499.77457778a7.41831111 3.57148445 0 1 0 14.83662222 0 7.41831111 3.57148445 0 1 0-14.83662222 0Z" fill="#FFFFFF" p-id="2978"></path><path d="M332.4928 561.28625778a7.12135111 4.93795555 0 1 0 14.24270222 0 7.12135111 4.93795555 0 1 0-14.24270222 0Z" fill="#FFFFFF" p-id="2979"></path><path d="M378.77873778 323.52483555a8.90083555 8.30805333 90 1 0 16.61610667 0 8.90083555 8.30805333 90 1 0-16.61610667 0Z" fill="#FFFFFF" p-id="2980"></path><path d="M299.26286222 318.18410667a9.19779555 3.56010667 0 1 0 18.39559111 0 9.19779555 3.56010667 0 1 0-18.39559111 0Z" fill="#FFFFFF" p-id="2981"></path><path d="M404.39580445 405.05912889a10.33443555 4.66716445 0 1 0 20.6688711 0 10.33443555 4.66716445 0 1 0-20.6688711 0Z" fill="#FFFFFF" p-id="2982"></path><path d="M486.25550222 647.44789333s-6.34993778 39.61059555 36.19612445 18.84615112c22.73507555-14.10389333 19.84284445-29.01447111 19.09191111-32.90225778 10.0352-4.46577778 27.83800889-14.25749333 30.32632889-15.51132445-8.80184889-7.40920889-12.17194667-11.25034667-13.25056-22.21283555-26.68430222 14.86279111-28.55480889 17.03822222-28.55480889 17.03822222s-3.53166222-11.57688889-12.51669333-12.32213334c-8.98503111-0.74752-66.9696 16.36238222-34.83306667 44.01379556 3.62154667 2.24483555 3.54076445 3.05038222 3.54076444 3.05038222z" fill="#F9DBAF" p-id="2983"></path><path d="M554.78158222 586.73834667s15.9232-144.67754667 197.86183111-168.81322667c45.61009778-0.4608 68.06186667 18.02808889 77.21528889 35.67616 9.15114667 17.65376-0.97507555 106.48576-55.85692444 140.02062222s-157.71534222 68.54542222-212.55850667 15.81511111c-5.86524445-19.10328889-6.66168889-22.69866667-6.66168889-22.69866666z" fill="#CD6D13" p-id="2984"></path><path d="M640.80099555 495.83559111s78.66481778-81.42392889 132.05390223-51.24778666c39.22147555 19.35701333 31.49368889 34.27896889 30.83150222 35.81496888-0.66332445 1.53713778-5.34983111 10.5472-17.09056-7.00984888-14.32917333-12.41998222-32.73272889-33.50186667-103.02236445-3.93329778-33.55989333 24.36096-37.31683555 29.97248-39.23057777 29.42748444-1.91146667-0.54613333-3.54190222-3.05152-3.54190223-3.05152z" fill="#E29712" p-id="2985"></path><path d="M557.09582222 573.31370667s55.63278222 67.60903111 192.12174223-1.04220445c28.15203555-16.86869333 75.28220445-67.87072 78.88440888-75.45742222-3.02193778 19.37180445-13.57027555 124.10311111-180.41969778 136.02929778-67.83203555-10.39132445-75.16842667-13.45991111-81.66627555-28.71864889-6.49557333-15.25304889-8.92017778-30.81102222-8.92017778-30.81102222z" fill="#BD541E" p-id="2986"></path><path d="M371.16131555 606.69155555s1.00920889-28.82332445-31.39356444-9.91345777c-32.40277333 18.91214222-33.10250667 22.7328-33.04561778 31.39470222 0.05461333 8.65848889 9.60170667 78.43953778 64.43918222 56.18005333 38.39544889-25.20291555 21.81688889-16.73557333 19.82691556-24.78535111-1.98656-8.05091555-28.63672889-13.02983111-21.47783111-18.17713777 7.15776-5.14389333 23.16856889-12.55879111 14.86848-21.48010667-8.29895111-8.92017778-13.21756445-13.21870222-13.21756445-13.21870223z" fill="#633211" p-id="2987"></path><path d="M401.27374222 600.11975111s-5.94602667-27.90513778-32.50631111-1.98314666c-26.56028445 25.92312889-26.31452445 29.75630222-24.18232889 38.0563911 2.12878222 8.29781333 28.03029333 72.97706667 75.31975111 38.45802667 30.80419555-33.39832889 16.92444445-21.29351111 13.08330667-28.54343111s-30.60963555-5.63427555-24.97308445-12.29255111c5.63427555-6.65144889 19.22275555-17.61052445 9.11701334-24.18005333-10.10801778-6.57066667-15.85834667-9.51523555-15.85834667-9.51523556z" fill="#C6302E" p-id="2988"></path><path d="M614.46485333 349.26023111s-44.92856889 58.10744889 13.88430222 69.71050667c41.67224889-19.40593778 11.78965333-54.56099555-13.88430222-69.71050667z" fill="#77AC44" p-id="2989"></path><path d="M614.88924445 348.91662222s13.48266667 8.45141333 21.3754311 27.69237333c7.89390222 19.24437333 2.97528889 31.13870222 0.16839112 34.83648-2.80462222 3.69891555-7.66065778 9.77692445-15.27808 3.35189334-7.61628445-6.42730667-22.41991111-17.36248889-6.26574222-65.88074667z" fill="#97C265" p-id="2990"></path><path d="M614.88128 353.94446222s5.74008889 56.90709333 12.03541333 61.27502223c4.37816889-5.90506667-4.22912-51.02592-12.03541333-61.27502223z" fill="#77AC44" p-id="2991"></path><path d="M690.14641778 408.64540445s-47.78780445-44.34375111-62.73024 6.71971555c13.83537778 38.38179555 47.29059555 14.76949333 62.73024-6.71971555z" fill="#77AC44" p-id="2992"></path><path d="M690.41379555 409.04817778s-8.54471111 11.24352-26.18026666 16.68778667c-17.64010667 5.44540445-27.76291555 0.14904889-30.80874667-2.62599112-3.04583111-2.77390222-8.03271111-7.55143111-1.74421333-13.77052444 6.28622222-6.22023111 17.13379555-18.43427555 58.73322666-0.29127111z" fill="#97C265" p-id="2993"></path><path d="M685.96963555 408.64085333s-50.75968 0.54158222-55.12192 5.75715556c4.86968889 4.34062222 45.44170667 0.32654222 55.12192-5.75715556z" fill="#77AC44" p-id="2994"></path></svg>,
            describe: '想吃什麼，都可以讓AI告訴你怎麼做',
            example: [
              '宮保雞丁',
              '麻婆豆腐',
              '烤鴨'
            ],
            presets: '使用中文語言，描述一道菜的詳細做法，包括需要的食材，準備工作，做法步驟，注意點.'
          },
          {
            title: '解夢',
            icon: h => <svg t="1682042857675" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1605" width="200" height="200"><path d="M881.65082106 514.17491399c0 49.93241252-4.49032457 99.55050216-22.45162435 142.92703976-18.63484807 44.90324873-52.98583326 81.36468601-86.93268904 115.26663852a360.48327905 360.48327905 0 0 1-119.21812463 77.2335876c-43.37653837 17.96129903-88.99823861 38.93111629-138.93065114 38.93111629s-97.52985583-16.07536329-140.95129668-34.08156558c-44.90324873-18.63484807-82.80158983-48.67512098-116.74844639-82.5770735A362.54882787 362.54882787 0 0 1 175.68194857 654.54246821C157.67574551 610.896511 142.13922222 564.10732575 142.13922222 514.17491399a374.04406005 374.04406005 0 0 1 28.19923968-142.29839475c18.67975133-44.90324873 50.78557386-82.71178331 84.68752636-116.74844561S327.81415456 192.03900953 372.80720907 173.40416147a367.84741128 367.84741128 0 0 1 141.13090977-27.70530451c49.93241252 0 96.13785527 13.47097447 139.51439362 31.65678985 44.90324873 18.63484807 90.43514245 39.11072937 124.33709495 73.01268187s52.35718748 80.15229853 70.99203557 125.10045053c18.0062023 43.42144162 32.86917809 88.81862555 32.86917808 138.70613478z" fill="#FFD635" p-id="1606"></path><path d="M593.28215929 840.57662669c-47.05860409 0-92.00675609-15.17729791-132.91361544-32.15072579-42.43356972-17.60207364-78.1316522-45.89111987-110.10276569-77.90713586a342.34236617 342.34236617 0 0 1-76.02119935-110.86612049c-16.97342788-40.90685934-31.43227427-85.04675251-31.43227426-132.15026064a353.11914606 353.11914606 0 0 1 26.40311048-134.21580945c17.60207364-42.43356972 48.04647601-77.99694239 79.88287891-109.96805513s68.65706712-59.58661068 111.04573356-77.18868433a340.32171984 340.32171984 0 0 1 67.80390503-20.02684861c-4.49032457 0-9.29497278-0.40412942-14.00981369-0.40412943a367.84741128 367.84741128 0 0 0-141.13090977 27.70530451C327.81415456 192.03900953 288.92794077 221.36083016 255.02598826 255.26278343s-66.00777503 71.84519767-84.68752636 116.74844562A374.04406005 374.04406005 0 0 0 142.13922222 514.17491399c0 49.93241252 15.53652406 96.72159699 33.54272635 140.36755422a362.54882787 362.54882787 0 0 0 80.82584679 117.55670445c33.9019525 33.9019525 71.84519767 63.94222544 116.74844639 82.57707426 43.42144162 17.96129903 91.06378822 34.08156558 140.95129669 34.08156558s95.55411278-20.92491399 138.93065114-38.93111629a375.66057696 375.66057696 0 0 0 97.61966238-57.70067417c-8.53161722 4.22090572-17.2428475 8.2621976-26.17859413 11.98916738-41.17627897 16.56929847-84.01397811 36.46143805-131.29709853 36.46143727z" fill="#F7B523" p-id="1607"></path><path d="M454.80054084 241.43258282s2.64929132-2.06554959 7.45393954-5.2985834a174.2246042 174.2246042 0 0 1 20.79020418-12.07897392 170.99157039 170.99157039 0 0 1 32.1507258-12.21368371A157.79001478 157.79001478 0 0 1 555.2491076 206.40804859h10.19303739c3.18813054 0 6.82529378 0.22451634 10.10323085 0.4490327s6.60077742 0.7184523 9.83381199 1.16748421 6.37626109 1.12258095 9.4745851 1.79612999a122.31644863 122.31644863 0 0 1 17.46736385 5.4332932 101.66095425 101.66095425 0 0 1 14.86297502 7.18451993 89.80649669 89.80649669 0 0 1 19.93704207 15.44671751 53.88389785 53.88389785 0 0 1 4.80464745 5.61290629 20.02684863 20.02684863 0 0 1 1.57161441 2.20025862s-3.77187304 0.67354903-9.87871527 1.12258173c-3.00851747 0.2694196-6.60077742 0.31432288-10.6420693 0.49393517s-8.44181067 0-13.15665236 0-9.7440047-0.4490327-14.99768483-0.80825806-10.68697334-0.98787114-16.29987885-1.70632344l-8.48671396-1.167485-8.71123028-1.39200055-8.9806499-1.4818071-4.49032456-0.8980646a40.05369802 40.05369802 0 0 0-4.22090572-0.53883923 318.45383797 318.45383797 0 0 0-66.41190445 0l-23.3047857 1.97574306-6.69058397 0.1347098z" fill="#FFEF57" p-id="1608"></path><path d="M641.73276394 665.04982846a57.38635128 57.38635128 0 0 1-3.05342074 21.68826957 69.68984152 69.68984152 0 0 1-12.43819927 22.04749494 71.57577804 71.57577804 0 0 1-18.90426768 18.76955788 66.00777503 66.00777503 0 0 1-32.42014541 9.51948834 94.70095067 94.70095067 0 0 1-34.35098519-5.07406705 67.89371154 67.89371154 0 0 1-24.33756088-16.5243952A66.86093713 66.86093713 0 0 1 503.16133972 694.95539236c-3.2330338-6.82529378-2.96361419-14.1445235-3.63716322-21.9576884a65.01990389 65.01990389 0 0 1 0.53883922-22.90065706 60.79899817 60.79899817 0 0 1 11.49523141-20.65549438c5.61290629-7.40903627 10.10323085-14.50374887 18.50013825-19.21859055a75.34765107 75.34765107 0 0 1 32.2854356-11.58503795 83.87926829 83.87926829 0 0 1 35.06943672 7.22942317 78.89500777 78.89500777 0 0 1 24.7416903 16.52439522 70.54300363 70.54300363 0 0 1 13.78529735 20.79020418 65.2893235 65.2893235 0 0 1 5.79251859 21.86788187zM318.56408505 477.66857268l1.30219403 1.97574306c0.89806461 1.39200055 1.88593652 2.42477574 3.50245342 4.49032455a77.99694239 77.99694239 0 0 0 14.90787829 13.78529735 97.08082315 97.08082315 0 0 0 11.62994199 6.96000358 99.41579235 99.41579235 0 0 0 14.189426 5.65780955 95.41940297 95.41940297 0 0 0 15.98555674 3.77187304 106.28598939 106.28598939 0 0 0 16.92852462 1.39200056H405.58658062c2.82890439 0 5.70271282-0.4490327 8.48671394-0.85316211a149.93194659 149.93194659 0 0 0 16.21007232-3.36774362 124.65141784 124.65141784 0 0 0 14.36903984-5.20877686A96.36237084 96.36237084 0 0 0 456.46196101 499.62626109a67.35487232 67.35487232 0 0 0 14.86297503-13.02194178 58.68854608 58.68854608 0 0 0 4.49032533-6.10684224l0.31432289-0.49393518a9.33987606 9.33987606 0 0 1 16.97342788 7.49884202l-0.76335556 2.64929209a57.25164147 57.25164147 0 0 1-2.73909786 7.2294232 70.81242248 70.81242248 0 0 1-16.74891154 22.45162358 85.31617211 85.31617211 0 0 1-14.81807253 11.04619949 100.31385695 100.31385695 0 0 1-18.36542845 8.7112303 111.31515318 111.31515318 0 0 1-20.79020419 5.47819648c-3.59225996 0.62864576-7.27432645 1.07767767-10.95639219 1.39200055-1.84103325 0-3.81677631 0.2694196-5.79251936 0.35922615a24.96620587 24.96620587 0 0 1-2.55948477 0h-2.82890516a129.95000123 129.95000123 0 0 1-22.18220475-2.33496921 123.48393362 123.48393362 0 0 1-20.74530093-6.24155127 103.77140711 103.77140711 0 0 1-17.96129902-9.42968259 92.36598223 92.36598223 0 0 1-14.32413658-11.54013467 78.266362 78.266362 0 0 1-16.07536251-22.45162436 60.57448182 60.57448182 0 0 1-2.96361496-7.18451993c-0.49393596-1.4818071-0.7184523-2.29006594-0.71845153-2.29006517a9.42968182 9.42968182 0 0 1 16.88362134-8.08258529z" fill="#943436" p-id="1609"></path><path d="M295.84304107 417.09409086l3.23303381-5.38838994c1.21238748-1.75122671 2.55948477-4.04129265 4.265809-6.42116435s3.59225996-5.07406706 5.8823259-7.85806896 4.75974417-5.79251935 7.49884202-8.98064989 5.79251935-6.24155127 8.98064991-9.29497201 6.87019704-6.15174474 10.50736026-9.25006952 7.58864933-5.92722917 11.62994122-8.57652049 8.17239106-5.25368014 12.25858697-7.76826164 8.30710088-4.49032457 12.39329602-6.60077742 8.08258452-3.90658284 12.03407064-5.34348668 7.49884281-3.14322728 11.00129622-4.22090571l9.42968182-3.09832401 7.40903627-2.06554959 6.42116434-1.70632345a15.7610404 15.7610404 0 1 1 8.17239106 30.44440313l-1.70632344 0.35922537h-0.7633548l-5.74761609 0.89806538-6.6456807 0.98787114-8.53161721 1.79612998c-3.14322728 0.58374249-6.37626109 1.61651691-9.92361777 2.51458229s-7.13961666 2.29006594-10.95639295 3.45755015-7.54374607 2.87380766-11.40542487 4.49032457-7.72335836 3.41264689-11.40542487 5.52309975-7.40903627 4.17600246-11.0461995 6.3313578-7.00490684 4.49032457-10.10323085 7.04981012-6.19664801 4.89445399-8.9806499 7.27432647-5.38838993 4.80464744-7.58864857 7.13961663-4.49032457 4.49032457-6.06193897 6.42116436-3.09832401 3.6820665-4.49032457 5.07406705L308.28124114 425.53590153a7.40903627 7.40903627 0 0 1-12.21368372-8.30710086z" fill="#F7B523" p-id="1610"></path><path d="M808.18910651 485.7511572l-0.71845231 2.29006593a60.57448182 60.57448182 0 0 1-2.96361419 7.18451993 78.58068489 78.58068489 0 0 1-16.12026656 22.45162436 92.36598223 92.36598223 0 0 1-14.3241358 11.54013469 103.77140711 103.77140711 0 0 1-17.9612998 9.4296818 124.24728843 124.24728843 0 0 1-20.70039688 6.24155205 130.21942085 130.21942085 0 0 1-22.18220475 2.33496844h-2.87380844a25.14581895 25.14581895 0 0 1-2.55948477 0c-1.97574306 0-3.9514861 0-5.74761609-0.35922538-3.72696977-0.31432288-7.36413299-0.76335558-11.00129545-1.39200133a112.25812104 112.25812104 0 0 1-20.79020419-5.47819571 100.31385695 100.31385695 0 0 1-18.36542845-8.71123028 87.15720537 87.15720537 0 0 1-14.81807253-11.0461995 70.81242248 70.81242248 0 0 1-16.74891155-22.45162436 55.7249311 55.7249311 0 0 1-2.78400111-7.40903549l-0.76335557-2.6492921a9.33987606 9.33987606 0 0 1 16.92852461-7.5437453l0.31432288 0.53883846a58.68854608 58.68854608 0 0 0 4.49032457 6.10684224 68.65706712 68.65706712 0 0 0 14.8629758 13.02194178 103.27747115 103.27747115 0 0 0 11.85445755 6.42116435 122.45115844 122.45115844 0 0 0 14.41394235 5.20877686 147.73168719 147.73168719 0 0 0 16.21007309 3.36774362c2.78400113 0.40412942 5.61290629 0.67354903 8.44181067 0.8531621H712.85951007a105.88185997 105.88185997 0 0 0 16.92852463-1.39200055 95.9582422 95.9582422 0 0 0 16.03045923-3.77187304 100.94250272 100.94250272 0 0 0 14.1445235-5.65780955 97.79927545 97.79927545 0 0 0 11.67484448-6.96000358 77.50300721 77.50300721 0 0 0 14.8629758-13.78529734c1.61651691-2.11045286 2.60438804-3.14322728 3.50245265-4.49032456l1.34709806-1.97574306a9.42968182 9.42968182 0 0 1 16.88362136 8.08258452z" fill="#943436" p-id="1611"></path><path d="M801.76794215 425.53590153l-3.81677631-4.93935725c-1.21238748-1.39200055-2.51458228-3.14322728-4.49032532-5.07406707s-3.72696977-4.17600246-6.06193821-6.42116511-4.84955072-4.49032457-7.54374608-7.13961588-5.79251935-4.93935726-8.98064911-7.27432646-6.69058397-4.49032457-10.14813413-7.04981011-7.18451993-4.49032457-11.00129622-6.33135782-7.6784551-3.72696977-11.40542487-5.52309974-7.6784551-3.14322728-11.45032814-4.49032457-7.36413299-2.60438804-10.91148968-3.45755015-6.82529378-1.93083979-9.96852104-2.51458228l-8.48671395-1.79612999-6.6456807-0.98787112-5.79251936-0.89806539h-0.7184523a15.7610404 15.7610404 0 1 1 4.49032535-31.16285466l1.7512267 0.35922615 6.46606762 1.70632345 7.36413299 2.06554959 9.4745851 3.09832401c3.45755016 1.07767767 7.09471339 2.73909786 11.00129622 4.22090571s7.85806818 3.50245343 11.98916737 5.34348668 8.2621976 4.26580823 12.43819927 6.60077743 8.2621976 4.89445399 12.21368371 7.76826164 7.90297145 5.65780956 11.62994122 8.57652048 7.27432645 6.0619382 10.50736027 9.25006952 6.28645454 6.28645454 8.9806499 9.29497202 5.34348668 6.01703494 7.54374606 8.98064988 4.17600246 5.47819647 5.83742187 7.85806818 3.09832401 4.49032457 4.49032455 6.42116513l3.23303459 5.38838916A7.40903627 7.40903627 0 0 1 801.76794215 425.53590153z" fill="#F7B523" p-id="1612"></path><path d="M174.82878647 335.23546888l103.77140711-149.39310813v-1.25729076h-94.29682126v-40.77214955h158.01453112v28.4686593L240.9263688 319.69894483v1.30219403h103.27747116v40.72724627H174.82878647zM366.65546433 241.43258282L444.56260018 129.17446178v-0.89806539H373.7501777V97.7421875H492.38455984v21.32904264L416.04903762 229.6679318v0.94296788h77.50300644v30.57911215H366.65546433zM529.51954616 252.61349135l58.37422319-84.0139781v-0.71845153H534.81812955v-22.90065706h88.90843209v15.98555675L566.60962998 243.90226106v0.71845231h58.01499626v22.90065628H529.51954616z" fill="#5FA5E1" p-id="1613"></path></svg>,
            describe: '根據您的夢境，分析當前運勢',
            example: [
              '今天夢到了去河裡游泳，然後一直上不了岸',
              '今天夢到被一隻狼追著跑',
              '今天夢到在一個孤島上，島上全是房子但是沒有人'
            ],
            presets: '使用中文語言，幫我分析問題，給出建議，'
          },
          {
            title: 'Emoji',
            icon: h => <svg t="1681973210814" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1457" width="200" height="200"><path d="M39.06666667 787.24444476C1.06666698 763.24444476-8.93333333 713.24444414 15.06666667 675.24444445L165.06666667 773.24444414c-24 37.99999969-73.99999969 48-112.00000031 24l-13.99999969-9.99999938z" fill="#FF8A14" p-id="1458"></path><path d="M929.06666636 719.24444414c0 43.99999969-36 82.00000031-81.99999938 82.00000031v-178.00000031c43.99999969 0 82.00000031 36 81.99999938 82.00000031v13.99999969z" fill="#FF8A14" p-id="1459"></path><path d="M645.06666667 345.24444445h-178.00000031l10.00000031-40.00000031c4.00000031-13.99999969 16.00000031-24 31.99999969-24H605.06666636c13.99999969 0 28.00000031 10.00000031 32.00000062 24l7.99999969 40.00000031z" fill="#ADC4D9" p-id="1460"></path><path d="M847.06666698 839.24444414c0 36-30 64.00000031-64.00000031 64.00000031H329.06666636c-36 0-64.00000031-30-63.99999938-64.00000031V621.24444445C265.06666698 459.24444445 395.06666636 329.24444414 555.06666667 329.24444414s292.00000031 130.00000031 292.00000031 292.00000031v217.99999969z" fill="#FFE500" p-id="1461"></path><path d="M555.06666667 329.24444414c-160.00000031 0-289.99999969 130.00000031-289.99999969 292.00000031v82.00000031c0-162 130.00000031-292.00000031 291.99999938-292.00000031s292.00000031 130.00000031 292.00000031 292.00000031v-82.00000031C847.06666698 459.24444445 717.06666667 329.24444414 555.06666667 329.24444414z" fill="#FFF48C" p-id="1462"></path><path d="M225.06666667 927.24444445a330 30 0 1 0 660 0 330 30 0 1 0-660 0Z" fill="#45413C" p-id="1463"></path><path d="M767.06666636 897.24444445c0 18-13.99999969 31.99999969-31.99999969 31.99999969H377.06666636c-18 0-31.99999969-13.99999969-31.99999969-31.99999969v-97.99999969c0-18 13.99999969-31.99999969 31.99999969-32.00000062h356.00000062c18 0 31.99999969 13.99999969 31.99999969 32.00000062v97.99999969z" fill="#C0DCEB" p-id="1464"></path><path d="M767.06666636 799.24444476c0-18-13.99999969-31.99999969-31.99999969-32.00000062H377.06666636c-18 0-31.99999969 13.99999969-31.99999969 32.00000062v39.99999938c0-18 13.99999969-31.99999969 31.99999969-31.99999969h356.00000062c18 0 31.99999969 13.99999969 31.99999969 31.99999969v-39.99999938z" fill="#DAEDF7" p-id="1465"></path><path d="M693.06666667 589.24444476m-90 0a90 90 0 1 0 180 0 90 90 0 1 0-180 0Z" fill="#FFFFFF" p-id="1466"></path><path d="M693.06666667 589.24444476m-31.99999969 0a31.99999969 31.99999969 0 1 0 63.99999938 0 31.99999969 31.99999969 0 1 0-63.99999938 0Z" fill="#FF6242" p-id="1467"></path><path d="M419.06666636 589.24444476m-81.99999938 0a82.00000031 82.00000031 0 1 0 163.99999969 0 82.00000031 82.00000031 0 1 0-163.99999969 0Z" fill="#FFFFFF" p-id="1468"></path><path d="M419.06666636 589.24444476m-31.99999969 0a31.99999969 31.99999969 0 1 0 64.00000031 0 31.99999969 31.99999969 0 1 0-64.00000031 0Z" fill="#6DD627" p-id="1469"></path><path d="M385.06666698 799.24444476m-8.00000062 0a7.99999969 7.99999969 0 1 0 16.00000031 0 7.99999969 7.99999969 0 1 0-16.00000031 0Z" fill="#C0DCEB" p-id="1470"></path><path d="M385.06666698 791.24444414c-4.00000031 0-7.99999969 4.00000031-8.00000062 8.00000062s4.00000031 7.99999969 8.00000062 7.99999969 7.99999969-4.00000031 7.99999969-7.99999969-1.99999969-7.99999969-7.99999969-8.00000062z" fill="#45413C" p-id="1471"></path><path d="M727.06666698 799.24444476m-8.00000062 0a7.99999969 7.99999969 0 1 0 16.00000031 0 7.99999969 7.99999969 0 1 0-16.00000031 0Z" fill="#C0DCEB" p-id="1472"></path><path d="M727.06666698 791.24444414c-4.00000031 0-7.99999969 4.00000031-8.00000062 8.00000062s4.00000031 7.99999969 8.00000062 7.99999969 7.99999969-4.00000031 7.99999969-7.99999969-4.00000031-7.99999969-7.99999969-8.00000062z" fill="#45413C" p-id="1473"></path><path d="M735.06666667 61.24444476m-40.00000031 0a40.00000031 40.00000031 0 1 0 80.00000062 0 40.00000031 40.00000031 0 1 0-80.00000062 0Z" fill="#FF6242" p-id="1474"></path><path d="M847.06666698 621.24444445v40.00000031c40.00000031 0 73.99999969 30 79.99999969 67.99999969 0-4.00000031 1.99999969-7.99999969 1.99999969-12v-16.00000031c0-43.99999969-36-79.99999969-81.99999938-79.99999969z" fill="#FFAA54" p-id="1475"></path><path d="M13.06666698 679.24444476c0 30 16.00000031 60 45.99999938 79.99999969l16.00000031 10.00000031c28.00000031 18 60 19.99999969 85.99999969 12l6-6-150-98.00000062c-4.00000031 0-4.00000031 0-3.99999938 2.00000062z" fill="#FFAA54" p-id="1476"></path></svg>,
            describe: '把您想發的內容，添加有趣的Emoji表情',
            example: [
              '你好',
              '周圍全是樹',
              '我生氣了'
            ],
            presets: '使用中文語言，不管我直接來說的什麼，都給我翻譯成Emoji表情，'
          },
          {
            title: 'AI回復',
            icon: h => <svg t="1681962929691" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3447" width="200" height="200"><path d="M918.016 189.44h-340.992c-32.768 0-59.904 26.624-59.904 59.904V757.248L642.048 650.24h275.968c32.768 0 59.904-26.624 59.904-59.904v-340.992c0-33.28-26.624-59.904-59.904-59.904z" fill="#09435B" p-id="3448"></path><path d="M439.296 261.12h-351.232C53.76 261.12 25.6 289.28 25.6 323.584v351.232c0 34.304 28.16 62.464 62.464 62.464h270.848L501.76 859.648V323.584c0-34.304-28.16-62.464-62.464-62.464z" fill="#FACC39" p-id="3449"></path><path d="M430.08 415.232c0 11.264-9.216 19.968-19.968 19.968H148.48c-11.264 0-19.968-9.216-19.968-19.968V404.48c0-11.264 9.216-19.968 19.968-19.968h261.632c11.264 0 19.968 9.216 19.968 19.968v10.752zM430.08 522.752c0 11.264-9.216 19.968-19.968 19.968H148.48c-11.264 0-19.968-9.216-19.968-19.968V511.488c0-11.264 9.216-19.968 19.968-19.968h261.632c11.264 0 19.968 9.216 19.968 19.968v11.264zM270.848 609.28c0 11.776-8.192 25.6-18.944 25.6h-118.272c-10.24 0-18.944-13.824-18.944-25.6s8.192-25.6 18.944-25.6h118.272c10.24 0 18.944 13.824 18.944 25.6z" fill="#09435B" p-id="3450"></path><path d="M885.76 328.192c0 11.264-9.216 19.968-19.968 19.968H599.04c-11.264 0-19.968-9.216-19.968-19.968V322.56c0-11.264 9.216-19.968 19.968-19.968h266.752c11.264 0 19.968 9.216 19.968 19.968v5.632zM885.76 435.712c0 11.264-9.216 19.968-19.968 19.968H599.04c-11.264 0-19.968-9.216-19.968-19.968V430.08c0-11.264 9.216-19.968 19.968-19.968h266.752c11.264 0 19.968 9.216 19.968 19.968v5.632zM732.16 527.36c0 8.704-6.656 15.36-15.36 15.36h-122.88c-8.704 0-15.36-6.656-15.36-15.36s6.656-15.36 15.36-15.36h122.88c8.704 0 15.36 6.656 15.36 15.36z" fill="#FACC39" p-id="3451"></path></svg>,
            describe: '和人聊天不會回復，用AI幫您',
            example: [
              '你好',
              '幫我一個忙吧',
              '給我帶一份飯'
            ],
            presets: '使用中文語言，根據對方說的話，寫一份高情商回復，顯得你幽默健談，對方說：'
          }
        ]
      }
      // {
      //   group: '其他應用',
      //   type: 'flex',
      //   list: [
      //     {
      //       title: 'AI繪畫',
      //       icon: h => null,
      //       describe: '快速地生成逼真的畫作，無需手動繪製。 基於人工智慧科技，AI繪畫算灋可以生成更多樣化、有創意的畫作。 通過AI繪畫工具輕鬆地探索和實踐繪畫技巧，提高自己的創作水准。',
      //       example: [
      //         '計算機科學，文章類型：論文，文章要求：字數1500字，參考文獻數量5條',
      //         '生物學，文章類型：實驗報告，文章要求：字數1500字，參考文獻數量3條',
      //         '文學，文章類型：綜述，文章要求：字數1500字，參考文獻數量10條'
      //       ],
      //       presets: '使用中文語言，根據以下要求生成學科文章.'
      //     }
      //   ]
      // }
    ],
    chatroom: '聊天室',
    use: '使用'
  },
  PCUserCenter: {
    setUp: {
      h2: '設備設定',
      span: '外觀',
      lang: '語言',
      li: ['深色主題', '亮色主題'],
      ser: '聯絡客服'
    },
    userAvatar: {
      avatar: '更換頭像',
      userName: '暱稱',
      revise: '修改',
      userId: '賬號ID',
      package: '當前套餐',
      expire: '到期時間',
      rights: '更多權益',
      password: '初始密碼'
    },
    pop: {
      userName: '修改用戶名',
      avatar: '頭像設置',
      name: '在這裡修改暱稱',
      yes: '確定',
      no: '取消',
      upload: '重新上傳',
      i: '請輸入使用者名稱',
      c: '昵稱長度請設置在 1 到 20 位以內的字節',
      o: '請輸入漢字或字母或數字或組合'
    },
    uploads: [
      '上傳失敗',
      '上傳成功',
      '請輸入使用者名稱',
      '使用者名稱修改成功',
      '上傳頭像圖片只能是 JPG 或 png 格式！',
      '上傳頭像圖片大小不能超過2MB'
    ],
    header: {
      alt: '頭像',
      i: '（每天可問3個問題）',
      p: '初始密碼：123456'
    },
    invite: [
      '邀請連結',
      '複製連結',
      '複製以上連結，分享給好友註冊，免費用戶每次會新增',
      '次免費提問次數，VIP用戶自動贈送',
      '天'
    ],
    addInformation: {
      h2: '完善資訊，防止密碼丟失',
      span: [
        '手機號',
        '郵箱'
      ],
      placeholder: [
        '手機號',
        '驗證碼',
        '郵箱'
      ],
      btns: [
        '發送驗證碼',
        '保存'
      ]
    },
    setPass: {
      h2: '修改密碼',
      span: [
        '原密碼',
        '新密碼',
        '確認密碼'
      ],
      btn: '確認修改',
      logOff: [
        '註銷帳號',
        'VIP過期後，或者待帳戶裏的充值餘額用完，才能',
        '註銷帳戶'
      ]
    },
    confirPassword: {
      h1: '註銷密碼確認框',
      span: '密碼',
      btns: [
        '取消',
        '確定'
      ]
    },
    message: [
      '郵箱不能為空',
      '手機不能為空',
      '驗證碼為空',
      '提交成功',
      '請將資訊填寫完畢（三項都為必填項）',
      '密碼修改成功',
      '手機號格式不正確！',
      '郵箱格式不正確！',
      '驗證碼已發送至您的郵箱，請接收',
      '驗證碼已發送至您的手機，請接收',
      '已複製到剪切板，現在去分享給您的好友吧',
      '註銷成功'
    ],
    input: '火遍全球的chat智能助手機器人，網站：'
  },
  PCHelpCenter: {
    title: '您可能關心的問題：',
    collapse: {
      title: [
        '我的資料安全嗎？',
        '我為什麼要付費才能使用VIP的套餐？',
        '我的權益能得到保障嗎？',
        '付費成功，卻沒有成功升級到VIP怎麼辦？',
        '我以前是VIP，現在怎麼又變成免費套餐了？',
        '我是VIP用戶，在微信小程式登入變成了免費套餐用戶？'
      ],
      p: [
        '我們深知數據和隱私安全對您的重要性，我們已經充分考慮到了這點，作為用戶和合作方之間的橋樑，我們的服務器不存儲您的聊天數據，您所有的聊天記錄只存在您的設備中，資料傳輸的過程採用https（ssl）加密傳輸協定； 用戶註冊過程只要求提供最低限度必要的資料，並且採取了嚴格的安全管理措施，任何人都無法獲取您的數據。',
        '由於API是收費的，計費方式是按照Token數量（約等於聊天字數）計費，我們嚴格遵循API的規範，從正規付費通路對接官方的API服務，存在較大的運營成本，為了能够長期運營下去，無法提供完全的免費服務，希望盡我們所能，充分考慮用戶的承受能力和自身的成本風險， 讓大多數用戶以較低的費用享受到便捷高質的AI服務。',
        '在科技上，我們力求做到極致，盡可能與官網的體驗保持一致並加以創新。 流程上，我們確保每一個環節都是合法合規的，包括與合作方的合作對接、網站的備案、支付的流程，以及客服流程，嚴格遵循必要的規範和法律法規，確保提供長期有效的服務。',
        '支付前請您仔細查看VIP會員的權益，如果確定付費後沒有成功升級到相應的VIP級別，請您聯繫我們的客服人員幫助解決，客服人員會幫您解決遇到的問題。',
        '出現這種情況，一般來說有兩種可能：第一種情况：您以前購買了包周或包月VIP，但是您的VIP過期了，需要續費。第二種情况：之前使用郵箱登錄，後面是用google或Apple賬號登入，或者點擊了一鍵註冊登入，後面兩種情况都會自動註冊一個新用戶，需要切換到原來的帳號，如果您忘記了原來的帳號密碼，請聯系客服協助您找回。',
        '首次進入微信小程式，並不會自動登錄您在網頁版本註冊的帳號，而是自動註冊了一個新用戶，您需要在小程式首頁點擊“用戶中心”，然後點擊“切換帳號密碼登入”，重新登入到您網頁版本的VIP帳號。'
      ]
    },
    footerBox: {
      guide: [
        '為了方便您以後能找到我們的網站，請按',
        // '收藏本站，或者下載',
        '收藏本站',
        '快捷方式檔案',
        '拖至案頭'
      ],
      alt: '快捷方式',
      title: '下載',
      footerLeft: {
        h2: '聯繫我們',
        btn: '線上客服（點擊諮詢）',
        p: [
          'QQ號',
          '郵箱',
          '關注我們'
        ]
      },
      imgRight: {
        span: '客服微信'
      }
    }
  },
  PCUpgradeService: {
    upgradeCenter: {
      h1: 'VIP套餐',
      p: [
        '3.5无限制',
        '支持GPT 3.5和4.0',
        '優良的架構和低延遲',
        '$',
        ' / day'
      ],

      btn: '立即購買',
      subscript: [
        '老用戶有額外折扣',
        '最多人購買，限時特惠！'
      ],
      remind: [
        '支付完成，帳號卻沒有升級為VIP，請刷新頁面試試，如果仍有問題請',
        '聯繫我們'
      ],
      noticeInterests: [
        '如果您有什麼疑問，請隨時',
        '聯繫我們',
        '權益須知'
      ]
    },
    tabbar: {
      bubble: '限時開放',
      title: [
        'VIP 套餐',
        'SVIP 套餐'
      ],
      span: [
        '極致性價比!',
        '至尊權益!'
      ]
    },
    svip: {
      lo: '600/月,20/天',
      p: [
        '更多或無限的GPT-4使用額度',
        '更好的客服支援',
        '更快的響應速度'
      ],
      discount: [
        '每天僅需',
        '元'
      ],
      buy: '立即購買',
      mark: '活動特價，限時優惠！',
      tip: {
        h1: '溫馨提醒 !',
        p: '套餐升級成功後原有VIP權益將會被替換為新的SVIP權益，有效日期依SVIP權益從目前日期開始重新開始計算。',
        confirm: '確定',
        cancel: '取消'
      },
      right: {
        h1: '權益須知',
        p: '感謝您選擇本公司產品',
        ol: [
          '基於虛擬產品的性質與特徵，您所取得的虛擬產品不能夠進行退貨、換貨、兌換現金，亦不得用於商業領域，如買賣、置換、抵押等。',
          '扣款成功即刻生效，若未即刻生效，請稍候或聯絡客服以取得協助。',
          '在高峰時期，由於AI需要大量運算資源，可能會出現服務波動，請諒解。',
          'VIP用戶可以無限次、不限字數地使用3.5版本，我們承諾保證這項權益的延續性，即使未來發生變化，也會以更優的版本或服務進行取代。',
          'SVIP在VIP原有優惠的基礎上將獲得更多的4.0次數和繪畫次數的使用體驗，請依照需求選擇適合的套餐。',
          'VIP升級SVIP成功的用戶，原有的權益將會被替換為新的SVIP權益，有效日期依照SVIP權益從目前日期開始重新開始計算。',
          '為保護多數使用者的權益，嚴厲禁止濫用我們的服務，包括利用我們的服務從事非法、違反公序良俗的活動，以程序操控、破解方式使用我們的服務。 一旦發現，我們將立即停用帳號並不退還費用。 涉嫌違法犯罪行為的，同時將報警處理。',
          '在法律範圍內，我們公司對本產品享有最終解釋權，感謝您的理解'
        ],
        btn: '我已知曉',
        discount: 'VIP 升級折扣說明'
      },
      table: {
        head: [
          '套餐專屬權益',
          '• 權益',
          '可用模型',
          '可用次數',
          '回覆字數',
          '客服級別',
          '4.0次數',
          '月',
          '天'
        ],
        name: [
          '一年,兩年SVIP',
          '半年SVIP',
          '兩年VIP',
          'VIP',
          '免费用户'
        ],
        customer: [
          '標準服務',
          'VIP專屬',
          'SVIP專屬'
        ],
        model: [
          '全部',
          '無限制',
          '無'
        ],
        count: [
          '4.0無限',
          '/每天',
          '/每次',
          '贈送',
          '次',
          '/月',
          '/天'
        ]
      }
    },
    help: {
      question: [
        '普通VIP',
        '升級到SVIP政策',
        '如果您有什麼疑問，請隨時',
        '聯絡我們',
        '權益須知',
        '付款完成，帳號沒有升級為VIP,請刷新頁面試試，如果任有問題請聯絡我們'
      ]
    },
    upgradeAlways: {
      p: '您已經是終身會員，無需再升級服務',
      noticeInterests: [
        '如果您有什麼疑問，請隨時',
        '聯繫我們',
        '權益須知'
      ]
    },
    dialog: {
      title: '權益須知',
      p: [
        '1.會員權益為虛擬服務，套餐開通成功後不可退換，敬請諒解。',
        '2.扣款成功即刻生效，若未即刻生效，請稍等幾分鐘或聯系客服獲取幫助。',
        '3.在高峰時期，由於AI需要大量計算資源，可能會出現服務波動，請諒解。',
        '4.VIP用户可以无限次、不限字数地使用3.5版本，我们承诺保证这一权益的延续性，即使未来发生变化，也会以更优的版本或服务进行取代。',
        '5.由於4.0版本的资源限制，囙此VIP用戶每天將限制請求對話',
        '次（永久vip',
        '次），該次數未來將根據OpenAI的政策和我司的運營決策進行調整或取消限制。',
        '6.為保護大多數用戶的權益，嚴厲禁止濫用我們的服務，包括利用我們的服務從事非法、違反公序良俗的活動，以程式操控、破解管道使用我們的服務。 一旦發現，我們將立即禁用帳號並不退還費用。 涉嫌違法犯罪行為的，同時將報警處理。',
        '7.在法律範圍內，我們公司對本產品享有最終解釋權，感謝您的理解。'
      ],
      btn: '我已知曉'
    }
  },
  PCVipCard: {
    card: {
      expireTime: '有效期限',
      permanently: '永久有效',
      orangeCount: 'GPT-4 增强额度(次数)',
      drawCount: '繪畫次數',
      time: '個',
      count: '次',
      rightTitle: '每日權益'
    },
    btn: '去升级获得更多权益',
    vip: [
      '取消訂閱',
      '立刻體驗'
    ]
  },
  PCAboutUs: {
    illustrate: {
      // h1: '關於我們',
      span: [
        'Suntube-AI 人機對話應用',
        '特色功能',
        '用戶體驗',
        '成本優勢',
        '我們的宗旨'
      ],
      pBox: [
        'Suntube-AI 是一款優秀的人機對話應用，基於多個全球領先的大型語言模型開發，包括 ChatGPT、ChatMM 等。該應用旨在為用戶提供領先的對話體驗。',
        '完全支持 ChatGPT 官方所有功能，包括最新模型更新、繪畫創作和圖片理解能力。',
        'Suntube-AI 在保持技術先進性的同時，注重用戶體驗。其介面設計簡潔直觀，使用戶註冊和使用過程變得極為簡單，操作流暢自然。穩定性和便捷性的顯著提升確保用戶在任何場景下都能享受流暢、無縫的交流體驗。',
        '除了技術和用戶體驗，Suntube-AI 在成本控制方面也具有顯著優勢，使其成為更具性價比的選擇。不論是個人用戶還是企業客戶，都能從這款高效、經濟的人機對話應用中獲益。',
        '我們的宗旨是普及 AI 應用，讓 AI 與普通用戶零距離接觸，為個人帶來幫助和效益。我們堅持為用戶提供全新、定制化的交流體驗。',
        '針對非專業用戶的獨特需求和使用習慣進行了深度定制和優化。'
      ]
    },
    product: {
      h6: '聯繫我們',
      span: [
        '電話',
        '電子郵箱',
        '地址'
      ],
      // p: 'UNIT 1804 SOUTH BANK TOWER, 55 UPPER GROUND,LONDON，ENGLAND SE1 9EY',
      p: '英国伦敦上城55号南岸大厦1804室',
      em: '我們期待您的來信'
    }
  },
  PCLogin: {
    tabbar: {
      login: '登入',
      signUp: '註冊',
      return: '返回'
    },
    otherLogin: '或其他方式登入',
    ol: ['使用Google繼續', '使用Apple繼續', '使用賬號密碼登入', '返回'],
    signIn: {
      h1: '歡迎，讓我們開始吧',
      label: [
        '帳號',
        '密碼'
      ],
      placeholder: '帳號/手機號/郵箱',
      a: '忘記密碼？',
      btn: '登入',
      p: [
        '沒有帳號？',
        '點擊註冊'
      ],
      signRules: [
        '請輸入您的帳號',
        '帳號長度為3-40位數',
        '請輸入您的密碼',
        '密碼長度為6-20位數'
      ]
    },
    register: {
      h1: '你好，讓我們開始建立帳戶吧',
      label: [
        '帳號',
        '密碼',
        '驗證碼',
        '邀請碼'
      ],
      placeholder: [
        '請輸入3-40比特字母數位，建議用手機號或郵箱',
        '長度限制為6-20比特',
        '可以為空'
      ],
      prompt: '看不清楚？ 點擊圖形碼換一張',
      btn: '註冊',
      p: [
        '有帳號？',
        '點擊登入'
      ],
      regRules: [
        '帳號不能為空',
        '帳號長度為3-40位數',
        '密碼不能為空',
        '密碼長度為6-20位數',
        '圖形碼不能為空'
      ]
    },
    retrievePassword: {
      h1: '找回密碼',
      label: [
        '手機/郵箱',
        '驗證碼'
      ],
      title: '發送驗證碼',
      btn: '下一步',
      p: [
        '有帳號？',
        '點擊登入'
      ],
      retRules: [
        '手機/郵箱不能為空',
        '請填寫正確的郵箱格式格式！',
        '請填寫正確的手機號格式！',
        '驗證碼不能為空'
      ]
    },
    setPassword: {
      h1: '設定新密碼',
      h3: '帳戶名稱',
      label: [
        '新密碼',
        '確認密碼'
      ],
      btn: '確認',
      setRules: [
        '密碼不能為空',
        '密碼長度為6-20位數',
        '兩次密碼輸入不一致'
      ]
    },
    confirmationBox: {
      btn: '確定'
    },
    messageTxt: [
      '註冊成功',
      '密碼修改成功',
      '登入中...'
    ],
    message: '發送成功，請注意查收'
  },
  PCCloudLoading: {
    txt: '雲端上傳中…'
  },
  PCChatOrange: {
    buttonName: '確定',
    Warning: '此商品僅限VIP用戶在4.0模型中使用，非VIP用戶暫時無法購買！',
    back: '返回',
    orange: {
      title: [
        '額外加油包',
        '額外次數增强包，給你的次數加個油'
      ],
      list: {
        span: '請選擇您想要的服務',
        left: [
          '次',
          '1桔子/每次'
        ],
        right: [
          '個',
          '立省',
          '$'
        ]
      },
      explain: [
        '桔子次數使用說明',
        '“桔子次數套餐“專為頻繁使用4.0模型的用戶設計。當您的4.0模型每日免費次數用盡後，您可以購買此套餐，繼續享受4.0模型的服務。每次提問將自動扣除一個”桔子”，未使用的“桔子”將永久保存在您的帳戶中， 且”桔子“數量沒有上限，桔子的使用次數不可退還或轉移給他人。請注意，官方每日免費次數用盡，使用4.0模型時，才消耗桔子次數'
      ],
      pay: {
        title: '桔子數量',
        buleText: '桔子使用記錄',
        p: [
          '當前桔子數量為',
          '個'
        ],
        ul: [
          '下單桔子數量',
          '商品原價',
          '優惠抵扣',
          '實際支付'
        ],
        btn: '支付訂單'
      }
    },
    recode: {
      back: '返回',
      recodeBox: {
        span: '桔子使用記錄',
        sort: '分類',
        time: [
          '時間',
          '全部',
          '至',
          '開始日期',
          '結束日期',
          '常見問題'
        ],
        table: [
          '分類',
          '時間',
          '內容',
          '桔子數量'
        ]
      }
    },
    sortObj: {
      0: '全部',
      1: '獲取',
      2: '使用'
    },
    message: [
      '請先升級會員',
      '支付成功'
    ],
    sort: [
      '獲取',
      '使用'
    ],
    textContent: '選擇'
  },
  PCPluginDetails: {
    alt: '圖標',
    headerTaber: [
      '使用',
      '訂閱',
      '設定'
    ],
    title: '關閉',
    useItem: {
      onTrial: [
        '當前無可用時長，新用戶可',
        '點擊這裡領取',
        '7天免費體驗',
        '7天免費體驗已領取成功！'
      ],
      payAfter: [
        '套餐類型',
        '免費體驗',
        '到期時間',
        '如需延長使用期可',
        '點擊前往訂閱',
        '購買'
      ],
      becomeDue: [
        '免費體驗已到期',
        '如需延長使用期可',
        '點擊前往訂閱',
        '購買'
      ]
    },
    subscribeItem: {
      payDetails: {
        h1: '套餐簡介：',
        placeholder: '選擇套餐',
        payPrice: [
          '購買時長',
          '天',
          '到期時間',
          '--年--月--日',
          '優惠金額',
          '還需支付',
          '支付'
        ]
      },
      payWay: {
        p: [
          '借記卡和信用卡（Visa、MasterCard、銀聯、JCB…）',
          '+客人信用卡付款'
        ],
        btn: [
          '付款',
          '支付'
        ],
        successPay: {
          alt: '購買完成',
          h4: '購買成功！',
          p: '後自動關閉'
        }
      }
    },
    setUpItem: {
      leftSetUp: [
        '啟用自動備份',
        '備份時間間隔',
        '分鐘',
        '自動備份只同步新增聊天內容'
      ],
      rightConfirm: [
        '重新備份',
        '下載/恢復',
        '保存設定'
      ],
      warnCover: {
        h1: '此操作會覆蓋雲端聊天記錄！ 確認覆蓋？',
        btns: [
          '取消',
          '確認'
        ]
      }
    },
    subscriptType: [
      '免費',
      '未訂閱',
      '已訂閱'
    ],
    date: [
      '年',
      '月',
      '日'
    ],
    message: [
      '支付成功',
      '上傳失敗！！！ 請重新上傳',
      '聊天記錄備份成功',
      '聊天記錄恢復成功.',
      '聊天記錄恢復失敗.',
      '設定成功'
    ]
  },
  PCPayPopup: {
    selectWay: {
      h1: '付款方式',
      p: [
        '借記卡和信用卡（Visa、MasterCard、銀聯、JCB…）',
        '+客人信用卡付款',
        '這種方式僅支持人民幣支付',
        '支持信用卡和借記卡（可透過Stripe客戶門戶的「設置」來取消或管理您的訂閱）'
      ],
      btn: '確認'
    },
    order: {
      title: '支付方式',
      origin: '原價',
      discount: '折扣',
      total: '還需支付',
      amount: '訂單金額',
      tip: '請注意：我們根據套餐時長收取一次性費用，而不是按月計費。在了解這一點後，請在下方選擇您首選的付款方式。',
      declare: '支付金額完全受套餐價格和匯率的影響。在將美元兌換為人民幣時，計算基於最近的平均匯率。',
      scan: '掃描條碼進行支付',
      buyvip: '訂閱專業版即可立即獲得全部功能權限，包括更多 GPT-4 使用額度。'
    },
    form: '支付',
    title: '關閉',
    paySuccess: {
      h1: '購買成功！',
      p: [
        '次數限制',
        '無限制',
        '回復限制',
        '無限制',
        '4.0可使用'
      ],
      btn: '去綁定郵箱',
      span: '關閉'
    },
    wait: {
      h1: '支付验证',
      p: '受網絡影響權益到賬可能會稍有延遲，請耐心等待'
    },
    tip: {
      text: '您目前已經是兩年會員，是否繼續購買？',
      confirm: '確認',
      cancel: '取消'
    },
    message: '支付成功'
  },
  PCDocumentParsing: {
    documentUpload: {
      h1: '拖拽檔案到這裡上傳',
      h4: '建議上傳PDF檔案，也可上傳WORD（DOC、DOCX格式）',
      upload: {
        text: '文件大小不超過2M，數量限制1頁',
        btn: '點擊上傳'
      }
    },
    documentPreview: {
      h1: '內容識別'
    },
    message: [
      '文檔格式不正確！',
      '上傳檔案大小不能超過2MB！'
    ]
  },
  PCImageOcr: {
    upload: {
      title: [
        '拖拽',
        '到這裡上傳'
      ],
      span: '可上傳格式為JPG、JPEG、PNG、BMP',
      uploadText: '文件上傳大小不超過4M',
      btn: '點擊上傳',
      copy: '粘貼'
    },
    ocr: {
      title: '檔案資訊',
      p: [
        '檔案名稱：',
        '檔案格式：',
        '文件大小：'
      ],
      span: '您可在右側編輯方塊內對識別的內容進行編輯',
      content: {
        title: '識別',
        mark: '文字識別中請稍後',
        btnlist: [
          '重新選擇',
          '確認發送'
        ]
      }
    },
    title: [
      '文字',
      '表格',
      '試題'
    ],
    message: [
      '請粘貼圖片檔案',
      '請上傳正確的圖片格式',
      '圖片大小超過',
      '上傳失敗，請重新選擇'
    ]
  },
  PCNetworkSearch: {
    title: [
      '引擎搜尋中',
      '引擎搜尋完成'
    ],
    searchResult: {
      span: [
        '內容來自：',
        '內容引用：',
        '重點詞彙：'
      ]
    }
  },
  PCNoviceGuide: {
    guide1: {
      h1: 'Hi！ 歡迎您的到來',
      p: [
        '點擊',
        '進入新手引導',
        '，10秒搞定ChatAI，輕鬆上手，快速使用！ 快來體驗吧！'
      ],
      btns: [
        '跳過',
        '進入教程'
      ]
    },
    guide2: {
      h1: '創建聊天室',
      p: '在這裡您可以輕鬆地創建一個新的聊天室，點擊“新建聊天室”按鈕，您將會被帶到新創建的聊天室中以便您開始新的對話或者話題。',
      footer: {
        span: '跳過',
        btn: '下一步'
      }
    },
    guide3: {
      h1: '管理聊天室',
      p: '在這裡您可以按一下進入對應的聊天室以繼續上一次的會話內容。 還可以對需要管理的聊天室進行相應的操作，如重命名、删除和篩選等。',
      footer: {
        span: '跳過',
        btn: '下一步'
      }
    },
    guide4: {
      h1: '開始對話',
      p: '在我們的聊天室中，您可以通過點擊輸入框並輸入您想要發送的內容來發送消息。 當您輸入完畢後，可以點擊“發送”按鈕，或者直接按回車鍵，即可將消息發送到聊天室中。',
      footer: {
        span: '跳過',
        btn: '完成'
      }
    }
  },
  YDLogin: {
    signIn: {
      h1: [
        'ChatAI',
        '歡迎登錄'
      ],
      h4: '神奇體驗，您的私人智能助手.'
    },
    register: {
      h1: [
        'ChatAI',
        '立即註冊'
      ],
      h4: '高效溝通，開啟一場智慧旅途'
    },
    retrievePassword: {
      h1: '找回密碼',
      h4: '別著急，按流程找回您的密碼'
    },
    resetPassword: {
      h1: '重置密碼',
      h4: '設定一個您能記住的新密碼哦~'
    },
    loading: '登入中…'
  },
  YDSignIn: {
    log: '登入',
    sig: '註冊',
    ol: [
      '歡迎，',
      '讓我們開始吧！',
      '你好，新用戶，',
      '讓我們開始創建賬戶吧！'
    ],
    label: [
      '賬戶',
      '密碼'
    ],
    placeholder: '帳號/手機號/郵箱',
    a: '忘記密碼？',
    btns: [
      '登入',
      '註冊'
    ],
    p: '新用戶一鍵註冊',
    popup: {
      h1: '請記住您的帳號！',
      span: [
        '帳號',
        '密碼',
        '入口'
      ],
      p: [
        '您可以在用戶中心修改密碼',
        '強烈建議'
      ],
      i: '截圖保存。',
      btn: '確定'
    },
    dialog: {
      title: '一鍵註冊',
      label: '驗證碼',
      btns: [
        '取消',
        '確定'
      ]
    },
    signRules: [
      '請輸入您的帳號',
      '帳號長度為3-40位數',
      '請輸入您的密碼',
      '密碼長度為6-20位數'
    ]
  },
  YDRegister: {
    label: [
      '賬戶',
      '密碼',
      '驗證碼'
    ],
    prompt: '看不清楚？ 點擊圖形碼換一張',
    span: '邀請碼',
    placeholder: '無',
    btn: '註冊',
    regRules: [
      '帳號不能為空',
      '帳號長度為3-40位數',
      '密碼不能為空',
      '密碼長度為6-20位數',
      '驗證碼不能為空'
    ],
    alert: '註冊成功，點擊“確定”登入'
  },
  YDForgotPassword: {
    label: [
      '手機號/郵箱',
      '驗證碼'
    ],
    btn: ['發送', '下一步'],
    retRules: [
      '手機/郵箱不能為空',
      '請填寫正確的郵箱格式格式！',
      '請填寫正確的手機號格式！',
      '驗證碼不能為空'
    ],
    message: '發送成功，請注意查收'
  },
  YDSetPassword: {
    h3: '帳戶名稱',
    label: [
      '新密碼',
      '確認密碼'
    ],
    btn: '確認',
    setRules: [
      '密碼不能為空',
      '密碼長度為6-20位數',
      '兩次密碼輸入不一致'
    ]
  },
  YDHome: {
    importNotice: '重要通知：',
    tabbar: [
      'AI 聊天',
      '應用場景',
      '我的'
    ]
  },
  YDUserCenter: {
    me: '我',
    leftText: {
      h1: '邀請連結：',
      p: [
        '複製以上連結，分享給好友註冊，免費用戶每次會新增',
        '次免費體驗次數，VIP用戶自動贈送',
        '天'
      ],
      btn: '複製'
    },
    group: {
      fuzhi: '複製連結給朋友',
      title: [
        '帳戶名',
        '修改密碼',
        '當前套餐',
        'VIP到期時間',
        '手機號',
        '郵箱',
        '註銷帳號'
      ],
      value: [
        '未綁定',
        '待帳戶裏的充值餘額用盡，可選擇註銷'
      ]
    },
    btn: '返回',
    setPassword: {
      label: [
        '原密碼',
        '新密碼',
        '確認密碼'
      ],
      placeholder: [
        '請輸入密碼',
        '請輸入新密碼',
        '請輸入確認密碼'
      ],
      btn: '確認修改',
      a: '返回'
    },
    dialogOne: {
      h1: [
        '綁定以下手機號碼',
        '輸入驗證碼'
      ],
      errorMessage: '請輸入正確的手機格式！',
      btns: [
        '取消',
        '發送驗證碼',
        '確定'
      ]
    },
    dialogTwo: {
      h1: [
        '綁定以下郵箱',
        '輸入驗證碼'
      ],
      errorMessage: '請輸入正確的郵箱格式！',
      btns: [
        '取消',
        '發送驗證碼',
        '確定'
      ]
    },
    dialogThree: {
      h1: '註銷確認密碼',
      i: '密碼',
      p: '註銷以後帳號將被删除，謹慎使用！！！',
      btns: [
        '取消',
        '確認'
      ]
    },
    value: '火遍全球的chat智能助手機器人，網站：',
    message: [
      '已複製到剪切板，現在去分享給您的好友吧',
      '密碼修改成功',
      '驗證碼已發送至您的郵箱，請接收',
      '驗證碼已發送至您的手機，請接收',
      '綁定成功',
      '註銷成功'
    ],
    passMessage: [
      '請填寫6-20比特密碼',
      '兩次密碼輸入不一致'
    ]
  },
  YDDetail: {
    example: '示例',
    placeholder: '請輸入內容',
    requestbox: '生成內容',
    bottom: [
      '複製內容',
      '停止回復'
    ],
    output: [
      '字數超出限制',
      '當前服務器正忙',
      '，請您重新發送您的問題',
      '用戶次數已用盡，請升級當前的服務，我們會提供更優質的服務，或者邀請好友，新增免費提問次數.',
      '當前服務器正忙，請您重新發送您的問題.',
      '回答出現錯誤，請重新提問',
      '用戶chat-4.0次數不足.',
      '對不起，當前聊天人數較多，請稍後重試',
      '網絡好像有點問題',
      '請聯系客服，或切換網絡試試，例如關閉wifi，或連接別的wifi網絡',
      '聊天太頻繁，請稍候再試'
    ],
    message: [
      '你的帳號在其他設備登入，請重新登入.',
      '已複製到剪切板'
    ]
  },
  YDSelectModel: {
    title: '提示',
    p: [
      '由於OpenAI對4.0現時仍然是限制使用，為了防止API被濫用，VIP用戶每天將限制請求對話',
      '次（永久vip',
      '次），該次數未來將隨OpenAI的政策和我司的運營決策進行調整或取消限制。'
    ],
    message: [
      '4.0暫時只對VIP用戶開放，現在去升級VIP？',
      '3.5-turbo暫時只對VIP用戶開放，現在去升級VIP？'
    ]
  },
  YDMineModule: {
    alt: '頭像',
    userInfo: [
      'VIP過期時間',
      '還可使用',
      '次',
      '單條字數限制',
      '字',
      '每日免費額度',
      '次'
    ],
    inviteLink: {
      h1: '邀請連結：',
      p: [
        '複製以上連結，分享給好友註冊，免費用戶每次會新增',
        '次免費體驗次數，VIP用戶自動贈送',
        '天'
      ],
      btn: '複製'
    },
    title: [
      '用戶資訊',
      '聯繫我們',
      '關於ChatAI',
      '常見問題',
      '最新公告'
    ],
    value: '火遍全球的chat智能助手機器人，網站：',
    message: '已複製到剪切板，現在去分享給你的好友吧'
  },
  YDChat_room: {
    voice: '聲音',
    lang: '語言',
    help: '幫助',
    shezhi: '設置',
    alt: '頭像',
    textRight: [
      '今日可提問：',
      '無限制',
      '次',
      '單次回復：',
      '無限制',
      '字',
      'VIP到期時間'
    ],
    addRoom: '新建聊天室',
    btnTxt: '删除',
    ribbon: [
      '用戶中心',
      '客服中心',
      '升級服務',
      '點擊創建桌面圖示',
      '關於ChatAI',
      '退出'
    ],
    popupOne: {
      title: 'VIP升級成功',
      bindTip: [
        '為保障您的權益',
        '請綁定手機號或郵箱。 綁定手機或郵箱後，以後可以使用手機號或郵箱登錄、找回帳號和密碼。'
      ],
      bindTitle: [
        '手機號',
        '郵箱'
      ],
      bindboxOne: {
        placeholder: [
          '請輸入手機號',
          '請輸入驗證碼'
        ],
        btn: '立即綁定'
      },
      bindboxTwo: {
        placeholder: [
          '請輸入郵箱',
          '請輸入驗證碼'
        ],
        btn: '立即綁定'
      }
    },
    popupTwo: {
      span: '手機號綁定成功！',
      btns: [
        '下次再說',
        '去綁定郵箱'
      ]
    },
    popupThree: {
      span: [
        '您方便的時候仍然可以在',
        '用戶中心',
        '綁定手機號或郵箱。'
      ],
      btn: '我已知曉'
    },
    initialList: [
      {
        iClass: 'icon-taiyangtianqi',
        span: '提問示例',
        textList: [
          '“唱歌跑調可以是一種病？”',
          '“幫我寫一篇科幻類文章的大綱”',
          '“修正一下我的程式碼”'
        ],

        type: 'click'
      },
      {
        iClass: 'icon-shandian',
        span: 'AI能力',
        textList: [
          '能記住對話過程中，前面提過的內容',
          '支持用戶提供後續更正',
          '懂得拒絕不合理的提問'
        ]
      },
      {
        iClass: 'icon-weixian',
        span: '能力限制',
        textList: [
          '回答中偶爾會有事實性錯誤',
          '可能會出現有偏見或歧視性回答',
          '對2021年以後的事瞭解有局限'
        ]
      }
    ],
    codeText: [
      '發送驗證碼',
      '重新發送'
    ],
    mobileValid: [
      '請輸入手機號',
      '手機號格式不正確',
      '手機號不能為空'
    ],
    emailValid: [
      '請輸入郵箱',
      '郵箱格式不正確',
      '郵箱不能為空'
    ],
    notify: [
      '驗證碼已發送至您的',
      '手機',
      '郵箱',
      '，請接收',
      '郵箱綁定成功'
    ],
    codeValid: '驗證碼不能為空'
  },
  YDNotice: {
    title: '最新公告',
    noData: '暫無最新消息',
    scrollNotice: [
      '加載中',
      '沒有數據了'
    ]
  },
  YDQuestions: {
    ol: [
      '您是否遇到以下问题',
      '常见问题',
      '協助'
    ],
    title: [
      '我的資料安全嗎？',
      '我為什麼要付費才能使用VIP的套餐？',
      '我的權益能得到保障嗎？',
      '付費成功，卻沒有成功升級到VIP怎麼辦？'
    ],
    item: [
      '我们深知数据和隐私安全对您的重要性，我们已经充分考虑到了这点，作为用户和合作方之间的桥梁，我们的服务器不存储您的聊天数据，您所有的聊天记录只存在您的设备中，数据传输的过程采用https(ssl)加密传输协议；用户註冊过程只要求提供最低限度必要的资料，并且采取了严格的安全管理措施，任何人都无法获取您的数据。',
      '由於API是收費的，計費方式是按照Token數量（約等於聊天字數）計費，我們嚴格遵循API的規範，從正規付費通路對接官方的API服務，存在較大的運營成本，為了能够長期運營下去，無法提供完全的免費服務，希望盡我們所能，充分考慮用戶的承受能力和自身的成本風險， 讓大多數用戶以較低的費用享受到便捷高質的AI服務。',
      '在科技上，我們力求做到極致，盡可能與官網的體驗保持一致並加以創新。 流程上，我們確保每一個環節都是合法合規的，包括與合作方的合作對接、網站的備案、支付的流程，以及客服流程，嚴格遵循必要的規範和法律法規，確保提供長期有效的服務。',
      '支付前請您仔細查看VIP會員的權益，如果確定付費後沒有成功升級到相應的VIP級別，請您聯繫我們的客服人員幫助解決，下列管道都可以找到我們：關注公眾號、QQ、加微信群，或者直接電話聯系我們，客服人員會幫您解決遇到的問題。'
    ],
    btn: '返回'
  },
  YDHelpCenter: {
    menuBox: [
      '官方QQ',
      '郵箱號',
      '返回'
    ],
    document: {
      title: [
        '我的資料安全嗎？',
        '我為什麼要付費才能使用VIP的套餐？',
        '我的權益能得到保障嗎？',
        '付費成功，卻沒有成功升級到VIP怎麼辦？',
        '我以前是VIP，現在怎麼又變成免費套餐了？'
      ],
      item: [
        '我們深知數據和隱私安全對您的重要性，我們已經充分考慮到了這點，作為用戶和OpenAI之間的橋樑，我們的服務器不存儲您的聊天數據，您所有的聊天記錄只存在您的設備中，資料傳輸的過程采用https（ssl）加密傳輸協定； 用戶註冊過程只要求提供最低限度必要的資料，並且採取了嚴格的安全管理措施，任何人都無法獲取您的數據。',
        '由於API是收費的，計費方式是按照Token數量（約等於聊天字數）計費，我們嚴格遵循OpenAI的規範，從正規付費通路對接官方的API服務，存在較大的運營成本，為了能够長期運營下去，無法提供完全的免費服務，希望盡我們所能，充分考慮用戶的承受能力和自身的成本風險， 讓大多數用戶以較低的費用享受到便捷高質的AI服務。',
        '在科技上，我們力求做到極致，盡可能與官網的體驗保持一致並加以創新。 流程上，我們確保每一個環節都是合法合規的，包括與OpenAI的合作對接、網站的備案、支付的流程，以及客服流程，嚴格遵循必要的規範和法律法規，確保提供長期有效的服務。',
        '支付前請您仔細查看VIP會員的權益，如果確定付費後沒有成功升級到相應的VIP級別，請您聯繫我們的客服人員幫助解決，下列管道都可以找到我們：關注公眾號、QQ、加微信群，或者直接電話聯系我們，客服人員會幫您解決遇到的問題。',
        '出現這種情況，一般來說有兩種可能：第一種情况：您以前購買了包周或包月VIP，但是您的VIP過期了，需要續費。 第二種情况：您可能之前是用戶名密碼登入的，後來改用微信掃描登入，或者點擊了一鍵註冊登入，後面兩種情况都會自動註冊一個新用戶，需要切換到原來的帳號，如果您忘記了原來的帳號密碼，請聯系客服協助您找回。'
      ],
      btn: '返回'
    }
  },
  YDAboutUs: {
    h1: '關於我們',
    // pBox: [
    //   '自2022年伊始，我們便立志成為一家專業的軟件和互聯網產品提供商，我們始終堅持以創新為驅動，以客戶需求為導向，專注於C端軟件和互聯網產品的深度研發和高效運營。 我們的團隊由一群富有激情和專業知識的人組成，他們致力於提供最優質的服務，以滿足客戶的各種需求。',
    //   '我們的代表作品Anycell Report，這是一款國產知名的報表軟件，它的出現充分體現了我們在技術研發和產品創新方面的專業實力。 這款軟件的成功，不僅僅是我們科技實力的體現，更是我們對於市場需求敏銳洞察力和快速回應能力的最好證明。',
    //   '我們以卓越的專業水準，高效的運營能力，優質的服務水平和快速的發展速度，贏得了業內和廣大用戶的一致好評。 我們的成就並非偶然，而是源於我們對專業精神的堅守，對用戶需求的深度理解，以及對市場變化的敏銳把握。',
    //   '我們期待與您的合作，為您提供最優質的服務，共同開創更美好的未來。'
    // ],
    illustrate: {
      // h1: '關於我們',
      span: [
        '開創性人工智慧解決方案',
        '人工智慧客戶服務系統:',
        '辦公AI:',
        '全球影響力:',
        '您身邊的人工智慧解決方案'
      ],
      pBox: [
        'SUNTUBE LIMITED位於倫敦市中心，是人工智慧領域創新的燈塔。 該公司主要專注於人工智慧應用程序開發和諮詢，在全球市場上為自己開闢了一個利基市場.',
        'ChatAI:ChatAI是在ChatGPT的基礎上開發的，是一種最先進的對話式人工智慧，提供無縫互動，使其成為旨在增强客戶參與度的企業的最愛.',
        'SUNTUBE LIMITED深知高效、快速的客戶服務的重要性。 通過我們的人工智慧驅動的客戶服務解決方案，企業可以確保我們的客戶得到及時準確的響應，從而提升整體客戶體驗.',
        'SUNTUBE的AI for Office將人工智慧集成到日常辦公任務中，簡化了操作，提高了生產力，徹底改變了工作空間.',
        'SUNTUBE LIMITED服務於超過500萬的龐大用戶群，其影響力是真正的全球性。 我們對卓越的承諾和對創新的不懈追求使他們成為全球企業值得信賴的合作夥伴.',
        '加入SUNTUBE LIMITED的人工智慧革命，科技的未來滿足當今的需求.'
      ]
    },
    product: {
      h6: '聯繫我們',
      span: [
        '電話',
        '電子郵箱',
        '地址'
      ],
      // p: 'UNIT 1804 SOUTH BANK TOWER, 55 UPPER GROUND,LONDON，ENGLAND SE1 9EY',
      p: '英国伦敦上城55号南岸大厦1804室',
      em: '我們期待您的來信'
    }
    // h6: '聯繫我們',
    // column: {
    //   span: [
    //     '地址：',
    //     '電話：',
    //     '電子郵件：'
    //   ],
    //   p: '中國深圳市寶安區新安街道洪浪北二路稻興環球科創中心A座'
    // }
  },
  YDChatRoom: {
    top: [
      'AI增強以提供更佳回覆',
      '輸入問題或主題，GPT生成相關文本回應，以幫助解決問題或獲取信息。',
      '範例',
      '你可以這樣與AI對話:'

    ],
    initialRoom: [
      '兩步為本站創建桌面圖示，點這裡',
      '查看引導',
      '兩步創建桌面圖示或添加書簽，點這裡'
    ],
    myAsk: '重新編輯',
    aiAnswer: {
      limit: [
        '（點擊這裡升級服務）',
        '（點擊這裡邀請好友）',
        '（運營成本限制，回答字數受限，完整回答請點這裡',
        '升級服務'
      ],
      loading: '正在聊天',
      copy: '複製'
    },
    field: '在這裡輸入您的問題，開始和AI對話',
    scrollBox: [
      '置頂',
      '置底'
    ],
    collect: [
      '點擊瀏覽器下方分享按鈕',
      '找到瀏覽器的工具列或設定',
      '下一步',
      '下拉式功能表，添加到主荧幕',
      '點擊圖標，添加書簽或案頭',
      '機型不同，添加位置或有不同',
      '我知曉了'
    ],
    popup: '語音',
    dialogOne: {
      title: '聊天記錄截圖',
      p: '長按保存圖片'
    },
    model: [
      '今日可用',
      '次'
    ],
    dialogTwo: {
      title: '提示',
      p: '今日4.0次數已用盡，是否新建一個聊天室？'
    },
    announcer: [
      '聆小琬',
      '聆小瑤',
      '聆飛哲'
    ],
    toolList: [
      '聊天截圖',
      '語音切換',
      '在线客服'
    ],
    columns: ['聆小琬（女聲）', '聆小瑤（女聲）', '聆飛哲（男聲）'],
    chatRecord: [
      '當前服務器正忙',
      '，請您重新發送您的問題',
      '用戶次數已用盡，請升級當前的服務，我們會提供更優質的服務，或者邀請好友，新增免費提問次數.',
      '無法處理您的對話，可能是文字太長了，或者當前服務器正忙，建議减少提問字數或新建話題再試試.',
      '當前服務器正忙，請您重新發送您的問題.',
      '回答出現錯誤，請重新提問',
      '無法處理您的對話，建議减少提問字數重新提問.',
      '用戶chat-4.0次數不足.',
      '對不起，當前聊天人數較多，請稍後重試',
      '網絡好像有點問題',
      '請聯系客服，或切換網絡試試，例如關閉wifi，或連接別的wifi網絡',
      '聊天太頻繁，請稍候再試。'
    ],
    message: [
      '您的帳號在其他設備登入，請重新登入.',
      '用戶次數不足，請升級服務.',
      '用戶4.0次數不足.'
    ],
    download: '聊天記錄'
  },
  YDSelectModelChat: {
    label: '模型選擇',
    title: '提示',
    p: [
      '由於OpenAI對4.0現時仍然是限制使用，為了防止API被濫用，VIP用戶每天將限制請求對話',
      '次（永久vip',
      '次），該次數未來將隨OpenAI的政策和我司的運營決策進行調整或取消限制。'
    ],
    modelList: [
      { value: 'minimax', text: 'Chat-MM', name: 'Chat-MM', tip: 'Chat-MM是一款专为中国用户定制的全新产品，它主要专注于中文知识。这款产品具有全面的中文训练，能更深入地理解和生成中文内容。拥有丰富的中文知识库，理解中国文化和语言习惯，以此来更好地满足中文用户的沟通需求。' },
      { value: '3.5', text: 'GPT-3.5', name: 'GPT-3.5' },
      { value: '3.5-turbo', text: 'GPT-3.5-16k', name: 'GPT-3.5-16k' },
      { value: '4.0', text: 'GPT-4.0', name: 'GPT-4.0' }
    ],
    message: [
      '4.0暫時只對VIP用戶開放，現在去升級VIP？',
      '3.5-turbo暫時只對VIP用戶開放，現在去升級VIP？'
    ],
    notify: '今日4.0次數已用盡，暫時關閉新建4.0聊天室功能'
  },
  YDUpgradeService: {
    upgradeServiceBox: {
      top: {
        title: '專業版',
        p: '全球顶尖AI大语言模型为您提供服务'
      },
      product: {
        month: '每月',
        year: '每年',
        popular: '更受歡迎',
        permonth: '月',
        peryear: '年',
        subcribe: '訂閱',
        threeMon: '三個月'
      }
    },
    paySuccess: {
      h1: '購買成功！',
      productCard: {
        h1: '總計',
        li: [
          '次數限制：回復',
          '無限制',
          '字',
          '回復限制：',
          '無限次數',
          '次數'
        ]
      },
      btn: '現在去使用'
    },
    lifeMember: {
      h2: '您已經是終身會員，無需再升級服務',
      btn: '返回聊天室',
      noticeInterests: [
        '如果您有什麼疑問，請隨時',
        '聯繫我們',
        '權益須知'
      ]
    },
    popup: {
      header: [
        '支付金額',
        '訂閱專業版即可立即獲得全部功能許可權，包括更多GPT-4使用額度'
      ],
      ulBox: [
        '支付方式',
        'Stripe,信用卡（Visa、MasterCard、銀聯、JCB…）',
        'Paypal+客人信用卡付款',
        '僅支持人民幣支付',
        '已完成支付',
        '回到首頁'
      ],
      msgBox: '您要填寫支付資訊的UI由協力廠商支付平臺（strip或paypal）的官方插件提供支援，我們無法也不會收集您的信用卡或其他支付資訊。',
      btn: '下一個',
      form: '確認付款'
    },
    dialog: {
      title: '權益須知',
      confirmButtonText: '我已知曉',
      p: [
        '1.會員權益為虛擬服務，套餐開通成功後不可退換，敬請諒解。',
        '2.扣款成功即刻生效，若未即刻生效，請稍等幾分鐘或聯系客服獲取幫助。',
        '3.在高峰時期，由於AI需要大量計算資源，可能會出現服務波動，請諒解。',
        '4.VIP用戶可以無限次、不限字數地使用3.5版本，我們承諾保證這一權益的延續性，即使未來發生變化，也會以更優的版本或服務進行取代。',
        '5.由於4.0版本的资源限制，囙此VIP用戶每天將限制請求對話',
        '次（永久vip',
        '次），該次數未來將根據OpenAI的政策和我公司的運營決策進行調整或取消限制。',
        '6.為保護大多數用戶的權益，嚴厲禁止濫用我們的服務，包括利用我們的服務從事非法、違反公序良俗的活動，以程式操控、破解管道使用我們的服務。 一旦發現，我們將立即禁用帳號並不退還費用。 涉嫌違法犯罪行為的，同時將報警處理。',
        '7.在法律範圍內，我們公司對本產品享有最終解釋權，感謝您的理解。'
      ]
    },
    rightsIntereste: [
      '3.5无限制',
      '支持GPT 3.5和4.0',
      '優良的架構和低延遲'
    ],
    loading: '支付中…'
  }
}
